
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "act", () => $72b03fdf46effee2$export$3ba232387fd5d6dd, (v) => $72b03fdf46effee2$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$3ba232387fd5d6dd;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;

var $hPtJY = parcelRequire("hPtJY");
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray, $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$noop$1() {}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop$1, $72b03fdf46effee2$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $hPtJY && "function" === typeof $hPtJY.emit) {
        $hPtJY.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $72b03fdf46effee2$var$noop() {}
$72b03fdf46effee2$export$dca3b0875bd9a954 = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$3ba232387fd5d6dd = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, void 0, void 0, null, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;

var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
var $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $dca0ddb82b882518$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$0) {
                                control = x$0;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$1) {
                            control = x$1;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return fiber = $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1), fiber;
        case 11:
            return fiber = $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1), fiber;
        case 1:
            return fiber = $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0), fiber;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$2 = parentA.child; child$2;){
                if (child$2 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$2 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$2 = child$2.sibling;
            }
            if (!didFindChild) {
                for(child$2 = parentB.child; child$2;){
                    if (child$2 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$2 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$2 = child$2.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    fiber = nextRootInstance.nodeType;
    switch(fiber){
        case 9:
        case 11:
            nextRootInstance = (nextRootInstance = nextRootInstance.documentElement) ? (nextRootInstance = nextRootInstance.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance) : 0 : 0;
            break;
        default:
            if (fiber = 8 === fiber ? nextRootInstance.parentNode : nextRootInstance, nextRootInstance = fiber.tagName, fiber = fiber.namespaceURI) fiber = $dca0ddb82b882518$var$getOwnHostContext(fiber), nextRootInstance = $dca0ddb82b882518$var$getChildHostContextProd(fiber, nextRootInstance);
            else switch(nextRootInstance){
                case "svg":
                    nextRootInstance = 1;
                    break;
                case "math":
                    nextRootInstance = 2;
                    break;
                default:
                    nextRootInstance = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, nextRootInstance);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$onCommitRoot(root) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, root, void 0, 128 === (root.current.flags & 128));
    } catch (err) {}
}
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionLane = 128, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194176;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, warmLanes = root.warmLanes;
    root = 0 !== root.finishedLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = nonIdlePendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(warmLanes))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = pendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(warmLanes))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, warmLanes = wipLanes & -wipLanes, suspendedLanes >= warmLanes || 32 === suspendedLanes && 0 !== (warmLanes & 4194176)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
            return currentTime + 250;
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextTransitionLane() {
    var lane = $dca0ddb82b882518$var$nextTransitionLane;
    $dca0ddb82b882518$var$nextTransitionLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextTransitionLane & 4194176) && ($dca0ddb82b882518$var$nextTransitionLane = 128);
    return lane;
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194218;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node) {
    var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    node._valueTracker || (node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node));
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$283;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_418 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_418) {
            var $dca0ddb82b882518$var$element$jscomp$inline_419 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_419.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_418 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_419.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$283 = $dca0ddb82b882518$var$isSupported$jscomp$inline_418;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$283 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$283 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
function $dca0ddb82b882518$var$restoreSelection(priorSelectionInformation, containerInfo) {
    var curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(containerInfo);
    containerInfo = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== containerInfo && containerInfo && containerInfo.ownerDocument && $dca0ddb82b882518$var$containsNode(containerInfo.ownerDocument.documentElement, containerInfo)) {
        if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(containerInfo)) {
            if (priorSelectionInformation = priorSelectionRange.start, curFocusedElem = priorSelectionRange.end, void 0 === curFocusedElem && (curFocusedElem = priorSelectionInformation), "selectionStart" in containerInfo) containerInfo.selectionStart = priorSelectionInformation, containerInfo.selectionEnd = Math.min(curFocusedElem, containerInfo.value.length);
            else if (curFocusedElem = (priorSelectionInformation = containerInfo.ownerDocument || document) && priorSelectionInformation.defaultView || window, curFocusedElem.getSelection) {
                curFocusedElem = curFocusedElem.getSelection();
                var length = containerInfo.textContent.length, start = Math.min(priorSelectionRange.start, length);
                priorSelectionRange = void 0 === priorSelectionRange.end ? start : Math.min(priorSelectionRange.end, length);
                !curFocusedElem.extend && start > priorSelectionRange && (length = priorSelectionRange, priorSelectionRange = start, start = length);
                length = $dca0ddb82b882518$var$getNodeForCharacterOffset(containerInfo, start);
                var endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(containerInfo, priorSelectionRange);
                length && endMarker && (1 !== curFocusedElem.rangeCount || curFocusedElem.anchorNode !== length.node || curFocusedElem.anchorOffset !== length.offset || curFocusedElem.focusNode !== endMarker.node || curFocusedElem.focusOffset !== endMarker.offset) && (priorSelectionInformation = priorSelectionInformation.createRange(), priorSelectionInformation.setStart(length.node, length.offset), curFocusedElem.removeAllRanges(), start > priorSelectionRange ? (curFocusedElem.addRange(priorSelectionInformation), curFocusedElem.extend(endMarker.node, endMarker.offset)) : (priorSelectionInformation.setEnd(endMarker.node, endMarker.offset), curFocusedElem.addRange(priorSelectionInformation)));
            }
        }
        priorSelectionInformation = [];
        for(curFocusedElem = containerInfo; curFocusedElem = curFocusedElem.parentNode;)1 === curFocusedElem.nodeType && priorSelectionInformation.push({
            element: curFocusedElem,
            left: curFocusedElem.scrollLeft,
            top: curFocusedElem.scrollTop
        });
        "function" === typeof containerInfo.focus && containerInfo.focus();
        for(containerInfo = 0; containerInfo < priorSelectionInformation.length; containerInfo++)curFocusedElem = priorSelectionInformation[containerInfo], curFocusedElem.element.scrollLeft = curFocusedElem.left, curFocusedElem.element.scrollTop = curFocusedElem.top;
    }
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll scrollEnd toggle touchMove waiting wheel".split(" ");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    isHidden && null !== update && 3 === sourceFiber.tag && (parent = sourceFiber.stateNode, isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), parent = parent.hiddenUpdates, sourceFiber = parent[isHidden], null === sourceFiber ? parent[isHidden] = [
        update
    ] : sourceFiber.push(update), update.lane = lane | 536870912);
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {}, $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $dca0ddb82b882518$var$track(instance);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children), $dca0ddb82b882518$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 3:
        case 27:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        case 5:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var shouldClear = !1, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== fiber.tag && 27 !== fiber.tag) {
        if (JSCompiler_temp = 5 === fiber.tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && (shouldClear = !0);
    shouldClear && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === fiber.tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(shouldClear = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === shouldClear) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        shouldClear--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || shouldClear++;
                }
                fiber = fiber.nextSibling;
            }
            $dca0ddb82b882518$var$nextHydratableInstance = null;
        }
    } else $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$noop$3() {}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$3, $dca0ddb82b882518$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            if (thenableState === $dca0ddb82b882518$var$SuspenseException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$3, $dca0ddb82b882518$var$noop$3);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    thenableState = thenable.reason;
                    if (thenableState === $dca0ddb82b882518$var$SuspenseException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
                    throw thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 33554434, lastPlacedIndex) : newIndex;
        newFiber.flags |= 33554434;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 33554434);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = fiber);
        }
    } else $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || "$!" === state.data)) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber$1.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber$1.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber$1.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber$1.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber$1.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber$1.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
var $dca0ddb82b882518$var$createFunctionComponentUpdateQueue;
$dca0ddb82b882518$var$createFunctionComponentUpdateQueue = function() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
};
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber$1;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber$1.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber$1.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber$1.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$54 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber$1.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber$1.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$54 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber$1, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushEffect(9, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 60) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber$1.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber$1.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$60) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$60);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber$1;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    currentStateHook = "object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then ? $dca0ddb82b882518$var$useThenable(currentStateHook) : currentStateHook;
    var actionQueueHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), actionQueue = actionQueueHook.queue, dispatch = actionQueue.dispatch;
    action !== actionQueueHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber$1.flags |= 2048, $dca0ddb82b882518$var$pushEffect(9, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), {
        destroy: void 0
    }, null));
    return [
        currentStateHook,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushEffect(tag, create, inst, deps) {
    tag = {
        tag: tag,
        create: create,
        inst: inst,
        deps: deps,
        next: null
    };
    create = $dca0ddb82b882518$var$currentlyRenderingFiber$1.updateQueue;
    null === create && (create = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber$1.updateQueue = create);
    inst = create.lastEffect;
    null === inst ? create.lastEffect = tag.next = tag : (deps = inst.next, inst.next = tag, tag.next = deps, create.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber$1.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushEffect(1 | hookFlags, create, {
        destroy: void 0
    }, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushEffect(hookFlags, create, inst, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber$1.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushEffect(1 | hookFlags, create, inst, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber$1.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber$1.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop$2() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop$2 : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$63 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$63 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$63, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$63, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber$1 || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber$1;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194176)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError
};
$dca0ddb82b882518$var$ContextOnlyDispatcher.useCacheRefresh = $dca0ddb82b882518$var$throwInvalidHookError;
$dca0ddb82b882518$var$ContextOnlyDispatcher.useMemoCache = $dca0ddb82b882518$var$throwInvalidHookError;
$dca0ddb82b882518$var$ContextOnlyDispatcher.useHostTransitionStatus = $dca0ddb82b882518$var$throwInvalidHookError;
$dca0ddb82b882518$var$ContextOnlyDispatcher.useFormState = $dca0ddb82b882518$var$throwInvalidHookError;
$dca0ddb82b882518$var$ContextOnlyDispatcher.useActionState = $dca0ddb82b882518$var$throwInvalidHookError;
$dca0ddb82b882518$var$ContextOnlyDispatcher.useOptimistic = $dca0ddb82b882518$var$throwInvalidHookError;
var $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber$1, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 60) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushEffect(9, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = ":" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += ":";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = ":" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + ":";
        return hook.memoizedState = identifierPrefix;
    },
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1);
    }
};
$dca0ddb82b882518$var$HooksDispatcherOnMount.useMemoCache = $dca0ddb82b882518$var$useMemoCache;
$dca0ddb82b882518$var$HooksDispatcherOnMount.useHostTransitionStatus = $dca0ddb82b882518$var$useHostTransitionStatus;
$dca0ddb82b882518$var$HooksDispatcherOnMount.useFormState = $dca0ddb82b882518$var$mountActionState;
$dca0ddb82b882518$var$HooksDispatcherOnMount.useActionState = $dca0ddb82b882518$var$mountActionState;
$dca0ddb82b882518$var$HooksDispatcherOnMount.useOptimistic = function(passthrough) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    hook.memoizedState = hook.baseState = passthrough;
    var queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
    };
    hook.queue = queue;
    hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, !0, queue);
    queue.dispatch = hook;
    return [
        passthrough,
        hook
    ];
};
var $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId
};
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useCacheRefresh = $dca0ddb82b882518$var$updateRefresh;
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useMemoCache = $dca0ddb82b882518$var$useMemoCache;
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useHostTransitionStatus = $dca0ddb82b882518$var$useHostTransitionStatus;
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useFormState = $dca0ddb82b882518$var$updateActionState;
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useActionState = $dca0ddb82b882518$var$updateActionState;
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useOptimistic = function(passthrough, reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
};
var $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId
};
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useCacheRefresh = $dca0ddb82b882518$var$updateRefresh;
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useMemoCache = $dca0ddb82b882518$var$useMemoCache;
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useHostTransitionStatus = $dca0ddb82b882518$var$useHostTransitionStatus;
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useFormState = $dca0ddb82b882518$var$rerenderActionState;
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useActionState = $dca0ddb82b882518$var$rerenderActionState;
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useOptimistic = function(passthrough, reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    hook.baseState = passthrough;
    return [
        passthrough,
        hook.queue.dispatch
    ];
};
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    isMounted: function(component) {
        return (component = component._reactInternals) ? $dca0ddb82b882518$var$getNearestMountedFiber(component) === component : !1;
    },
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$67 in Component)void 0 === newProps[propName$67] && (newProps[propName$67] = Component[propName$67]);
    }
    return newProps;
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $hPtJY && "function" === typeof $hPtJY.emit) {
        $hPtJY.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$68) {
        setTimeout(function() {
            throw e$68;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$69) {
        setTimeout(function() {
            throw e$69;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, nextIsDetached = 0 !== (workInProgress.stateNode._pendingVisibility & 2), prevState = null !== current ? current.memoizedState : null;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    if ("hidden" === nextProps.mode || nextIsDetached) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(nextIsDetached = 0; null !== nextChildren;)nextIsDetached = nextIsDetached | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = nextIsDetached & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 2097664);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 2097664;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($dca0ddb82b882518$var$isHydrating) {
                var nextInstance = $dca0ddb82b882518$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                            id: $dca0ddb82b882518$var$treeContextId,
                            overflow: $dca0ddb82b882518$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912
                    }, JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return "$!" === nextInstance.data ? workInProgress.lanes = 16 : workInProgress.lanes = 536870912, null;
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, nextProps;
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), "$!" === nextInstance.data) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp) {
                nextProps = renderLanes & -renderLanes;
                if (0 !== (nextProps & 42)) nextProps = 1;
                else switch(nextProps){
                    case 2:
                        nextProps = 1;
                        break;
                    case 8:
                        nextProps = 4;
                        break;
                    case 32:
                        nextProps = 16;
                        break;
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                        nextProps = 64;
                        break;
                    case 268435456:
                        nextProps = 134217728;
                        break;
                    default:
                        nextProps = 0;
                }
                nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps;
                if (0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            }
            "$?" === nextInstance.data || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 128, workInProgress.child = current.child, workInProgress = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, current), nextInstance._reactRetry = workInProgress, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextInstance.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && ($dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId, $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow, $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider, $dca0ddb82b882518$var$treeContextId = current.id, $dca0ddb82b882518$var$treeContextOverflow = current.overflow, $dca0ddb82b882518$var$treeContextProvider = workInProgress), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 31457280, null !== digest ? showFallback = $dca0ddb82b882518$var$createWorkInProgress(digest, showFallback) : (showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $dca0ddb82b882518$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, nextProps;
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    return $dca0ddb82b882518$var$createFiberFromOffscreen(offscreenProps, mode, 0, null);
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $dca0ddb82b882518$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $dca0ddb82b882518$var$shouldConstruct(lazyComponent) ? (current = $dca0ddb82b882518$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $dca0ddb82b882518$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                var nextProps = workInProgress.pendingProps;
                init = workInProgress.memoizedState;
                lazyComponent = init.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                nextProps = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, nextProps);
                nextProps !== init.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                nextProps = nextState.element;
                if (init.isDehydrated) {
                    if (init = {
                        element: nextProps,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = init, workInProgress.memoizedState = init, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else if (nextProps !== lazyComponent) {
                        lazyComponent = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError(lazyComponent);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else for($dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(workInProgress.stateNode.containerInfo.firstChild), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !0, renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextProps, renderLanes), workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (nextProps === lazyComponent) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, lazyComponent[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(lazyComponent, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (lazyComponent = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(lazyComponent.firstChild)), lazyComponent = workInProgress.pendingProps.children, null !== current || $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes) : workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (init = lazyComponent = $dca0ddb82b882518$var$nextHydratableInstance) lazyComponent = $dca0ddb82b882518$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(lazyComponent.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            nextProps = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = nextProps.children;
            $dca0ddb82b882518$var$shouldSetTextContent(init, nextProps) ? lazyComponent = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = init);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), init = $dca0ddb82b882518$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), lazyComponent = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? (init = $dca0ddb82b882518$var$peekCacheFromPool(), null === init && (init = $dca0ddb82b882518$var$workInProgressRoot, nextProps = $dca0ddb82b882518$var$createCache(), init.pooledCache = nextProps, nextProps.refCount++, null !== nextProps && (init.pooledCacheLanes |= renderLanes), init = nextProps), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, nextProps = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, lazyComponent)) : (lazyComponent = nextProps.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194176))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0;
                        try {
                            destroy();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            var instance = current.stateNode;
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = instance;
                    break;
                default:
                    instanceToUse = instance;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$112) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$112);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 27 !== fiber.tag && 18 !== fiber.tag;){
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? 8 === parent.nodeType ? parent.parentNode.insertBefore(node, before) : parent.insertBefore(node, before) : (8 === parent.nodeType ? (before = parent.parentNode, before.insertBefore(node, parent)) : (before = parent, before.appendChild(node)), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null, $dca0ddb82b882518$var$shouldFireAfterActiveInstanceBlur = !1;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
    resolvedPrevProps = $dca0ddb82b882518$var$shouldFireAfterActiveInstanceBlur;
    $dca0ddb82b882518$var$shouldFireAfterActiveInstanceBlur = !1;
    return resolvedPrevProps;
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$111) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$111);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (flags = finishedWork.updateQueue, null !== flags)) {
                finishedRoot = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        finishedRoot = finishedWork.child.stateNode;
                        break;
                    case 1:
                        finishedRoot = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(flags, finishedRoot);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 26:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 22:
            prevProps = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!prevProps) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                var prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            flags & 512 && ("manual" === finishedWork.memoizedProps.mode ? $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return) : $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber = deletedFiber.stateNode;
            for(nearestMountedAncestor = deletedFiber.attributes; nearestMountedAncestor.length;)deletedFiber.removeAttributeNode(nearestMountedAncestor[0]);
            $dca0ddb82b882518$var$detachDeletedInstance(deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParent;
            var prevHostParentIsContainer$119 = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParentIsContainer;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer$119;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    finishedRoot = $dca0ddb82b882518$var$hostParent, prevHostParent = deletedFiber.stateNode, 8 === finishedRoot.nodeType ? finishedRoot.parentNode.removeChild(prevHostParent) : finishedRoot.removeChild(prevHostParent);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (nearestMountedAncestor = $dca0ddb82b882518$var$hostParent, deletedFiber = deletedFiber.stateNode, 8 === nearestMountedAncestor.nodeType ? $dca0ddb82b882518$var$clearSuspenseBoundary(nearestMountedAncestor.parentNode, deletedFiber) : 1 === nearestMountedAncestor.nodeType && $dca0ddb82b882518$var$clearSuspenseBoundary(nearestMountedAncestor, deletedFiber), $dca0ddb82b882518$var$retryIfBlockedOn(nearestMountedAncestor)) : $dca0ddb82b882518$var$clearSuspenseBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            if (flags & 4 && null === finishedWork.alternate) {
                hoistableRoot = finishedWork.stateNode;
                currentResource = finishedWork.memoizedProps;
                try {
                    for(var node = hoistableRoot.firstChild; node;){
                        var nextNode = node.nextSibling, nodeName = node.nodeName;
                        node[$dca0ddb82b882518$var$internalHoistableMarker] || "HEAD" === nodeName || "BODY" === nodeName || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node.rel.toLowerCase() || hoistableRoot.removeChild(node);
                        node = nextNode;
                    }
                    for(var type = finishedWork.type, attributes = hoistableRoot.attributes; attributes.length;)hoistableRoot.removeAttributeNode(attributes[0]);
                    $dca0ddb82b882518$var$setInitialProperties(hoistableRoot, type, currentResource);
                    hoistableRoot[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                    hoistableRoot[$dca0ddb82b882518$var$internalPropsKey] = currentResource;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            node = null !== finishedWork.memoizedState;
            nextNode = null !== current && null !== current.memoizedState;
            nodeName = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            type = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = nodeName || node;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = type || nextNode;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = type;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = nodeName;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            root = finishedWork.stateNode;
            root._current = finishedWork;
            root._visibility &= -3;
            root._visibility |= root._pendingVisibility & 2;
            if (flags & 8192 && (root._visibility = node ? root._visibility & -2 : root._visibility | 1, node && (root = $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden, null === current || nextNode || root || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), null === finishedWork.memoizedProps || "manual" !== finishedWork.memoizedProps.mode)) a: for(current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag || 27 === root.tag) {
                    if (null === current) {
                        nextNode = current = root;
                        try {
                            if (hoistableRoot = nextNode.stateNode, node) currentResource = hoistableRoot.style, "function" === typeof currentResource.setProperty ? currentResource.setProperty("display", "none", "important") : currentResource.display = "none";
                            else {
                                maybeNodes = nextNode.stateNode;
                                i = nextNode.memoizedProps.style;
                                var display = void 0 !== i && null !== i && i.hasOwnProperty("display") ? i.display : null;
                                maybeNodes.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        nextNode = root;
                        try {
                            nextNode.stateNode.nodeValue = node ? "" : nextNode.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            if (27 !== finishedWork.tag) {
                a: {
                    for(var parent = finishedWork.return; null !== parent;){
                        if ($dca0ddb82b882518$var$isHostParent(parent)) {
                            var JSCompiler_inline_result = parent;
                            break a;
                        }
                        parent = parent.return;
                    }
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
                }
                switch(JSCompiler_inline_result.tag){
                    case 27:
                        var parent$jscomp$0 = JSCompiler_inline_result.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                        $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0);
                        break;
                    case 5:
                        var parent$113 = JSCompiler_inline_result.stateNode;
                        JSCompiler_inline_result.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$113, ""), JSCompiler_inline_result.flags &= -33);
                        var before$114 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                        $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$114, parent$113);
                        break;
                    case 3:
                    case 4:
                        var parent$115 = JSCompiler_inline_result.stateNode.containerInfo, before$116 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                        $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$116, parent$115);
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
                }
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 26:
            case 27:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 26:
            case 27:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 4 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 4 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 4, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 4 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 4, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource($dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 4 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -5, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 4 && (i._visibility &= -5, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 31457280;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 31457282;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_OFFSCREEN_TYPE:
            return $dca0ddb82b882518$var$createFiberFromOffscreen(pendingProps, mode, lanes, key);
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_PROVIDER_TYPE:
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromOffscreen(pendingProps, mode, lanes, key) {
    pendingProps = $dca0ddb82b882518$var$createFiberImplClass(22, pendingProps, key, mode);
    pendingProps.elementType = $dca0ddb82b882518$var$REACT_OFFSCREEN_TYPE;
    pendingProps.lanes = lanes;
    var primaryChildInstance = {
        _visibility: 1,
        _pendingVisibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null,
        _current: null,
        detach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(456));
            if (0 === (primaryChildInstance._pendingVisibility & 2)) {
                var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility |= 2, $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        },
        attach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(456));
            if (0 !== (primaryChildInstance._pendingVisibility & 2)) {
                var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility &= -3, $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        }
    };
    pendingProps.stateNode = primaryChildInstance;
    return pendingProps;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        resource = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194176) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null !== $dca0ddb82b882518$var$shellBoundary : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || resource !== $dca0ddb82b882518$var$shellBoundary)) throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$131 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$131 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$131 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$131.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags & 31457280, subtreeFlags |= child$132.flags & 31457280, child$132.return = completedWork, child$132 = child$132.sibling;
    else for(child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags, subtreeFlags |= child$132.flags, child$132.return = completedWork, child$132 = child$132.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, null !== $dca0ddb82b882518$var$hydrationErrors && ($dca0ddb82b882518$var$queueRecoverableErrors($dca0ddb82b882518$var$hydrationErrors), $dca0ddb82b882518$var$hydrationErrors = null));
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== renderLanes ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else null !== $dca0ddb82b882518$var$hydrationErrors && ($dca0ddb82b882518$var$queueRecoverableErrors($dca0ddb82b882518$var$hydrationErrors), $dca0ddb82b882518$var$hydrationErrors = null), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$144 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$144 = newProps.memoizedState.cachePool.pool);
                cache$144 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$144 = type.rendering;
            if (null === cache$144) {
                if (newProps) $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$144 = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== cache$144) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1);
                            current = cache$144.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(cache$144), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$144.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - type.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$144.sibling = workInProgress.child, workInProgress.child = cache$144) : (current = type.last, null !== current ? current.sibling = cache$144 : workInProgress.child = cache$144, type.last = cache$144);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $dca0ddb82b882518$var$now(), workInProgress.sibling = null, current = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$rootDoesHavePassiveEffects = !1, $dca0ddb82b882518$var$rootWithPendingPassiveEffects = null, $dca0ddb82b882518$var$pendingPassiveEffectsLanes = 0, $dca0ddb82b882518$var$pendingPassiveEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes) return $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes;
    if (null !== $dca0ddb82b882518$var$ReactSharedInternals.T) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $dca0ddb82b882518$var$requestTransitionLane();
    }
    return $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    0 === $dca0ddb82b882518$var$workInProgressDeferredLane && ($dca0ddb82b882518$var$workInProgressDeferredLane = 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && 2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 60) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else if (6 === exitStatus) $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
        else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && $dca0ddb82b882518$var$queueRecoverableErrors(renderWasConcurrent);
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                switch(exitStatus){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194176) === lanes) {
                            $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                            break a;
                        }
                        break;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                shouldTimeSlice.finishedWork = forceSync;
                shouldTimeSlice.finishedLanes = lanes;
                if ((lanes & 62914560) === lanes && (renderWasConcurrent = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < renderWasConcurrent)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0)) break a;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, 2, -0, 0), renderWasConcurrent);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$queueRecoverableErrors(errors) {
    null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = errors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, errors);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var subtreeFlags = finishedWork.subtreeFlags;
    if (subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if ($dca0ddb82b882518$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $dca0ddb82b882518$var$noop
        }, $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork), finishedWork = $dca0ddb82b882518$var$waitForCommitToBeReady(), null !== finishedWork) {
            root.cancelPendingCommit = finishedWork($dca0ddb82b882518$var$commitRoot.bind(null, root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, 1, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    root.finishedWork = null;
    root.finishedLanes = 0;
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194176) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$164) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$164);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 === $dca0ddb82b882518$var$workInProgressSuspendedReason && $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : 1) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrent();
        break;
    } catch (thrownValue$166) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$166);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrent() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousUpdateLanePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$ReactSharedInternals.T = null, $dca0ddb82b882518$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, previousUpdateLanePriority, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
    } finally{
        $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousUpdateLanePriority;
    }
}
function $dca0ddb82b882518$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, renderPriorityLevel, spawnedLane, updatedLanes, suspendedRetryLanes) {
    do $dca0ddb82b882518$var$flushPassiveEffects();
    while (null !== $dca0ddb82b882518$var$rootWithPendingPassiveEffects);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var finishedWork = root.finishedWork;
    didIncludeRenderPhaseUpdate = root.finishedLanes;
    if (null === finishedWork) return null;
    root.finishedWork = null;
    root.finishedLanes = 0;
    if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
    root.callbackNode = null;
    root.callbackPriority = 0;
    root.cancelPendingCommit = null;
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    remainingLanes |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
    $dca0ddb82b882518$var$markRootFinished(root, didIncludeRenderPhaseUpdate, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
    0 === (finishedWork.subtreeFlags & 10256) && 0 === (finishedWork.flags & 10256) || $dca0ddb82b882518$var$rootDoesHavePassiveEffects || ($dca0ddb82b882518$var$rootDoesHavePassiveEffects = !0, $dca0ddb82b882518$var$pendingPassiveEffectsRemainingLanes = remainingLanes, $dca0ddb82b882518$var$pendingPassiveTransitions = transitions, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
        $dca0ddb82b882518$var$flushPassiveEffects(!0);
        return null;
    }));
    transitions = 0 !== (finishedWork.flags & 15990);
    0 !== (finishedWork.subtreeFlags & 15990) || transitions ? (transitions = $dca0ddb82b882518$var$ReactSharedInternals.T, $dca0ddb82b882518$var$ReactSharedInternals.T = null, spawnedLane = $dca0ddb82b882518$var$ReactDOMSharedInternals.p, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, updatedLanes = $dca0ddb82b882518$var$executionContext, $dca0ddb82b882518$var$executionContext |= 4, $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root), $dca0ddb82b882518$var$restoreSelection($dca0ddb82b882518$var$selectionInformation, root.containerInfo), $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled, $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null, root.current = finishedWork, $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork), $dca0ddb82b882518$var$requestPaint(), $dca0ddb82b882518$var$executionContext = updatedLanes, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = spawnedLane, $dca0ddb82b882518$var$ReactSharedInternals.T = transitions) : root.current = finishedWork;
    $dca0ddb82b882518$var$rootDoesHavePassiveEffects ? ($dca0ddb82b882518$var$rootDoesHavePassiveEffects = !1, $dca0ddb82b882518$var$rootWithPendingPassiveEffects = root, $dca0ddb82b882518$var$pendingPassiveEffectsLanes = didIncludeRenderPhaseUpdate) : $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    remainingLanes = root.pendingLanes;
    0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
    $dca0ddb82b882518$var$onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
    if (null !== recoverableErrors) for(renderPriorityLevel = root.onRecoverableError, finishedWork = 0; finishedWork < recoverableErrors.length; finishedWork++)remainingLanes = recoverableErrors[finishedWork], renderPriorityLevel(remainingLanes.value, {
        componentStack: remainingLanes.stack
    });
    0 !== ($dca0ddb82b882518$var$pendingPassiveEffectsLanes & 3) && $dca0ddb82b882518$var$flushPassiveEffects();
    remainingLanes = root.pendingLanes;
    0 !== (didIncludeRenderPhaseUpdate & 4194218) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
    $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    return null;
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (null !== $dca0ddb82b882518$var$rootWithPendingPassiveEffects) {
        var root$170 = $dca0ddb82b882518$var$rootWithPendingPassiveEffects, remainingLanes = $dca0ddb82b882518$var$pendingPassiveEffectsRemainingLanes;
        $dca0ddb82b882518$var$pendingPassiveEffectsRemainingLanes = 0;
        var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingPassiveEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
        try {
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            if (null === $dca0ddb82b882518$var$rootWithPendingPassiveEffects) var JSCompiler_inline_result = !1;
            else {
                renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
                $dca0ddb82b882518$var$pendingPassiveTransitions = null;
                var root = $dca0ddb82b882518$var$rootWithPendingPassiveEffects, lanes = $dca0ddb82b882518$var$pendingPassiveEffectsLanes;
                $dca0ddb82b882518$var$rootWithPendingPassiveEffects = null;
                $dca0ddb82b882518$var$pendingPassiveEffectsLanes = 0;
                if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
                var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
                $dca0ddb82b882518$var$executionContext |= 4;
                $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root.current);
                $dca0ddb82b882518$var$commitPassiveMountOnFiber(root, root.current, lanes, renderPriority);
                $dca0ddb82b882518$var$executionContext = prevExecutionContext;
                $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
                if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
                    $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root);
                } catch (err) {}
                JSCompiler_inline_result = !0;
            }
            return JSCompiler_inline_result;
        } finally{
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root$170, remainingLanes);
        }
    }
    return !1;
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateTask($dca0ddb82b882518$var$processRootScheduleInMicrotask));
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$172 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$172;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$172.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$172.suspendedLanes, pingedLanes = root$172.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326677 ? JSCompiler_inline_result & 201326677 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$172, root$172 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$172, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                }
                root$172 = root$172.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane), $dca0ddb82b882518$var$currentEventTransitionLane = 0);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && 2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPassiveEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPassiveEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateTask(cb) {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, cb) : cb();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    0 === $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = $dca0ddb82b882518$var$claimNextTransitionLane());
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1439 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1439 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1439++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1440 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1439], $dca0ddb82b882518$var$domEventName$jscomp$inline_1441 = $dca0ddb82b882518$var$eventName$jscomp$inline_1440.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1442 = $dca0ddb82b882518$var$eventName$jscomp$inline_1440[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1440.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1441, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1442);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer || 8 === container.nodeType && container.parentNode === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if (3 === grandTag || 4 === grandTag) {
                    if (grandTag = nodeTag.stateNode.containerInfo, grandTag === targetContainer || 8 === grandTag.nodeType && grandTag.parentNode === targetContainer) return;
                }
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $dca0ddb82b882518$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $dca0ddb82b882518$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $dca0ddb82b882518$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $dca0ddb82b882518$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $dca0ddb82b882518$var$getParent(inCapturePhase);
                                reactEventName = $dca0ddb82b882518$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        targetFiber = targetFiber.return;
    }
    return listeners;
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$noop$1() {}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$186 = props[hasSrc];
                if (null != propValue$186) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$186;
                        break;
                    case "type":
                        propValue = propValue$186;
                        break;
                    case "checked":
                        checked = propValue$186;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$186;
                        break;
                    case "value":
                        propKey = propValue$186;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$186;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$186) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$186, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $dca0ddb82b882518$var$track(domElement);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $dca0ddb82b882518$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$186 in props)props.hasOwnProperty(propValue$186) && (hasSrc = props[propValue$186], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$186, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$203 in nextProps){
                var propKey = nextProps[propKey$203];
                lastProp = lastProps[propKey$203];
                if (nextProps.hasOwnProperty(propKey$203) && (null != propKey || null != lastProp)) switch(propKey$203){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$203, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$203 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$203 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$203 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$203, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$203 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$203 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$203, propKey);
            return;
        case "option":
            for(var propKey$219 in lastProps)if (propKey$203 = lastProps[propKey$219], lastProps.hasOwnProperty(propKey$219) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$219)) switch(propKey$219){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$219, null, nextProps, propKey$203);
            }
            for(lastDefaultValue in nextProps)if (propKey$203 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$203 && "function" !== typeof propKey$203 && "symbol" !== typeof propKey$203;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$203, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$224 in lastProps)propKey$203 = lastProps[propKey$224], lastProps.hasOwnProperty(propKey$224) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$224) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$224, null, nextProps, propKey$203);
            for(checked in nextProps)if (propKey$203 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$203) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$203, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$229 in lastProps)propKey$203 = lastProps[propKey$229], lastProps.hasOwnProperty(propKey$229) && void 0 !== propKey$203 && !nextProps.hasOwnProperty(propKey$229) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$229, void 0, nextProps, propKey$203);
                for(defaultChecked in nextProps)propKey$203 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$203 === propKey || void 0 === propKey$203 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$203, nextProps, propKey);
                return;
            }
    }
    for(var propKey$234 in lastProps)propKey$203 = lastProps[propKey$234], lastProps.hasOwnProperty(propKey$234) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$234) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$234, null, nextProps, propKey$203);
    for(lastProp in nextProps)propKey$203 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$203 === propKey || null == propKey$203 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$203, nextProps, propKey);
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" !== node && "$?" !== node && "$!" !== node || depth++;
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(suspenseInstance);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
function $dca0ddb82b882518$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$242 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$243 = styles$242.get(type);
                resource$243 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$243 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$242.set(type, resource$243), (styles$242 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$242._p && (resource$243.instance = styles$242, resource$243.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$242 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$243.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$243;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$248 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$248) return resource.state.loading |= 4, resource.instance = instance$248, $dca0ddb82b882518$var$markNodeAsHoistable(instance$248), instance$248;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$248 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$248);
            var linkInstance = instance$248;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$248, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$248, props.precedence, hoistableRoot);
            return resource.instance = instance$248;
        case "script":
            instance$248 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$248))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$248)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $dca0ddb82b882518$var$suspendedState = null;
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $dca0ddb82b882518$var$suspendedState) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(475));
    var state = $dca0ddb82b882518$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $dca0ddb82b882518$var$waitForCommitToBeReady() {
    if (null === $dca0ddb82b882518$var$suspendedState) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(475));
    var state = $dca0ddb82b882518$var$suspendedState;
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.finishedLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $dca0ddb82b882518$var$requestUpdateLane(), root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        0 === root.tag && $dca0ddb82b882518$var$flushPassiveEffects();
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1686 = $acw62.version;
if ("19.0.0" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1686) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1686, "19.0.0"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2165 = {
    bundleType: 0,
    version: "19.0.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    findFiberByHostInstance: $dca0ddb82b882518$var$getClosestInstanceFromNode,
    reconcilerVersion: "19.0.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2166 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2166.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2166.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2166.inject($dca0ddb82b882518$var$internals$jscomp$inline_2165), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2166;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(8 === container.nodeType ? container.parentNode : container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    initialChildren.current.lanes = isStrictMode;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, isStrictMode);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $11c56e2ffb2d6006$export$8352ce38b91d0c62, (v) => $11c56e2ffb2d6006$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $11c56e2ffb2d6006$export$839f9183b0465a69, (v) => $11c56e2ffb2d6006$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $11c56e2ffb2d6006$export$4b844e58a3e414b4, (v) => $11c56e2ffb2d6006$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$8352ce38b91d0c62;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$839f9183b0465a69;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$4b844e58a3e414b4;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$requestHostCallback();
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostCallback() {
    $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
}
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$8352ce38b91d0c62 = function() {
    $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$requestHostCallback());
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$839f9183b0465a69 = function() {
    return $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$4b844e58a3e414b4 = function() {};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$requestHostCallback()));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});

parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.0.0";

});



var $93aa5168b4bbf7a2$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"1LzKV\",\"index.6e9d3d53.js\",\"f53SX\",\"water.ee4f3e46.svg\",\"8koGT\",\"index.e0edb1d0.css\"]"));

const $37fb57f92a46a76e$var$STORAGE_KEY = 'storage';
class $37fb57f92a46a76e$export$bf2a15d34f3c441c {
    static{
        this.data = {};
    }
    static{
        this.isLoaded = false;
    }
    static load() {
        if (this.isLoaded) return;
        try {
            const data = localStorage.getItem($37fb57f92a46a76e$var$STORAGE_KEY);
            if (data) this.data = JSON.parse(data);
        } catch (e) {
            console.error('Failed to load storage data:', e);
        }
        this.isLoaded = true;
        setInterval(()=>{
            this.save();
        }, 1000);
    }
    static clear() {
        this.data = {};
        this.save();
    }
    static save() {
        try {
            localStorage.setItem($37fb57f92a46a76e$var$STORAGE_KEY, JSON.stringify(this.data));
        } catch (e) {
            console.error('Failed to save storage data:', e);
        }
    }
    static set(key, value) {
        this.data[key] = value;
    }
    static get(key, fallback = null) {
        this.load();
        return this.data[key] ?? fallback;
    }
}


const $3a56dcb81cc6e4dc$var$TARGET_PIXELS = 10000;
let $3a56dcb81cc6e4dc$var$savedPixelSize = (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).get('pixelSize', null);
if ($3a56dcb81cc6e4dc$var$savedPixelSize === null) {
    const screenArea = window.innerWidth * window.innerHeight;
    const pixelSize = Math.sqrt(screenArea / $3a56dcb81cc6e4dc$var$TARGET_PIXELS);
    $3a56dcb81cc6e4dc$var$savedPixelSize = Math.max(1, Math.min(20, Math.round(pixelSize)));
}
const $3a56dcb81cc6e4dc$export$1630b5343357e8b5 = {
    pixelSize: $3a56dcb81cc6e4dc$var$savedPixelSize,
    movementSmoothness: 1 / 60,
    colorVariation: 0.4
};


var $25746eb61037a613$export$873e90337ab80c46 = /*#__PURE__*/ function(EPointType) {
    EPointType["Smoke"] = "smoke";
    EPointType["Water"] = "water";
    EPointType["Border"] = "border";
    EPointType["Sand"] = "sand";
    EPointType["StaticSand"] = "staticSand";
    EPointType["Stone"] = "stone";
    EPointType["StaticStone"] = "staticStone";
    EPointType["Lava"] = "lava";
    EPointType["Fire"] = "fire";
    EPointType["Oil"] = "oil";
    EPointType["BurningOil"] = "burningOil";
    EPointType["IceFire"] = "iceFire";
    EPointType["Bomb"] = "bomb";
    EPointType["Ice"] = "ice";
    EPointType["Steam"] = "steam";
    EPointType["Void"] = "void";
    EPointType["Clone"] = "clone";
    EPointType["Gas"] = "gas";
    EPointType["FireEmitter"] = "fireEmitter";
    EPointType["Wood"] = "wood";
    EPointType["BurningWood"] = "burningWood";
    EPointType["Dynamite"] = "dynamite";
    EPointType["LiquidGas"] = "liquidGas";
    EPointType["Metal"] = "metal";
    EPointType["MoltenMetal"] = "moltenMetal";
    EPointType["Electricity_Ground"] = "electricityGround";
    EPointType["Electricity_Spark"] = "electricitySpark";
    EPointType["Electricity_Source"] = "electricitySource";
    EPointType["Electricity_Amplifier"] = "electricityAmplifier";
    EPointType["Heater"] = "heater";
    EPointType["Cooler"] = "cooler";
    EPointType["Virus"] = "virus";
    EPointType["Heal"] = "heal";
    EPointType["Acid"] = "acid";
    EPointType["Plant"] = "plant";
    EPointType["PlantSeed"] = "plantSeed";
    EPointType["Glass"] = "glass";
    EPointType["LiquidGlass"] = "liquidGlass";
    EPointType["ConstantCold"] = "constantCold";
    EPointType["ConstantHot"] = "constantHot";
    EPointType["ColdDetector"] = "coldDetector";
    EPointType["HotDetector"] = "hotDetector";
    EPointType["LiquidDetector"] = "liquidDetector";
    EPointType["Wire"] = "wire";
    EPointType["Pipe"] = "pipe";
    EPointType["Snow"] = "snow";
    EPointType["Magnet"] = "magnet";
    EPointType["WindSource"] = "windSource";
    EPointType["Ant"] = "ant";
    EPointType["FireAnt"] = "fireAnt";
    EPointType["IceAnt"] = "iceAnt";
    EPointType["Worm"] = "worm";
    EPointType["LightSource"] = "lightSource";
    EPointType["Mirror"] = "mirror";
    EPointType["LightDetector"] = "lightDetector";
    EPointType["LightBulb"] = "lightBulb";
    EPointType["Thermometer"] = "thermometer";
    return EPointType;
}({});


const $a1b3895d2b1f2262$export$15a7dd6201a8849f = {
    [(0, $25746eb61037a613$export$873e90337ab80c46).Sand]: 0.01,
    [(0, $25746eb61037a613$export$873e90337ab80c46).StaticSand]: 0,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Stone]: 0,
    [(0, $25746eb61037a613$export$873e90337ab80c46).StaticStone]: 0,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Void]: 0,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Clone]: 0,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Wood]: 0,
    [(0, $25746eb61037a613$export$873e90337ab80c46).BurningWood]: 0,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Glass]: 0,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Fire]: 4,
    [(0, $25746eb61037a613$export$873e90337ab80c46).IceFire]: 4,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Steam]: 10,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Gas]: 10,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Spark]: 10,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Smoke]: 5,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Ant]: 1,
    [(0, $25746eb61037a613$export$873e90337ab80c46).FireAnt]: 1,
    [(0, $25746eb61037a613$export$873e90337ab80c46).IceAnt]: 1,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Worm]: 1
};



const $62f2f2603999608f$export$5d2a1c3aa5eff4b5 = {
    [(0, $25746eb61037a613$export$873e90337ab80c46).Metal]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Ground]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Heater]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Cooler]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).ColdDetector]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).HotDetector]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidDetector]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).LightDetector]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).LightBulb]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Amplifier]: true
};



const $b0107f5265abe006$export$5551a2d24ff40153 = (point)=>{
    const colorGetter = $b0107f5265abe006$var$POINTS_COLORS[point.type];
    if (typeof colorGetter === 'function') return colorGetter(point);
    return colorGetter;
};
const $b0107f5265abe006$var$POINTS_COLORS = {
    [(0, $25746eb61037a613$export$873e90337ab80c46).Water]: {
        r: 0,
        g: 0,
        b: 255
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Sand]: {
        r: 255,
        g: 204,
        b: 0
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).StaticSand]: {
        r: 230,
        g: 184,
        b: 0
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Border]: {
        r: 211,
        g: 211,
        b: 211
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Stone]: {
        r: 128,
        g: 128,
        b: 128
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).StaticStone]: {
        r: 100,
        g: 100,
        b: 100
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Fire]: {
        r: 255,
        g: 0,
        b: 0
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).FireEmitter]: {
        r: 255,
        g: 0,
        b: 0
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).IceFire]: {
        r: 173,
        g: 216,
        b: 230
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Bomb]: {
        r: 0,
        g: 0,
        b: 0
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Ice]: {
        r: 173,
        g: 216,
        b: 230
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Steam]: {
        r: 211,
        g: 211,
        b: 211
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Clone]: {
        r: 0,
        g: 128,
        b: 0
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Gas]: {
        r: 211,
        g: 211,
        b: 211
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Lava]: {
        r: 255,
        g: 0,
        b: 0
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Wood]: {
        r: 139,
        g: 69,
        b: 19
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).BurningWood]: {
        r: 255,
        g: 0,
        b: 0
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Dynamite]: {
        r: 255,
        g: 68,
        b: 68
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidGas]: {
        r: 0,
        g: 204,
        b: 255
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Metal]: {
        r: 192,
        g: 192,
        b: 192
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).MoltenMetal]: {
        r: 255,
        g: 51,
        b: 51
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Glass]: {
        r: 230,
        g: 230,
        b: 250
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidGlass]: {
        r: 255,
        g: 50,
        b: 0
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Ground]: {
        r: 160,
        g: 160,
        b: 160
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Spark]: {
        r: 255,
        g: 255,
        b: 0
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Source]: {
        r: 255,
        g: 255,
        b: 0
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Amplifier]: {
        r: 200,
        g: 200,
        b: 0
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Heater]: {
        r: 255,
        g: 100,
        b: 0
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Cooler]: {
        r: 100,
        g: 180,
        b: 255
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).ColdDetector]: {
        r: 0,
        g: 100,
        b: 255
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).HotDetector]: {
        r: 255,
        g: 130,
        b: 0
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidDetector]: {
        r: 0,
        g: 160,
        b: 230
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).ConstantCold]: {
        r: 0,
        g: 0,
        b: 255
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).ConstantHot]: {
        r: 255,
        g: 0,
        b: 0
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Void]: {
        r: 0,
        g: 0,
        b: 0
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Virus]: {
        r: 128,
        g: 0,
        b: 128
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Heal]: {
        r: 0,
        g: 255,
        b: 255
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Acid]: {
        r: 0,
        g: 255,
        b: 0
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Plant]: {
        r: 0,
        g: 255,
        b: 0
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).PlantSeed]: {
        r: 0,
        g: 255,
        b: 0
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Wire]: {
        r: 0,
        g: 0,
        b: 0
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Pipe]: {
        r: 0,
        g: 50,
        b: 255
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Smoke]: {
        r: 128,
        g: 128,
        b: 128
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Oil]: {
        r: 30,
        g: 30,
        b: 30
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).BurningOil]: {
        r: 255,
        g: 0,
        b: 0
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Snow]: {
        r: 240,
        g: 240,
        b: 240
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Magnet]: {
        r: 70,
        g: 70,
        b: 70
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).WindSource]: {
        r: 135,
        g: 206,
        b: 250
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Ant]: {
        r: 0,
        g: 0,
        b: 0
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).FireAnt]: {
        r: 255,
        g: 69,
        b: 0
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).IceAnt]: {
        r: 30,
        g: 144,
        b: 255
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Worm]: {
        r: 160,
        g: 82,
        b: 45
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).LightSource]: {
        r: 255,
        g: 255,
        b: 128
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Mirror]: {
        r: 200,
        g: 200,
        b: 255
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).LightDetector]: {
        r: 255,
        g: 230,
        b: 100
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).LightBulb]: {
        r: 255,
        g: 240,
        b: 150
    },
    [(0, $25746eb61037a613$export$873e90337ab80c46).Thermometer]: (point)=>{
        const temperature = point.data.temperature || 0;
        if (temperature === 0) return {
            r: 0,
            g: 0,
            b: 0
        };
        else if (temperature > 0) {
            const red = Math.min(255, temperature * 2.55 / 10);
            return {
                r: red,
                g: 0,
                b: 0
            };
        } else {
            const blue = Math.min(255, Math.abs(temperature) * 2.55 / 10);
            return {
                r: 0,
                g: 0,
                b: blue
            };
        }
    },
    eraser: {
        r: 200,
        g: 200,
        b: 200
    },
    heatTool: {
        r: 255,
        g: 69,
        b: 0
    },
    coolTool: {
        r: 135,
        g: 206,
        b: 250
    }
};



const $360a87d5b9cd525c$export$508f9609af06e33b = {
    [(0, $25746eb61037a613$export$873e90337ab80c46).Bomb]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Border]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Void]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Clone]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).ConstantCold]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).ConstantHot]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).FireEmitter]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Fire]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).IceFire]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).BurningWood]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Dynamite]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Ground]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Spark]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Source]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Heal]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Ant]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).FireAnt]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).IceAnt]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Worm]: true
};



const $635f7a435680582b$export$cd5d22869177bd58 = {
    water: 1,
    sand: 1,
    virus: 1,
    acid: 1,
    ant: 1,
    liquidGas: 2,
    stone: 2,
    staticStone: 2,
    lava: 2,
    wood: 2,
    glass: 2,
    liquidGlass: 1.5,
    mirror: 2,
    steam: 0.1,
    gas: 0.1,
    smoke: 0.1,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Ground]: 1,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Source]: 1,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Metal]: 0.5,
    [(0, $25746eb61037a613$export$873e90337ab80c46).MoltenMetal]: 0.5,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Dynamite]: 4,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Heater]: 0.5,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Cooler]: 0.5,
    [(0, $25746eb61037a613$export$873e90337ab80c46).ColdDetector]: 0.5,
    [(0, $25746eb61037a613$export$873e90337ab80c46).HotDetector]: 0.5,
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidDetector]: 0.5,
    [(0, $25746eb61037a613$export$873e90337ab80c46).LightDetector]: 0.5,
    [(0, $25746eb61037a613$export$873e90337ab80c46).LightBulb]: 0.5,
    constantCold: 100,
    constantHot: 100,
    fire: 100,
    iceFire: 100
};



const $4683e24c4ad0e9dc$export$e9fdf378c59a59c7 = {
    [(0, $25746eb61037a613$export$873e90337ab80c46).Stone]: 1,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Sand]: 1,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Water]: 0.9,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Oil]: 0.85,
    [(0, $25746eb61037a613$export$873e90337ab80c46).BurningOil]: 0.8,
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidGas]: 0.89,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Lava]: 2,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Fire]: -0.8,
    [(0, $25746eb61037a613$export$873e90337ab80c46).IceFire]: -0.8,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Steam]: -0.1,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Smoke]: -0.3,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Bomb]: 1,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Gas]: 0,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Spark]: 1,
    [(0, $25746eb61037a613$export$873e90337ab80c46).MoltenMetal]: 2,
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidGlass]: 1.5,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Virus]: 1,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Heal]: 1,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Acid]: 1.2,
    [(0, $25746eb61037a613$export$873e90337ab80c46).PlantSeed]: 1,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Plant]: 0,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Snow]: 0.5,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Magnet]: 1,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Ant]: 0.5,
    [(0, $25746eb61037a613$export$873e90337ab80c46).FireAnt]: 0.5,
    [(0, $25746eb61037a613$export$873e90337ab80c46).IceAnt]: 0.5,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Worm]: Infinity,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Source]: Infinity,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Ground]: Infinity,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Amplifier]: Infinity,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Metal]: Infinity,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Dynamite]: Infinity,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Wood]: Infinity,
    [(0, $25746eb61037a613$export$873e90337ab80c46).BurningWood]: Infinity,
    [(0, $25746eb61037a613$export$873e90337ab80c46).StaticStone]: Infinity,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Border]: Infinity,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Ice]: Infinity,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Glass]: Infinity,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Heater]: Infinity,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Cooler]: Infinity,
    [(0, $25746eb61037a613$export$873e90337ab80c46).ColdDetector]: Infinity,
    [(0, $25746eb61037a613$export$873e90337ab80c46).HotDetector]: Infinity,
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidDetector]: Infinity,
    [(0, $25746eb61037a613$export$873e90337ab80c46).ConstantCold]: Infinity,
    [(0, $25746eb61037a613$export$873e90337ab80c46).ConstantHot]: Infinity,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Void]: Infinity,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Clone]: Infinity,
    [(0, $25746eb61037a613$export$873e90337ab80c46).FireEmitter]: Infinity,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Wire]: Infinity,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Pipe]: Infinity,
    [(0, $25746eb61037a613$export$873e90337ab80c46).WindSource]: Infinity,
    [(0, $25746eb61037a613$export$873e90337ab80c46).StaticSand]: Infinity,
    [(0, $25746eb61037a613$export$873e90337ab80c46).LightSource]: Infinity,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Mirror]: Infinity,
    [(0, $25746eb61037a613$export$873e90337ab80c46).LightDetector]: Infinity,
    [(0, $25746eb61037a613$export$873e90337ab80c46).LightBulb]: Infinity
};





class $6b3e82ea4b803b12$export$c7c44baae9d9f25f {
    static{
        this.state = {
            maxSpeedMode: (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).get('Controls.maxSpeedMode', false),
            debugMode: (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).get('Controls.debugMode', false),
            isTemperatureEnabled: (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).get('Controls.isTemperatureEnabled', true),
            drawingType: (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).get('Controls.drawingType', (0, $25746eb61037a613$export$873e90337ab80c46).Water),
            drawingData: (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).get('Controls.drawingData', {}),
            baseTemperature: (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).get('Controls.baseTemperature', 20),
            brushSize: (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).get('Controls.brushSize', 2),
            simulationSpeed: (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).get('Controls.simulationSpeed', 1),
            isPaused: (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).get('Controls.isPaused', false),
            isSmoothMovementEnabled: (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).get('Controls.isSmoothMovementEnabled', true),
            isConnectionMode: false,
            isLightSourcesEnabled: (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).get('Controls.isLightSourcesEnabled', false)
        };
    }
    static{
        this.subscribers = [];
    }
    static{
        this.connectionStartPoint = null;
    }
    static subscribe(key, callback) {
        this.subscribers.push({
            key: key,
            callback: callback
        });
        return ()=>{
            this.subscribers = this.subscribers.filter((subscriber)=>subscriber.callback !== callback);
        };
    }
    static callSubscribers(key) {
        this.subscribers.forEach((subscriber)=>{
            if (subscriber.key === key) subscriber.callback($6b3e82ea4b803b12$export$c7c44baae9d9f25f.state);
        });
    }
    static setState(key, value) {
        const isSame = this.state[key] === value;
        if (isSame) return;
        (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).set(`Controls.${key}`, value);
        this.state[key] = value;
        this.callSubscribers(key);
    }
    static getBrushSize() {
        return this.state.brushSize;
    }
    static setBrushSize(value) {
        this.setState('brushSize', value);
    }
    static getDrawingType() {
        return this.state.drawingType;
    }
    static setDrawingType(value) {
        this.setState('drawingType', value);
    }
    static getDrawingData() {
        return this.state.drawingData;
    }
    static setDrawingData(value) {
        this.setState('drawingData', value);
    }
    static getDebugMode() {
        return this.state.debugMode;
    }
    static setDebugMode(value) {
        this.setState('debugMode', value);
    }
    static getMaxSpeedMode() {
        return this.state.maxSpeedMode;
    }
    static setMaxSpeedMode(value) {
        this.setState('maxSpeedMode', value);
    }
    static getBaseTemperature() {
        return this.state.baseTemperature;
    }
    static setBaseTemperature(value) {
        this.setState('baseTemperature', value);
    }
    static getIsTemperatureEnabled() {
        return this.state.isTemperatureEnabled;
    }
    static setIsTemperatureEnabled(value) {
        this.setState('isTemperatureEnabled', value);
    }
    static getSimulationSpeed() {
        return this.state.simulationSpeed;
    }
    static setSimulationSpeed(value) {
        this.setState('simulationSpeed', value);
    }
    static getIsPaused() {
        return this.state.isPaused;
    }
    static setIsPaused(value) {
        this.setState('isPaused', value);
    }
    static getIsSmoothMovementEnabled() {
        return this.state.isSmoothMovementEnabled;
    }
    static setIsSmoothMovementEnabled(value) {
        this.setState('isSmoothMovementEnabled', value);
    }
    static getIsConnectionMode() {
        return this.state.isConnectionMode;
    }
    static setIsConnectionMode(value) {
        this.setState('isConnectionMode', value);
    }
    static getConnectionStartPoint() {
        return this.connectionStartPoint;
    }
    static setConnectionStartPoint(value) {
        this.connectionStartPoint = value;
    }
    static getIsLightSourcesEnabled() {
        return this.state.isLightSourcesEnabled;
    }
    static setIsLightSourcesEnabled(value) {
        this.setState('isLightSourcesEnabled', value);
    }
}


const $6de2ed3e5d01eb29$var$buffer = [];
const $6de2ed3e5d01eb29$var$MAX_BUFFER_SIZE = 1000000;
setInterval(()=>{
    if ($6de2ed3e5d01eb29$var$buffer.length < $6de2ed3e5d01eb29$var$MAX_BUFFER_SIZE) for(let i = 0; i < 10000; i++)$6de2ed3e5d01eb29$var$buffer.push(Math.random());
}, 0);
let $6de2ed3e5d01eb29$var$fromRandomCount = 0;
let $6de2ed3e5d01eb29$var$fromBufferCount = 0;
function $6de2ed3e5d01eb29$export$4385e60b38654f68() {
    const fromBuffer = $6de2ed3e5d01eb29$var$buffer.pop();
    if (!fromBuffer) {
        $6de2ed3e5d01eb29$var$fromRandomCount++;
        return Math.random();
    }
    $6de2ed3e5d01eb29$var$fromBufferCount++;
    return fromBuffer;
}
const $6de2ed3e5d01eb29$export$ff07e02f86da72e2 = ()=>$6de2ed3e5d01eb29$var$fromRandomCount;
const $6de2ed3e5d01eb29$export$8707e673f135b79e = ()=>$6de2ed3e5d01eb29$var$fromBufferCount;
const $6de2ed3e5d01eb29$export$1edf699114815981 = ()=>$6de2ed3e5d01eb29$var$buffer.length;



const $54b1901f91ac083a$export$1c715e9dd0603148 = 100;
const $54b1901f91ac083a$export$46f2d0992622c673 = 0.99;
const $54b1901f91ac083a$export$4a7158be66f0b395 = 'lightSource';
const $54b1901f91ac083a$export$7da6434e793a8d85 = (intensity = 1.0)=>{
    const lightSourceProcessor = (point)=>{
        // Mark the point for the renderer to know it's a light source
        point.data.isLightSource = true;
        // Light intensity at source (can be modified based on point properties)
        point.data.lightIntensity = intensity * 0.5;
    };
    lightSourceProcessor.processorName = $54b1901f91ac083a$export$4a7158be66f0b395;
    return lightSourceProcessor;
};





const $57a22ed606f2167f$var$LIGHT_FADE_FACTOR = 0.9;
// 1 - totally transparent
// 0 - totally opaque
const $57a22ed606f2167f$var$OPACITY = {
    default: 0.4,
    [(0, $25746eb61037a613$export$873e90337ab80c46).LightSource]: 1,
    [(0, $25746eb61037a613$export$873e90337ab80c46).LightBulb]: 1,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Glass]: 0.9,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Border]: 0,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Water]: 0.9,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Ice]: 0.8,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Void]: 0,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Gas]: 0.9,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Metal]: 0.05,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Smoke]: 0.2,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Mirror]: 0,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Fire]: 1,
    [(0, $25746eb61037a613$export$873e90337ab80c46).IceFire]: 1
};
const $57a22ed606f2167f$var$REFLECTION_FACTOR = {
    default: 0.1,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Metal]: 0.9,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Mirror]: 0.9999,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Border]: 0.5
};
class $57a22ed606f2167f$export$3e593816f425a913 {
    static{
        this.lightMap = new Map();
    }
    static{
        this.processedPoints = new Set();
    }
    static{
        this.lastRays = [];
    }
    static{
        this.lightSourcePoints = new Set();
    }
    static getLightSourcePoints() {
        if (!(0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getIsLightSourcesEnabled()) return new Set();
        return this.lightSourcePoints;
    }
    static addLightSourcePoint(point) {
        this.lightSourcePoints.add(point);
    }
    static removeLightSourcePoint(point) {
        this.lightSourcePoints.delete(point);
    }
    static getKey(x, y) {
        return `${x},${y}`;
    }
    static getLightIntensity(x, y) {
        const key = this.getKey(x, y);
        const lightIntensity = this.lightMap.get(key) || 0;
        return lightIntensity;
    }
    static fadeLightMap() {
        for (const [key, intensity] of this.lightMap.entries())this.lightMap.set(key, intensity * $57a22ed606f2167f$var$LIGHT_FADE_FACTOR);
    }
    static calculateLighting() {
        if (!(0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getIsLightSourcesEnabled()) return;
        this.fadeLightMap();
        this.processedPoints.clear();
        this.lastRays = [];
        const lightSources = Array.from(this.lightSourcePoints);
        for (const source of lightSources)this.processLightSource(source);
    }
    static getDirection(amount) {
        const initialAngle = (0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() * 2 * Math.PI;
        return Array.from({
            length: amount
        }, (_, i)=>{
            const angle = i / amount * 2 * Math.PI + initialAngle;
            return [
                Math.cos(angle),
                Math.sin(angle)
            ];
        });
    }
    static processLightSource(source, forceIntensity = 1, directionsCount = 11, initialDistance = 0) {
        if (this.processedPoints.has(source)) return;
        const sourceX = source.coordinates.x;
        const sourceY = source.coordinates.y;
        const intensity = typeof source.data.lightIntensity === 'number' ? source.data.lightIntensity : forceIntensity;
        this.processedPoints.add(source);
        this.setLight(sourceX, sourceY, intensity);
        // Cast rays in 8 directions (can be expanded for more precision)
        const directions = this.getDirection(directionsCount);
        for (const [dx, dy] of directions)this.castRay(sourceX, sourceY, dx, dy, intensity, initialDistance);
    }
    static castRay(x, y, dx, dy, intensity, initialDistance = 0) {
        let currentX = x;
        let currentY = y;
        let currentIntensity = intensity;
        let distance = initialDistance;
        let distanceFromSource = 0;
        // Set light at source position
        this.setLight(Math.round(currentX), Math.round(currentY), currentIntensity);
        while(currentIntensity > 0.01 && distance < (0, $54b1901f91ac083a$export$1c715e9dd0603148)){
            // Move along the ray
            currentX += dx;
            currentY += dy;
            distance += 1;
            distanceFromSource += 1;
            // Decay light intensity with distance
            currentIntensity *= (0, $54b1901f91ac083a$export$46f2d0992622c673);
            // Round to nearest grid position
            const gridX = Math.round(currentX);
            const gridY = Math.round(currentY);
            // Check if there's a point at this position that blocks light
            const pointAtPosition = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPointByCoordinates({
                x: gridX,
                y: gridY
            });
            const previousLightAtPosition = this.getLightIntensity(gridX, gridY);
            // Set light intensity at this position
            this.setLight(gridX, gridY, currentIntensity + previousLightAtPosition);
            if (pointAtPosition) {
                if (distanceFromSource > 1) {
                    const reflectionFactor = $57a22ed606f2167f$var$REFLECTION_FACTOR[pointAtPosition.type] ?? $57a22ed606f2167f$var$REFLECTION_FACTOR.default;
                    const reflection = reflectionFactor * currentIntensity;
                    this.processLightSource(pointAtPosition, reflection, 11, distance);
                }
                const opacity = $57a22ed606f2167f$var$OPACITY[pointAtPosition.type] ?? $57a22ed606f2167f$var$OPACITY.default;
                currentIntensity *= opacity;
            }
        }
        this.lastRays.push({
            fromX: x,
            fromY: y,
            toX: currentX,
            toY: currentY
        });
    }
    static setLight(x, y, intensity) {
        const key = this.getKey(x, y);
        const currentIntensity = this.lightMap.get(key) || 0;
        // Use the highest intensity if multiple light sources affect this point
        this.lightMap.set(key, Math.max(currentIntensity, intensity));
    }
}


const $0c03ddc232f6bf98$export$f42c036c4e9ecad7 = (temperature)=>(point)=>{
        if (point.data.temperature && point.data.temperature < temperature) point.data.temperature = temperature;
    };
const $0c03ddc232f6bf98$export$a30105674c24852a = (temperature)=>(point)=>{
        if (point.data.temperature && point.data.temperature > temperature) point.data.temperature = temperature;
    };
const $0c03ddc232f6bf98$export$d73d835fa5131a64 = (temperatureByStep, maxTemperature)=>(point)=>{
        if (point.data.temperature && point.data.temperature < maxTemperature) point.data.temperature += temperatureByStep;
    };
const $0c03ddc232f6bf98$export$e802a0b707365fb = (temperatureByStep, minTemperature)=>(point)=>{
        if (point.data.temperature && point.data.temperature > minTemperature) point.data.temperature -= temperatureByStep;
    };
const $0c03ddc232f6bf98$export$1becb524344efd56 = (temperature)=>(point)=>{
        let temperatureValue;
        if (typeof temperature === 'function') temperatureValue = temperature();
        else temperatureValue = temperature;
        point.data.temperature = temperatureValue;
    };
const $0c03ddc232f6bf98$var$CHANCE_TO_CONVERT = 0.03;
const $0c03ddc232f6bf98$export$2293b0cf4a34d38f = {
    max: 500,
    min: -500
};
const $0c03ddc232f6bf98$export$f36b1181189adb85 = (type, temperature, typeToConvert)=>(point)=>{
        if (!(0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getIsTemperatureEnabled()) return;
        if (!point.data.temperature) point.data.temperature = 15;
        if (type === 'more') $0c03ddc232f6bf98$export$2293b0cf4a34d38f.max = Math.max($0c03ddc232f6bf98$export$2293b0cf4a34d38f.max, temperature);
        else $0c03ddc232f6bf98$export$2293b0cf4a34d38f.min = Math.min($0c03ddc232f6bf98$export$2293b0cf4a34d38f.min, temperature);
        if (type === 'more' && point.data.temperature > temperature && point.type !== typeToConvert) {
            (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markNeighboursAsUsed(point);
            if ((0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() < $0c03ddc232f6bf98$var$CHANCE_TO_CONVERT) {
                point.type = typeToConvert;
                (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).onPointUpdated(point);
            }
        }
        if (type === 'less' && point.data.temperature < temperature && point.type !== typeToConvert) {
            (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markNeighboursAsUsed(point);
            if ((0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() < $0c03ddc232f6bf98$var$CHANCE_TO_CONVERT) {
                point.type = typeToConvert;
                (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).onPointUpdated(point);
            }
        }
    };
const $0c03ddc232f6bf98$export$56b8754592079e56 = (intencity = 0.1)=>(point)=>{
        const baseTemperature = (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getBaseTemperature();
        if (!point.data.temperature) point.data.temperature = baseTemperature;
        const temperature = point.data.temperature;
        const difference = baseTemperature - temperature;
        point.data.temperature += difference * intencity;
    };
const $0c03ddc232f6bf98$export$cd97518631d93b14 = (type, temperature)=>(point)=>{
        if (type === 'more' && point.data.temperature && point.data.temperature > temperature) (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).deletePoint(point);
        if (type === 'less' && point.data.temperature && point.data.temperature < temperature) (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).deletePoint(point);
    };
const $0c03ddc232f6bf98$var$TEMPERATURE_BY_LIGHT_FACTOR = 0.2;
const $0c03ddc232f6bf98$export$fb01a17bfbf0d787 = (point)=>{
    const lightIntensity = (0, $57a22ed606f2167f$export$3e593816f425a913).getLightIntensity(point.coordinates.x, point.coordinates.y);
    point.data.temperature += lightIntensity * $0c03ddc232f6bf98$var$TEMPERATURE_BY_LIGHT_FACTOR;
};



const $de0cf5fb31f39b4f$export$f50ca6dc0891673f = {
    [(0, $25746eb61037a613$export$873e90337ab80c46).Ice]: -20,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Lava]: 1500,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Steam]: 120,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Fire]: (0, $0c03ddc232f6bf98$export$2293b0cf4a34d38f).max + 100,
    [(0, $25746eb61037a613$export$873e90337ab80c46).IceFire]: (0, $0c03ddc232f6bf98$export$2293b0cf4a34d38f).min - 100,
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidGas]: -180,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Virus]: 20,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Acid]: 20,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Glass]: 25,
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidGlass]: 1500,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Smoke]: 200,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Snow]: -20,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Amplifier]: 20,
    [(0, $25746eb61037a613$export$873e90337ab80c46).ConstantCold]: (0, $0c03ddc232f6bf98$export$2293b0cf4a34d38f).min - 100,
    [(0, $25746eb61037a613$export$873e90337ab80c46).ConstantHot]: (0, $0c03ddc232f6bf98$export$2293b0cf4a34d38f).max + 100,
    [(0, $25746eb61037a613$export$873e90337ab80c46).BurningWood]: 800,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Water]: 20,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Metal]: 25,
    [(0, $25746eb61037a613$export$873e90337ab80c46).MoltenMetal]: 1600,
    [(0, $25746eb61037a613$export$873e90337ab80c46).StaticStone]: 25,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Stone]: 25,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Sand]: 25,
    [(0, $25746eb61037a613$export$873e90337ab80c46).StaticSand]: 25,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Gas]: 25,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Wood]: 25,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Oil]: 20,
    [(0, $25746eb61037a613$export$873e90337ab80c46).BurningOil]: 350,
    [(0, $25746eb61037a613$export$873e90337ab80c46).FireAnt]: 800,
    [(0, $25746eb61037a613$export$873e90337ab80c46).IceAnt]: -400,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Mirror]: 25,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Spark]: 100,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Heater]: 20,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Cooler]: 20,
    [(0, $25746eb61037a613$export$873e90337ab80c46).ColdDetector]: 20,
    [(0, $25746eb61037a613$export$873e90337ab80c46).HotDetector]: 20,
    [(0, $25746eb61037a613$export$873e90337ab80c46).LightBulb]: 20
};
setInterval(()=>{
    $de0cf5fb31f39b4f$export$f50ca6dc0891673f[(0, $25746eb61037a613$export$873e90337ab80c46).Fire] = (0, $0c03ddc232f6bf98$export$2293b0cf4a34d38f).max + 100;
    $de0cf5fb31f39b4f$export$f50ca6dc0891673f[(0, $25746eb61037a613$export$873e90337ab80c46).IceFire] = (0, $0c03ddc232f6bf98$export$2293b0cf4a34d38f).min - 100;
    $de0cf5fb31f39b4f$export$f50ca6dc0891673f[(0, $25746eb61037a613$export$873e90337ab80c46).ConstantCold] = (0, $0c03ddc232f6bf98$export$2293b0cf4a34d38f).min - 100;
    $de0cf5fb31f39b4f$export$f50ca6dc0891673f[(0, $25746eb61037a613$export$873e90337ab80c46).ConstantHot] = (0, $0c03ddc232f6bf98$export$2293b0cf4a34d38f).max + 100;
}, 5000);



const $0a2978442e4c4e59$export$841e0ced76dde0da = {
    [(0, $25746eb61037a613$export$873e90337ab80c46).Water]: "\uD83D\uDCA7",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Sand]: "\uD83C\uDFDD\uFE0F",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Stone]: "\uD83E\uDEA8",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Lava]: "\uD83C\uDF0B",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Metal]: "\u2699\uFE0F",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Ground]: "\u26A1\uD83D\uDD0C",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Spark]: "\u26A1",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Source]: "\uD83D\uDD0B",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Amplifier]: "\u26A1\u2699\uFE0F",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Heater]: "\uD83D\uDD25\u26A1",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Cooler]: "\u2744\uFE0F\u26A1",
    [(0, $25746eb61037a613$export$873e90337ab80c46).ColdDetector]: "\u2744\uFE0F\uD83D\uDD0B",
    [(0, $25746eb61037a613$export$873e90337ab80c46).HotDetector]: "\uD83D\uDD25\uD83D\uDD0B",
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidDetector]: "\uD83D\uDCA7\uD83D\uDD0B",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Wood]: "\uD83E\uDEB5",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Border]: "\uD83E\uDDF1",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Fire]: "\uD83D\uDD25",
    [(0, $25746eb61037a613$export$873e90337ab80c46).IceFire]: "\u2744\uFE0F\uD83D\uDD25",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Bomb]: "\uD83D\uDCA3",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Dynamite]: "\uD83E\uDDE8",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Ice]: "\u2744\uFE0F",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Clone]: "\uD83E\uDDEC",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Gas]: "\u2601\uFE0F",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Void]: "\u26AB",
    [(0, $25746eb61037a613$export$873e90337ab80c46).ConstantCold]: "\u2744\uFE0F\u267E\uFE0F",
    [(0, $25746eb61037a613$export$873e90337ab80c46).ConstantHot]: "\uD83D\uDD25\u267E\uFE0F",
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidGas]: "\uD83D\uDCA7\u2601\uFE0F",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Glass]: "\uD83D\uDD0D",
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidGlass]: "\uD83C\uDF21\uFE0F\uD83D\uDD0D",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Virus]: "\uD83E\uDDA0",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Heal]: "\uD83D\uDC8A",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Acid]: "\u2697\uFE0F",
    [(0, $25746eb61037a613$export$873e90337ab80c46).PlantSeed]: "\uD83C\uDF31",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Wire]: "\uD83D\uDD0C",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Pipe]: "\uD83E\uDDEA",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Oil]: "\uD83D\uDEE2\uFE0F",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Smoke]: "\uD83D\uDEAC",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Snow]: "\u2744\uFE0F\u2603\uFE0F",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Magnet]: "\uD83E\uDDF2",
    [(0, $25746eb61037a613$export$873e90337ab80c46).WindSource]: "\uD83D\uDCA8",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Ant]: "\uD83D\uDC1C",
    [(0, $25746eb61037a613$export$873e90337ab80c46).FireAnt]: "\uD83D\uDD25\uD83D\uDC1C",
    [(0, $25746eb61037a613$export$873e90337ab80c46).IceAnt]: "\u2744\uFE0F\uD83D\uDC1C",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Worm]: "\uD83E\uDEB1",
    [(0, $25746eb61037a613$export$873e90337ab80c46).LightSource]: "\uD83D\uDCA1",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Mirror]: "\uD83E\uDE9E",
    [(0, $25746eb61037a613$export$873e90337ab80c46).LightDetector]: "\uD83D\uDC41\uFE0F",
    [(0, $25746eb61037a613$export$873e90337ab80c46).LightBulb]: "\uD83D\uDCA1\u26A1",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Thermometer]: "\uD83C\uDF21\uFE0F",
    eraser: "\uD83E\uDDFD",
    heatTool: "\uD83D\uDD25\uD83D\uDD27",
    coolTool: "\u2744\uFE0F\uD83D\uDD27"
};
const $0a2978442e4c4e59$export$402035f05c012faf = [
    {
        name: "Basic Elements",
        elements: [
            (0, $25746eb61037a613$export$873e90337ab80c46).Sand,
            (0, $25746eb61037a613$export$873e90337ab80c46).Stone,
            (0, $25746eb61037a613$export$873e90337ab80c46).Border,
            (0, $25746eb61037a613$export$873e90337ab80c46).Wood,
            (0, $25746eb61037a613$export$873e90337ab80c46).Glass,
            (0, $25746eb61037a613$export$873e90337ab80c46).Mirror,
            (0, $25746eb61037a613$export$873e90337ab80c46).Magnet,
            (0, $25746eb61037a613$export$873e90337ab80c46).LightSource
        ]
    },
    {
        name: "Light Elements",
        elements: [
            (0, $25746eb61037a613$export$873e90337ab80c46).LightSource,
            (0, $25746eb61037a613$export$873e90337ab80c46).Mirror,
            (0, $25746eb61037a613$export$873e90337ab80c46).LightDetector,
            (0, $25746eb61037a613$export$873e90337ab80c46).LightBulb
        ]
    },
    {
        name: "Tools",
        elements: [
            'eraser',
            'heatTool',
            'coolTool',
            (0, $25746eb61037a613$export$873e90337ab80c46).Thermometer
        ]
    },
    {
        name: 'Live',
        elements: [
            (0, $25746eb61037a613$export$873e90337ab80c46).Ant,
            (0, $25746eb61037a613$export$873e90337ab80c46).FireAnt,
            (0, $25746eb61037a613$export$873e90337ab80c46).IceAnt,
            (0, $25746eb61037a613$export$873e90337ab80c46).Worm
        ]
    },
    {
        name: "Liquids",
        elements: [
            (0, $25746eb61037a613$export$873e90337ab80c46).Water,
            (0, $25746eb61037a613$export$873e90337ab80c46).Lava,
            (0, $25746eb61037a613$export$873e90337ab80c46).LiquidGas,
            (0, $25746eb61037a613$export$873e90337ab80c46).LiquidGlass,
            (0, $25746eb61037a613$export$873e90337ab80c46).Acid,
            (0, $25746eb61037a613$export$873e90337ab80c46).Oil
        ]
    },
    {
        name: "Gases",
        elements: [
            (0, $25746eb61037a613$export$873e90337ab80c46).Gas,
            (0, $25746eb61037a613$export$873e90337ab80c46).Smoke
        ]
    },
    {
        name: "Temperature Elements",
        elements: [
            (0, $25746eb61037a613$export$873e90337ab80c46).Fire,
            (0, $25746eb61037a613$export$873e90337ab80c46).Ice,
            (0, $25746eb61037a613$export$873e90337ab80c46).IceFire,
            (0, $25746eb61037a613$export$873e90337ab80c46).ConstantHot,
            (0, $25746eb61037a613$export$873e90337ab80c46).ConstantCold,
            (0, $25746eb61037a613$export$873e90337ab80c46).Snow
        ]
    },
    {
        name: "Electricity",
        elements: [
            (0, $25746eb61037a613$export$873e90337ab80c46).Metal,
            (0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Source,
            (0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Ground,
            (0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Spark,
            (0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Amplifier,
            (0, $25746eb61037a613$export$873e90337ab80c46).Heater,
            (0, $25746eb61037a613$export$873e90337ab80c46).Cooler,
            (0, $25746eb61037a613$export$873e90337ab80c46).LightBulb,
            (0, $25746eb61037a613$export$873e90337ab80c46).ColdDetector,
            (0, $25746eb61037a613$export$873e90337ab80c46).HotDetector,
            (0, $25746eb61037a613$export$873e90337ab80c46).LiquidDetector,
            (0, $25746eb61037a613$export$873e90337ab80c46).LightDetector
        ]
    },
    {
        name: "Connections",
        elements: [
            (0, $25746eb61037a613$export$873e90337ab80c46).Wire,
            (0, $25746eb61037a613$export$873e90337ab80c46).Pipe
        ]
    },
    {
        name: "Explosives",
        elements: [
            (0, $25746eb61037a613$export$873e90337ab80c46).Bomb,
            (0, $25746eb61037a613$export$873e90337ab80c46).Dynamite
        ]
    },
    {
        name: "Environmental",
        elements: [
            {
                type: (0, $25746eb61037a613$export$873e90337ab80c46).WindSource,
                data: {
                    windDirection: {
                        x: 0,
                        y: -1
                    }
                },
                icon: "\uD83D\uDCA8\u2B06\uFE0F"
            },
            {
                type: (0, $25746eb61037a613$export$873e90337ab80c46).WindSource,
                data: {
                    windDirection: {
                        x: 0,
                        y: 1
                    }
                },
                icon: "\uD83D\uDCA8\u2B07\uFE0F"
            },
            {
                type: (0, $25746eb61037a613$export$873e90337ab80c46).WindSource,
                data: {
                    windDirection: {
                        x: 1,
                        y: 0
                    }
                },
                icon: "\uD83D\uDCA8\u27A1\uFE0F"
            },
            {
                type: (0, $25746eb61037a613$export$873e90337ab80c46).WindSource,
                data: {
                    windDirection: {
                        x: -1,
                        y: 0
                    }
                },
                icon: "\uD83D\uDCA8\u2B05\uFE0F"
            }
        ]
    },
    {
        name: "Special Elements",
        elements: [
            (0, $25746eb61037a613$export$873e90337ab80c46).Clone,
            (0, $25746eb61037a613$export$873e90337ab80c46).Void,
            (0, $25746eb61037a613$export$873e90337ab80c46).Virus,
            (0, $25746eb61037a613$export$873e90337ab80c46).Heal,
            (0, $25746eb61037a613$export$873e90337ab80c46).PlantSeed,
            (0, $25746eb61037a613$export$873e90337ab80c46).Magnet
        ]
    }
];
const $0a2978442e4c4e59$var$allElementsInIcon = Object.keys($0a2978442e4c4e59$export$841e0ced76dde0da);
const $0a2978442e4c4e59$var$missingElements = $0a2978442e4c4e59$var$allElementsInIcon.filter((element)=>!$0a2978442e4c4e59$export$402035f05c012faf.some((group)=>{
        return group.elements.some((groupElement)=>{
            if (typeof groupElement === 'string') return groupElement === element;
            return groupElement.type === element;
        });
    }));
if ($0a2978442e4c4e59$var$missingElements.length > 0) console.warn('Not all elements are included in groups', $0a2978442e4c4e59$var$missingElements);



const $d4cc0bff95ac142d$export$1c1af44c281de472 = {
    w: (0, $25746eb61037a613$export$873e90337ab80c46).Water,
    s: (0, $25746eb61037a613$export$873e90337ab80c46).Sand,
    r: (0, $25746eb61037a613$export$873e90337ab80c46).Stone,
    f: (0, $25746eb61037a613$export$873e90337ab80c46).Fire,
    i: (0, $25746eb61037a613$export$873e90337ab80c46).IceFire,
    b: (0, $25746eb61037a613$export$873e90337ab80c46).Border,
    c: (0, $25746eb61037a613$export$873e90337ab80c46).Clone,
    g: (0, $25746eb61037a613$export$873e90337ab80c46).Gas,
    v: (0, $25746eb61037a613$export$873e90337ab80c46).Void,
    e: 'eraser',
    a: (0, $25746eb61037a613$export$873e90337ab80c46).Acid,
    h: 'heatTool',
    l: (0, $25746eb61037a613$export$873e90337ab80c46).LightSource
};
const $d4cc0bff95ac142d$export$d8dfc3abc36dfb12 = Object.entries($d4cc0bff95ac142d$export$1c1af44c281de472).reduce((acc, [key, value])=>{
    acc[value] = key;
    return acc;
}, {});




const $70e4e14f6ee7315a$export$e919a8af435a7734 = (point)=>{
    const baseColor = (0, $b0107f5265abe006$export$5551a2d24ff40153)(point);
    // Calculate brightness (0-1) using perceived brightness formula
    const brightness = (0.299 * baseColor.r + 0.587 * baseColor.g + 0.114 * baseColor.b) / 255;
    // Adjust variation based on brightness:
    // - For bright colors (brightness close to 1): smaller variation
    // - For dark colors (brightness close to 0): larger variation
    const variationScale = 0.1 + (1 - brightness) * 0.3 // Scale from 0.1 (bright) to 0.4 (dark)
    ;
    const factor = 1 + (point.colorVariation || 0) * variationScale * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).colorVariation;
    // Apply the variation and clamp values between 0-255
    const r = Math.min(255, Math.max(0, Math.round(baseColor.r * factor)));
    const g = Math.min(255, Math.max(0, Math.round(baseColor.g * factor)));
    const b = Math.min(255, Math.max(0, Math.round(baseColor.b * factor)));
    return `rgb(${r}, ${g}, ${b})`;
};



const $8cf8e02aa778f380$export$1477cfa3b314a285 = {
    [(0, $25746eb61037a613$export$873e90337ab80c46).LightSource]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Fire]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Lava]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).LightBulb]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).BurningWood]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).BurningOil]: true
};
const $8cf8e02aa778f380$export$e6907e933a8789b6 = {
    [(0, $25746eb61037a613$export$873e90337ab80c46).Worm]: true
};
const $8cf8e02aa778f380$export$6e249174ae4d7b22 = {
    [(0, $25746eb61037a613$export$873e90337ab80c46).Metal]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).MoltenMetal]: true
};
const $8cf8e02aa778f380$export$888605cfd55923ba = {
    [(0, $25746eb61037a613$export$873e90337ab80c46).Acid]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Void]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Clone]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Border]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Glass]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidGlass]: true
};
const $8cf8e02aa778f380$export$f38b826e47487d07 = {
    [(0, $25746eb61037a613$export$873e90337ab80c46).Void]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Clone]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Virus]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Border]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Heal]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Glass]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidGlass]: true
};
const $8cf8e02aa778f380$export$5db4bcc9f0e2124b = {
    [(0, $25746eb61037a613$export$873e90337ab80c46).Sand]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).StaticSand]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Plant]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).PlantSeed]: true
};
const $8cf8e02aa778f380$export$aca86d12099f09 = {
    from: 5,
    to: 15
};









function $8e9b18f56b659120$export$267b06a7460aa7d3(array) {
    if (array.length <= 1) return [
        ...array
    ];
    const copy = [
        ...array
    ];
    let i = copy.length;
    while(--i > 0){
        const j = Math.floor((0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() * (i + 1));
        const temp = copy[i];
        copy[i] = copy[j];
        copy[j] = temp;
    }
    return copy;
}














// Temperature processing constants
const $2ae2627a22c7a745$var$MIN_SIZE = 4; // Minimum size of a quadtree node
const $2ae2627a22c7a745$var$TEMPERATURE_SHARE_FACTOR = 0.05;
const $2ae2627a22c7a745$var$BASE_PULL_FACTOR = 0.1;
// Neighbor coefficient constants
const $2ae2627a22c7a745$var$DIAGONAL_COEFFICIENT = 0.75;
const $2ae2627a22c7a745$var$NORMAL_COEFFICIENT = 1;
const $2ae2627a22c7a745$var$BOUNDARY_COEFFICIENT = 0.01;
// Heat capacity constants
const $2ae2627a22c7a745$var$DEFAULT_HEAT_CAPACITY = 1;
class $2ae2627a22c7a745$export$4c3a4f8b84dea6c1 {
    constructor(x, y, size, temperature){
        this.children = null;
        this.isLeaf = true;
        this.hasPoints = false;
        this.x = x;
        this.y = y;
        this.size = size;
        this.temperature = temperature;
    }
    // Check if this node contains the given point
    contains(x, y) {
        return x >= this.x && x < this.x + this.size && y >= this.y && y < this.y + this.size;
    }
    // Subdivide this node into four children
    subdivide() {
        if (!this.isLeaf) return;
        const halfSize = this.size / 2;
        this.children = [
            new $2ae2627a22c7a745$export$4c3a4f8b84dea6c1(this.x, this.y, halfSize, this.temperature),
            new $2ae2627a22c7a745$export$4c3a4f8b84dea6c1(this.x + halfSize, this.y, halfSize, this.temperature),
            new $2ae2627a22c7a745$export$4c3a4f8b84dea6c1(this.x, this.y + halfSize, halfSize, this.temperature),
            new $2ae2627a22c7a745$export$4c3a4f8b84dea6c1(this.x + halfSize, this.y + halfSize, halfSize, this.temperature)
        ];
        this.isLeaf = false;
    }
    // Get the leaf node that contains the given point
    getLeafAt(x, y) {
        if (!this.contains(x, y)) return null;
        if (this.isLeaf) return this;
        for (const child of this.children){
            const leaf = child.getLeafAt(x, y);
            if (leaf) return leaf;
        }
        return null;
    }
    // Get all neighboring leaf nodes
    getNeighbors() {
        if (!this.isLeaf) throw new Error("getNeighbors can only be called on leaf nodes");
        // This is a simplified implementation - a full one would need to traverse the tree
        // to find all adjacent leaf nodes, which is more complex
        const neighbors = [];
        // For now, we'll just return an empty array as the actual implementation
        // would be quite complex and depend on the tree structure
        return neighbors;
    }
}
class $2ae2627a22c7a745$export$27d7857d42cf741d {
    static{
        this.root = null;
    }
    static{
        this.pointsMap = new Map();
    }
    // Initialize the quad tree
    static init() {
        const bounds = (0, $bab86e660d8728eb$export$c4e9d269599ab4b4).getBounds();
        const baseTemperature = (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getBaseTemperature();
        // Calculate the size needed to cover the entire bounds
        const width = bounds.right - bounds.left + 1;
        const height = bounds.bottom - bounds.top + 1;
        const size = Math.max(width, height);
        // Create the root node
        this.root = new $2ae2627a22c7a745$export$4c3a4f8b84dea6c1(bounds.left, bounds.top, size, baseTemperature);
        // Add all points to the tree
        this.updateFromPoints();
        // Save the state
        this.save();
    }
    static save() {
        // We don't actually save the entire tree structure as it would be too large
        // Instead, we'll recreate it each time from the points
        (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).set("TemperatureQuadTree.initialized", true);
    }
    // Update the quad tree from points
    static updateFromPoints() {
        if (!this.root) this.init();
        const points = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPoints();
        this.pointsMap.clear();
        for (const point of points){
            const { x: x, y: y } = point.coordinates;
            const temperature = point.data.temperature ?? (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getBaseTemperature();
            // Find or create the leaf node for this point
            let node = this.ensureLeafNodeAt(x, y);
            if (node) {
                node.temperature = temperature;
                node.hasPoints = true;
                this.pointsMap.set(`${x},${y}`, {
                    point: point,
                    node: node
                });
            }
        }
        // After adding all points, check if we need to refine the tree
        this.refineTree();
    }
    // Ensure there's a leaf node at the given coordinates
    static ensureLeafNodeAt(x, y) {
        if (!this.root) return null;
        if (!this.root.contains(x, y)) // Point is outside our current bounds, we'd need to expand the tree
        // This is a simplification - a full implementation would handle this
        return null;
        let current = this.root;
        // Traverse down to a leaf node, subdividing as needed
        while(!current.isLeaf){
            let found = false;
            for (const child of current.children)if (child.contains(x, y)) {
                current = child;
                found = true;
                break;
            }
            if (!found) // This shouldn't happen if our contains logic is correct
            return null;
        }
        // If the leaf is too large, subdivide it until we reach MIN_SIZE
        while(current.size > $2ae2627a22c7a745$var$MIN_SIZE){
            current.subdivide();
            // Find which child contains our point
            for (const child of current.children)if (child.contains(x, y)) {
                current = child;
                break;
            }
        }
        return current;
    }
    // Refine the tree based on temperature gradients
    static refineTree() {
        if (!this.root) return;
    // This is a simplified implementation
    // A full implementation would traverse the tree and subdivide nodes
    // where there are large temperature gradients
    // For now, we'll just ensure that areas with points have appropriate resolution
    }
    // Process one frame of temperature simulation
    static processTemperatureFrame() {
        if (!this.root) this.init();
        const baseTemperature = (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getBaseTemperature();
        // Create a new tree for the updated temperatures
        // In a real implementation, we'd use a more efficient approach
        const newTemperatures = new Map();
        // Process all leaf nodes
        if (this.root) this.processNode(this.root, newTemperatures, $2ae2627a22c7a745$var$TEMPERATURE_SHARE_FACTOR);
        // Update the tree with new temperatures
        for (const [node, temp] of newTemperatures.entries())node.temperature = temp;
        if (this.root) this.applyGlobalBasePull(this.root, baseTemperature);
        // Update points from the tree
        this.updatePointsFromTree();
        // Save the state
        this.save();
    }
    // Process a node and its children recursively
    static processNode(node, newTemperatures, temperatureShareFactor) {
        if (node.isLeaf) // For leaf nodes, calculate the new temperature
        this.processLeafNode(node, newTemperatures, temperatureShareFactor);
        else // For non-leaf nodes, process all children
        for (const child of node.children)this.processNode(child, newTemperatures, temperatureShareFactor);
    }
    // Process a leaf node
    static processLeafNode(node, newTemperatures, temperatureShareFactor) {
        // Get the current temperature
        const currentTemperature = node.temperature;
        // Find all neighboring nodes
        const neighbors = this.getNeighborsOf(node);
        // Calculate the average temperature of neighbors
        let temperatureSum = 0;
        let coefficientSum = 0;
        for (const neighbor of neighbors){
            const coefficient = this.getNeighborCoefficient(node, neighbor);
            temperatureSum += neighbor.temperature * coefficient;
            coefficientSum += coefficient;
        }
        if (coefficientSum === 0) {
            // No neighbors, maintain current temperature
            newTemperatures.set(node, currentTemperature);
            return;
        }
        const averageTemperature = temperatureSum / coefficientSum;
        const diff = averageTemperature - currentTemperature;
        // Check if there's a point at this location
        const hasPoint = node.hasPoints;
        const heatCapacity = hasPoint ? this.getHeatCapacityAt(node.x, node.y) : 1;
        const temperatureToShare = diff * temperatureShareFactor / heatCapacity;
        let newTemperature = currentTemperature + temperatureToShare;
        newTemperatures.set(node, newTemperature);
    }
    // Get all neighboring nodes of a leaf node
    static getNeighborsOf(node) {
        if (!node.isLeaf) throw new Error("getNeighborsOf can only be called on leaf nodes");
        const neighbors = [];
        // Check all 8 directions
        const directions = [
            {
                dx: -1,
                dy: -1
            },
            {
                dx: 0,
                dy: -1
            },
            {
                dx: 1,
                dy: -1
            },
            {
                dx: -1,
                dy: 0
            },
            {
                dx: 1,
                dy: 0
            },
            {
                dx: -1,
                dy: 1
            },
            {
                dx: 0,
                dy: 1
            },
            {
                dx: 1,
                dy: 1
            }
        ];
        if (!this.root) return neighbors;
        for (const { dx: dx, dy: dy } of directions){
            // For simplicity, we'll just check the center point of each direction
            const x = node.x + node.size / 2 + dx * node.size;
            const y = node.y + node.size / 2 + dy * node.size;
            const neighborNode = this.root.getLeafAt(x, y);
            if (neighborNode && neighborNode !== node) neighbors.push(neighborNode);
        }
        return neighbors;
    }
    // Get the coefficient for a neighbor based on its position
    static getNeighborCoefficient(node, neighbor) {
        // Determine if this is a diagonal neighbor
        const isDiagonal = neighbor.x !== node.x && neighbor.y !== node.y;
        // Base coefficient
        let coefficient = isDiagonal ? $2ae2627a22c7a745$var$DIAGONAL_COEFFICIENT : $2ae2627a22c7a745$var$NORMAL_COEFFICIENT;
        // Check if the neighbor is outside bounds
        const bounds = (0, $bab86e660d8728eb$export$c4e9d269599ab4b4).getBounds();
        if (neighbor.x < bounds.left || neighbor.x + neighbor.size > bounds.right + 1 || neighbor.y < bounds.top || neighbor.y + neighbor.size > bounds.bottom + 1) coefficient = $2ae2627a22c7a745$var$BOUNDARY_COEFFICIENT;
        // Apply heat capacity if there's a point
        if (neighbor.hasPoints) coefficient *= this.getHeatCapacityAt(neighbor.x, neighbor.y);
        return coefficient;
    }
    // Get the heat capacity at a specific location
    static getHeatCapacityAt(x, y) {
        const point = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPointByCoordinates({
            x: x,
            y: y
        });
        if (!point) return $2ae2627a22c7a745$var$DEFAULT_HEAT_CAPACITY;
        return (0, $635f7a435680582b$export$cd5d22869177bd58)[point.type] ?? $2ae2627a22c7a745$var$DEFAULT_HEAT_CAPACITY;
    }
    // Update all points with temperatures from the tree
    static updatePointsFromTree() {
        for (const { point: point, node: node } of this.pointsMap.values())point.data.temperature = node.temperature;
    }
    // Get the temperature at a specific location
    static getTemperatureAt(x, y) {
        if (!this.root) return (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getBaseTemperature();
        const node = this.root.getLeafAt(x, y);
        const temp = node ? node.temperature : (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getBaseTemperature();
        if (isNaN(temp)) return (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getBaseTemperature();
        return temp;
    }
    // Apply a global pull toward base temperature for all air cells
    static applyGlobalBasePull(node, baseTemperature) {
        if (node.isLeaf) // Only apply to air cells (no points)
        {
            if (!node.hasPoints) {
                const diff = baseTemperature - node.temperature;
                // Apply a strong pull toward base temperature (20% per frame)
                node.temperature += diff * $2ae2627a22c7a745$var$BASE_PULL_FACTOR;
            }
        } else if (node.children) // Recursively process all children
        for (const child of node.children)this.applyGlobalBasePull(child, baseTemperature);
    }
}


class $f401cf2536c45f5a$export$a83c692ac725e2ca {
    static{
        this.temperatureGrid = (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).get("TemperatureGrid.temperatureGrid", []);
    }
    static save() {
        (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).set("TemperatureGrid.temperatureGrid", this.temperatureGrid);
    }
    static getMinTemperature() {
        return Math.min(...this.temperatureGrid.flat());
    }
    static getMaxTemperature() {
        return Math.max(...this.temperatureGrid.flat());
    }
    static initGrid() {
        // Initialize both the traditional grid and the quadtree
        const baseTemperature = (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getBaseTemperature();
        const bounds = (0, $bab86e660d8728eb$export$c4e9d269599ab4b4).getBounds();
        this.temperatureGrid = [];
        for(let x = bounds.left; x <= bounds.right; x++)for(let y = bounds.top; y <= bounds.bottom; y++)this.setTemperatureOnPoint(x, y, baseTemperature);
        // Initialize the quadtree
        (0, $2ae2627a22c7a745$export$27d7857d42cf741d).init();
    }
    static setTemperatureOnPoint(x, y, temperature) {
        if (!this.temperatureGrid[x]) this.temperatureGrid[x] = [];
        this.temperatureGrid[x][y] = temperature;
    }
    static updateGridFromPoints() {
        const baseTemperature = (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getBaseTemperature();
        const points = [
            ...(0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPoints()
        ];
        for (const point of points){
            const x = point.coordinates.x;
            const y = point.coordinates.y;
            this.setTemperatureOnPoint(x, y, point.data.temperature ?? baseTemperature);
        }
        // Update the quadtree from points
        (0, $2ae2627a22c7a745$export$27d7857d42cf741d).updateFromPoints();
        this.save();
    }
    static getTemperatureOnPoint(x, y) {
        // Use the quadtree for temperature lookup
        return (0, $2ae2627a22c7a745$export$27d7857d42cf741d).getTemperatureAt(x, y);
    }
    static processTemperatureFrame() {
        // Use the quadtree for temperature processing
        (0, $2ae2627a22c7a745$export$27d7857d42cf741d).processTemperatureFrame();
        // For backward compatibility, we'll also update our traditional grid
        // from the quadtree results
        this.updateTraditionalGridFromQuadTree();
    }
    static updateTraditionalGridFromQuadTree() {
        const bounds = (0, $bab86e660d8728eb$export$c4e9d269599ab4b4).getBounds();
        for(let x = bounds.left; x <= bounds.right; x++)for(let y = bounds.top; y <= bounds.bottom; y++){
            const temperature = (0, $2ae2627a22c7a745$export$27d7857d42cf741d).getTemperatureAt(x, y);
            this.setTemperatureOnPoint(x, y, temperature);
        }
        this.save();
    }
    static updatePointsFromGrid() {
        // Use the quadtree to update points
        (0, $2ae2627a22c7a745$export$27d7857d42cf741d).updatePointsFromTree();
        // For backward compatibility, also update from our traditional grid
        const points = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPoints();
        for (const point of points){
            const temperatureForPoint = this.getTemperatureOnPoint(point.coordinates.x, point.coordinates.y);
            point.data.temperature = temperatureForPoint;
        }
        this.save();
    }
}


class $bab86e660d8728eb$export$c4e9d269599ab4b4 {
    static{
        this._bounds = (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).get('bounds', {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        });
    }
    static{
        this.witdh = (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).get('width', 0);
    }
    static{
        this.height = (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).get('height', 0);
    }
    static set bounds(bounds) {
        $bab86e660d8728eb$export$c4e9d269599ab4b4._bounds = bounds;
        $bab86e660d8728eb$export$c4e9d269599ab4b4.witdh = bounds.right - bounds.left;
        $bab86e660d8728eb$export$c4e9d269599ab4b4.height = bounds.bottom - bounds.top;
        (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).set('bounds', bounds);
        (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).set('width', $bab86e660d8728eb$export$c4e9d269599ab4b4.witdh);
        (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).set('height', $bab86e660d8728eb$export$c4e9d269599ab4b4.height);
    }
    static get bounds() {
        return $bab86e660d8728eb$export$c4e9d269599ab4b4._bounds;
    }
    static getBounds() {
        return $bab86e660d8728eb$export$c4e9d269599ab4b4.bounds;
    }
    static getWidth() {
        return $bab86e660d8728eb$export$c4e9d269599ab4b4.witdh;
    }
    static getHeight() {
        return $bab86e660d8728eb$export$c4e9d269599ab4b4.height;
    }
    static setBounds(bounds) {
        const areBoundsNew = $bab86e660d8728eb$export$c4e9d269599ab4b4.bounds.top === 0 && $bab86e660d8728eb$export$c4e9d269599ab4b4.bounds.right === 0 && $bab86e660d8728eb$export$c4e9d269599ab4b4.bounds.bottom === 0 && $bab86e660d8728eb$export$c4e9d269599ab4b4.bounds.left === 0;
        const areBoundsEqual = $bab86e660d8728eb$export$c4e9d269599ab4b4.bounds.top === bounds.top && $bab86e660d8728eb$export$c4e9d269599ab4b4.bounds.right === bounds.right && $bab86e660d8728eb$export$c4e9d269599ab4b4.bounds.bottom === bounds.bottom && $bab86e660d8728eb$export$c4e9d269599ab4b4.bounds.left === bounds.left;
        $bab86e660d8728eb$export$c4e9d269599ab4b4.bounds = bounds;
        if (!areBoundsNew && !areBoundsEqual) (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).deleteAllPoints();
        if (areBoundsNew || !areBoundsEqual) (0, $f401cf2536c45f5a$export$a83c692ac725e2ca).initGrid();
        const points = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPoints();
        for (const point of points)if (point.type === (0, $25746eb61037a613$export$873e90337ab80c46).Border && point.data?.isFromBounds) (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).deletePoint(point);
        // top
        for(let x = bounds.left - 1; x < bounds.right + 2; x++)(0, $8c2070529dc8eec8$export$1c787534cb11aa3e).addPoint({
            type: (0, $25746eb61037a613$export$873e90337ab80c46).Border,
            coordinates: {
                x: x,
                y: bounds.top - 1
            },
            speed: {
                x: 0,
                y: 0
            },
            data: {
                isFromBounds: true
            }
        });
        // right
        for(let y = bounds.top - 1; y < bounds.bottom + 1; y++)(0, $8c2070529dc8eec8$export$1c787534cb11aa3e).addPoint({
            type: (0, $25746eb61037a613$export$873e90337ab80c46).Border,
            coordinates: {
                x: bounds.right,
                y: y
            },
            speed: {
                x: 0,
                y: 0
            },
            data: {
                isFromBounds: true
            }
        });
        // bottom
        for(let x = bounds.left - 1; x < bounds.right + 1; x++)(0, $8c2070529dc8eec8$export$1c787534cb11aa3e).addPoint({
            type: (0, $25746eb61037a613$export$873e90337ab80c46).Border,
            coordinates: {
                x: x,
                y: bounds.bottom
            },
            speed: {
                x: 0,
                y: 0
            },
            data: {
                isFromBounds: true
            }
        });
        // left
        for(let y = bounds.top - 1; y < bounds.bottom + 1; y++)(0, $8c2070529dc8eec8$export$1c787534cb11aa3e).addPoint({
            type: (0, $25746eb61037a613$export$873e90337ab80c46).Border,
            coordinates: {
                x: bounds.left - 1,
                y: y
            },
            speed: {
                x: 0,
                y: 0
            },
            data: {
                isFromBounds: true
            }
        });
        (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).save();
    }
}



class $f243af196a25f578$export$f3ea0776119f0e84 {
    static{
        this.connections = (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).get('Connections', []);
    }
    static saveConnections() {
        this.mergeConnections();
        (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).set('Connections', this.connections);
    }
    static deleteAllConnections() {
        this.connections = [];
        this.saveConnections();
    }
    static mergeConnections() {
        let wasChanged = false;
        for (const conn of this.connections){
            const toX = conn.to.x;
            const toY = conn.to.y;
            if (conn.to.x === conn.from.x && conn.to.y === conn.from.y) {
                this.removeConnection(conn);
                wasChanged = true;
                continue;
            }
            for (const otherConn of this.connections){
                if (otherConn === conn) continue;
                if (otherConn.from.x === toX && otherConn.from.y === toY) {
                    conn.to = otherConn.to;
                    this.removeConnection(otherConn);
                    wasChanged = true;
                    break;
                }
            }
        }
        if (wasChanged) this.saveConnections();
    }
    static addConnection(connection) {
        this.connections.push(connection);
        this.saveConnections();
    }
    static removeConnection(connection) {
        this.connections = this.connections.filter((c)=>!(c.from.x === connection.from.x && c.from.y === connection.from.y && c.to.x === connection.to.x && c.to.y === connection.to.y && c.type === connection.type));
        this.saveConnections();
    }
    static getConnectionFromOrTo(coordinates) {
        return this.connections.filter((c)=>c.from.x === coordinates.x && c.from.y === coordinates.y || c.to.x === coordinates.x && c.to.y === coordinates.y);
    }
    static getWireFromPoint(coordinates) {
        return this.connections.filter((c)=>c.from.x === coordinates.x && c.from.y === coordinates.y && c.type === 'wire');
    }
    static getPipeFromPoint(coordinates) {
        return this.connections.filter((c)=>c.from.x === coordinates.x && c.from.y === coordinates.y && c.type === 'pipe');
    }
    static getAllConnections() {
        return [
            ...this.connections
        ];
    }
}








const $0db6937e29869b9b$var$distance = (a, b)=>{
    return (a.x - b.x) ** 2 + (a.y - b.y) ** 2;
};
class $0db6937e29869b9b$export$60c0aaabc4c77337 {
    static shufflePossibleNeighbours() {
        $0db6937e29869b9b$export$60c0aaabc4c77337.possibleNeighbours = (0, $8e9b18f56b659120$export$267b06a7460aa7d3)($0db6937e29869b9b$export$60c0aaabc4c77337.possibleNeighbours);
    }
    static{
        this.self = {
            x: 0,
            y: 0
        };
    }
    static{
        this.rounded = {
            left: {
                x: -1,
                y: 0
            },
            right: {
                x: 1,
                y: 0
            },
            up: {
                x: 0,
                y: -1
            },
            down: {
                x: 0,
                y: 1
            },
            leftUp: {
                x: -1,
                y: -1
            },
            rightUp: {
                x: 1,
                y: -1
            },
            leftDown: {
                x: -1,
                y: 1
            },
            rightDown: {
                x: 1,
                y: 1
            },
            topLeft: {
                x: -1,
                y: -1
            },
            topRight: {
                x: 1,
                y: -1
            },
            bottomLeft: {
                x: -1,
                y: 1
            },
            bottomRight: {
                x: 1,
                y: 1
            }
        };
    }
    static{
        this.possibleNeighbours = [
            $0db6937e29869b9b$export$60c0aaabc4c77337.rounded.left,
            $0db6937e29869b9b$export$60c0aaabc4c77337.rounded.right,
            $0db6937e29869b9b$export$60c0aaabc4c77337.rounded.up,
            $0db6937e29869b9b$export$60c0aaabc4c77337.rounded.down,
            $0db6937e29869b9b$export$60c0aaabc4c77337.rounded.leftUp,
            $0db6937e29869b9b$export$60c0aaabc4c77337.rounded.rightUp,
            $0db6937e29869b9b$export$60c0aaabc4c77337.rounded.leftDown,
            $0db6937e29869b9b$export$60c0aaabc4c77337.rounded.rightDown
        ];
    }
    static getRoundedSpeed(point, exceptNeighbours = false, possibleNeighbours = $0db6937e29869b9b$export$60c0aaabc4c77337.possibleNeighbours) {
        const { speed: speed, type: type } = point;
        const vectorLength = Math.sqrt(speed.x ** 2 + speed.y ** 2);
        if (vectorLength < 0.01) return {
            x: 0,
            y: 0
        };
        const normalizedSpeed = {
            x: speed.x / vectorLength,
            y: speed.y / vectorLength
        };
        const neighbours = exceptNeighbours ? (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getNeighbours(point) : [];
        let maxDistance = -Infinity;
        const distances = new Array(possibleNeighbours.length);
        for(let i = 0; i < possibleNeighbours.length; i++){
            const d = $0db6937e29869b9b$var$distance(normalizedSpeed, possibleNeighbours[i]);
            distances[i] = d;
            if (d > maxDistance) maxDistance = d;
        }
        const probabilities = new Array(distances.length);
        let sum = 0;
        for(let i = 0; i < distances.length; i++){
            probabilities[i] = maxDistance - distances[i];
            sum += probabilities[i];
        }
        const probabilityModifier = (0, $a1b3895d2b1f2262$export$15a7dd6201a8849f)[type] ?? 0.2;
        const averageProbability = sum / (distances.length * sum);
        const validSpeeds = [];
        for(let i = 0; i < probabilities.length; i++){
            const normalizedProb = probabilities[i] / sum;
            if (normalizedProb <= averageProbability) continue;
            if (exceptNeighbours) {
                const speed = possibleNeighbours[i];
                const isNeighbour = neighbours.some((neighbour)=>neighbour.coordinates.x === point.coordinates.x + speed.x && neighbour.coordinates.y === point.coordinates.y + speed.y && neighbour !== point);
                if (isNeighbour) continue;
            }
            validSpeeds.push({
                probability: normalizedProb * probabilityModifier,
                index: i
            });
        }
        if (validSpeeds.length > 0) {
            const randomValue = (0, $6de2ed3e5d01eb29$export$4385e60b38654f68)();
            for(let i = 0; i < validSpeeds.length; i++){
                if (randomValue < validSpeeds[i].probability) return possibleNeighbours[validSpeeds[i].index];
            }
        }
        let maxProbability = 0;
        let maxProbabilityIndex = 0;
        for(let i = 0; i < probabilities.length; i++)if (probabilities[i] > maxProbability) {
            maxProbability = probabilities[i];
            maxProbabilityIndex = i;
        }
        return possibleNeighbours[maxProbabilityIndex];
    }
}



class $3a70ac1fe66fc73f$export$beda572814268322 {
    static{
        this.vectors = {};
    }
    static{
        this.cache = {};
    }
    static{
        this.cacheHits = 0;
    }
    static{
        this.cacheMisses = 0;
    }
    static clearCache() {
        this.cache = {};
    }
    static getVectorsCount() {
        return Object.keys(this.vectors).length;
    }
    static getCacheStats() {
        return {
            hits: this.cacheHits,
            misses: this.cacheMisses
        };
    }
    static addVector(coordinates, vector) {
        const key = `${coordinates.x},${coordinates.y}`;
        if (this.vectors[key]) {
            const isSame = this.vectors[key].strength === vector.strength && this.vectors[key].radius === vector.radius && this.vectors[key].x === vector.x && this.vectors[key].y === vector.y;
            if (isSame) return;
        }
        this.vectors[key] = vector;
        this.clearCache();
    }
    static removeVector(coordinates) {
        const key = `${coordinates.x},${coordinates.y}`;
        delete this.vectors[key];
        this.clearCache();
    }
    static getVectorsAffectingPoint(coordinates) {
        const cacheKey = `${coordinates.x},${coordinates.y}`;
        if (this.cache[cacheKey]) {
            this.cacheHits++;
            return this.cache[cacheKey];
        }
        this.cacheMisses++;
        const result = [];
        Object.entries(this.vectors).forEach(([key, vector])=>{
            const [sourceX, sourceY] = key.split(',').map(Number);
            const dx = coordinates.x - sourceX;
            const dy = coordinates.y - sourceY;
            const distance = Math.sqrt(dx * dx + dy * dy);
            if (distance <= vector.radius) {
                // Strength decreases with distance
                const effectiveStrength = vector.strength * (1 - distance / vector.radius);
                result.push({
                    ...vector,
                    strength: effectiveStrength
                });
            }
        });
        this.cache[cacheKey] = result;
        return result;
    }
    static clearVectors() {
        this.vectors = {};
        this.clearCache();
    }
}


class $8c2070529dc8eec8$export$1c787534cb11aa3e {
    static{
        this._points = [];
    }
    static{
        this.coordinatesIndex = (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).get('coordinatesIndex', {});
    }
    static{
        this.unusedPoints = new WeakSet();
    }
    static{
        this.idCounter = (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).get('idCounter', 0);
    }
    static init() {
        this.updatePoints();
        for (const point of this._points)this.checkPointIsLightSource(point);
    }
    static onPointUpdated(point) {
        this.checkPointIsLightSource(point);
    }
    static checkPointIsLightSource(point) {
        if ((0, $8cf8e02aa778f380$export$1477cfa3b314a285)[point.type]) (0, $57a22ed606f2167f$export$3e593816f425a913).addLightSourcePoint(point);
        else (0, $57a22ed606f2167f$export$3e593816f425a913).removeLightSourcePoint(point);
    }
    static deleteAllPoints() {
        this._points = [];
        this.coordinatesIndex = {};
        this.unusedPoints = new WeakSet();
        (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).set('wasInit', false);
        (0, $f243af196a25f578$export$f3ea0776119f0e84).deleteAllConnections();
    }
    static isUnused(point) {
        return this.unusedPoints.has(point);
    }
    static markPointAsUnused(point) {
        if ((0, $360a87d5b9cd525c$export$508f9609af06e33b)[point.type]) return;
        this.unusedPoints.add(point);
    }
    static markPointAsUsed(point) {
        this.unusedPoints.delete(point);
        point.lastMoveOnIteration = (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).get('iteration', 0);
    }
    static markNeighboursAsUsed(point) {
        this.markPointAsUsed(point);
        for(let x = -2; x <= 2; x++)for(let y = -2; y <= 2; y++){
            const neighbour = this.getPointByCoordinates({
                x: point.coordinates.x + x,
                y: point.coordinates.y + y
            });
            if (neighbour) this.markPointAsUsed(neighbour);
        }
    }
    static shufflePoints() {
        this._points = (0, $8e9b18f56b659120$export$267b06a7460aa7d3)(this._points);
    }
    static updatePoints() {
        this._points = (0, $8e9b18f56b659120$export$267b06a7460aa7d3)(Object.values(this.coordinatesIndex).filter(Boolean));
    }
    static deletePointInIndex(coordinates) {
        const point = this.getPointByCoordinates(coordinates);
        if (point) this.markNeighboursAsUsed(point);
        delete this.coordinatesIndex[this.getIndexIndex(coordinates)];
    }
    static getIndexIndex(coordinates) {
        const width = (0, $bab86e660d8728eb$export$c4e9d269599ab4b4).getWidth();
        const i = coordinates.y * width + coordinates.x;
        return i;
    }
    static setPointInIndex(coordinates, point) {
        if (point.wasDeleted) return;
        const pointThere = this.getPointByCoordinates(coordinates);
        if (pointThere && point !== pointThere) throw new Error(`Point already exists at ${coordinates.x}:${coordinates.y}`);
        if (point === pointThere) return;
        this.unusedPoints.delete(point);
        point.lastMoveOnIteration = (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).get('iteration', 0);
        point.coordinates = {
            ...coordinates
        };
        this.coordinatesIndex[this.getIndexIndex(coordinates)] = point;
    }
    static getPointByCoordinates(coordinates) {
        return this.coordinatesIndex[this.getIndexIndex(coordinates)];
    }
    static addPoint(point) {
        if (this.getPointByCoordinates(point.coordinates)) return;
        const availablePointsCount = (0, $bab86e660d8728eb$export$c4e9d269599ab4b4).getWidth() * (0, $bab86e660d8728eb$export$c4e9d269599ab4b4).getHeight();
        if (this._points.length >= availablePointsCount * 0.95) {
            console.warn('Too many points, skipping', point);
            return;
        }
        const pointWithData = {
            data: {},
            ...point,
            id: this.idCounter++,
            visualCoordinates: {
                ...point.coordinates
            },
            colorVariation: Math.random() * 2 - 1 // Random value between -1 and 1
        };
        if (!pointWithData.data) pointWithData.data = {};
        if (!pointWithData.data.temperature) pointWithData.data.temperature = (0, $de0cf5fb31f39b4f$export$f50ca6dc0891673f)[point.type] ?? (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getBaseTemperature();
        this.checkPointIsLightSource(pointWithData);
        this.setPointInIndex(point.coordinates, pointWithData);
        this._points.push(pointWithData);
        this.markNeighboursAsUsed(pointWithData);
        this.save();
        return pointWithData;
    }
    static get points() {
        return this._points;
    }
    static save() {
        (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).set('coordinatesIndex', this.coordinatesIndex);
        (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).set('idCounter', this.idCounter);
    }
    static deletePoint(point) {
        this.markNeighboursAsUsed(point);
        if (point.type === (0, $25746eb61037a613$export$873e90337ab80c46).WindSource) (0, $3a70ac1fe66fc73f$export$beda572814268322).clearVectors();
        const pointByCoordinates = this.getPointByCoordinates(point.coordinates);
        if (pointByCoordinates === point) {
            this.deletePointInIndex(point.coordinates);
            point.wasDeleted = true;
            this.updatePoints();
        } else if (pointByCoordinates) console.warn('Point not found by coordinates', point);
        if ((0, $8cf8e02aa778f380$export$1477cfa3b314a285)[point.type]) (0, $57a22ed606f2167f$export$3e593816f425a913).removeLightSourcePoint(point);
    }
    static getPoints() {
        return this.points;
    }
    static getPossibleNeighbours(distance = 1) {
        if (distance === 0) return [];
        if (distance === 1) return (0, $0db6937e29869b9b$export$60c0aaabc4c77337).possibleNeighbours;
        const possiblePositions = [];
        for(let x = -distance; x <= distance; x++)for(let y = -distance; y <= distance; y++){
            if (x === 0 && y === 0) continue;
            possiblePositions.push({
                x: x,
                y: y
            });
        }
        return possiblePositions;
    }
    static getPointsNear(coordinates, withBorder = true, distance = 1) {
        const points = [];
        const possiblePositions = this.getPossibleNeighbours(distance);
        for (const neighbourPosition of possiblePositions){
            const pointByCoordinates = this.getPointByCoordinates({
                x: coordinates.x + neighbourPosition.x,
                y: coordinates.y + neighbourPosition.y
            });
            if (pointByCoordinates) {
                if (!withBorder && pointByCoordinates.type === (0, $25746eb61037a613$export$873e90337ab80c46).Border) continue;
                points.push(pointByCoordinates);
            }
        }
        return points;
    }
    static getActivePoints() {
        return this.points.filter((point)=>{
            if (point.type === (0, $25746eb61037a613$export$873e90337ab80c46).Border) return false;
            if (point.wasDeleted) return false;
            return true;
        });
    }
    static getNeighbours(point, withBorder = true, distance = 1) {
        return this.getPointsNear(point.coordinates, withBorder, distance);
    }
    static getPointBySpeed(fromPoint, roundedSpeed) {
        const { coordinates: coordinates } = fromPoint;
        const targetCoordinates = {
            x: coordinates.x + roundedSpeed.x,
            y: coordinates.y + roundedSpeed.y
        };
        return this.getPointByCoordinates(targetCoordinates);
    }
    static updateVisualCoordinates(interpolationFactor) {
        // @ts-ignore
        window.lastUpdateVisualCoordinatesInterpolationFactor = interpolationFactor;
        // If smooth movement is disabled, snap all points to their actual positions
        if (!(0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getIsSmoothMovementEnabled()) {
            for (const point of this._points)if (point.visualCoordinates) {
                point.visualCoordinates.x = point.coordinates.x;
                point.visualCoordinates.y = point.coordinates.y;
            } else point.visualCoordinates = {
                ...point.coordinates
            };
            return;
        }
        for (const point of this._points){
            if (!point.visualCoordinates) {
                point.visualCoordinates = {
                    ...point.coordinates
                };
                continue;
            }
            // Calculate distance between visual and actual coordinates
            const dx = point.coordinates.x - point.visualCoordinates.x;
            const dy = point.coordinates.y - point.visualCoordinates.y;
            // If the distance is very small, snap to the actual position
            if (Math.abs(dx) < 0.0001 && Math.abs(dy) < 0.0001) {
                point.visualCoordinates.x = point.coordinates.x;
                point.visualCoordinates.y = point.coordinates.y;
                continue;
            }
            // Smoothly interpolate between current visual position and actual position
            point.visualCoordinates.x += dx * interpolationFactor;
            point.visualCoordinates.y += dy * interpolationFactor;
        }
    }
}




const $4c0f0ee047d80e21$export$67ea982130081db = document.getElementById('canvas');
const $4c0f0ee047d80e21$export$94c3e10bf18350c = document.getElementById('lightCanvas');
const $4c0f0ee047d80e21$export$39f92e86d1722f3a = $4c0f0ee047d80e21$export$67ea982130081db.getContext('2d');
const $4c0f0ee047d80e21$export$1482ba6ca761618 = $4c0f0ee047d80e21$export$94c3e10bf18350c.getContext('2d');
const $4c0f0ee047d80e21$export$7f545ebf1bdfb9fd = ()=>{
    const boardWidth = Math.floor(window.innerWidth / (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize);
    const boardHeight = Math.floor(window.innerHeight / (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize);
    $4c0f0ee047d80e21$export$67ea982130081db.width = boardWidth * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize;
    $4c0f0ee047d80e21$export$67ea982130081db.height = boardHeight * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize;
    $4c0f0ee047d80e21$export$94c3e10bf18350c.width = boardWidth * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize;
    $4c0f0ee047d80e21$export$94c3e10bf18350c.height = boardHeight * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize;
    (0, $bab86e660d8728eb$export$c4e9d269599ab4b4).setBounds({
        top: 0,
        right: boardWidth,
        bottom: boardHeight,
        left: 0
    });
    $4c0f0ee047d80e21$export$39f92e86d1722f3a.fillStyle = 'white';
    $4c0f0ee047d80e21$export$39f92e86d1722f3a.fillRect(0, 0, $4c0f0ee047d80e21$export$67ea982130081db.width, $4c0f0ee047d80e21$export$67ea982130081db.height);
    $4c0f0ee047d80e21$export$1482ba6ca761618.fillStyle = 'rgba(0, 0, 0, 0)';
    $4c0f0ee047d80e21$export$1482ba6ca761618.fillRect(0, 0, $4c0f0ee047d80e21$export$94c3e10bf18350c.width, $4c0f0ee047d80e21$export$94c3e10bf18350c.height);
};






const $fac5033712cbc0e8$export$40edfb7eeb78c4e8 = false;





const $8a53c0929bfa4893$export$e486465b517b3350 = {
    [(0, $25746eb61037a613$export$873e90337ab80c46).Smoke]: 'Smoke',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Water]: 'Water',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Border]: 'Border',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Sand]: 'Sand',
    [(0, $25746eb61037a613$export$873e90337ab80c46).StaticSand]: 'Sand',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Stone]: 'Stone',
    [(0, $25746eb61037a613$export$873e90337ab80c46).StaticStone]: 'Static Stone',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Lava]: 'Lava',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Fire]: 'Fire',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Oil]: 'Oil',
    [(0, $25746eb61037a613$export$873e90337ab80c46).BurningOil]: 'Burning Oil',
    [(0, $25746eb61037a613$export$873e90337ab80c46).IceFire]: 'Ice Fire',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Bomb]: 'Bomb',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Ice]: 'Ice',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Steam]: 'Steam',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Void]: 'Void',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Clone]: 'Clone',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Gas]: 'Gas',
    [(0, $25746eb61037a613$export$873e90337ab80c46).FireEmitter]: 'Fire Emitter',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Wood]: 'Wood',
    [(0, $25746eb61037a613$export$873e90337ab80c46).BurningWood]: 'Burning Wood',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Dynamite]: 'Dynamite',
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidGas]: 'Liquid Gas',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Metal]: 'Metal',
    [(0, $25746eb61037a613$export$873e90337ab80c46).MoltenMetal]: 'Molten Metal',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Ground]: 'Electricity Ground',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Spark]: 'Electricity Spark',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Source]: 'Electricity Source',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Amplifier]: 'Electricity Amplifier',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Heater]: 'Heater',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Cooler]: 'Cooler',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Virus]: 'Virus',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Heal]: 'Heal',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Acid]: 'Acid',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Plant]: 'Plant',
    [(0, $25746eb61037a613$export$873e90337ab80c46).PlantSeed]: 'Plant Seed',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Glass]: 'Glass',
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidGlass]: 'Liquid Glass',
    [(0, $25746eb61037a613$export$873e90337ab80c46).ConstantCold]: 'Constant Cold',
    [(0, $25746eb61037a613$export$873e90337ab80c46).ConstantHot]: 'Constant Hot',
    [(0, $25746eb61037a613$export$873e90337ab80c46).ColdDetector]: 'Cold Detector',
    [(0, $25746eb61037a613$export$873e90337ab80c46).HotDetector]: 'Hot Detector',
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidDetector]: 'Liquid Detector',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Wire]: 'Wire',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Pipe]: 'Pipe',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Snow]: 'Snow',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Magnet]: 'Magnet',
    [(0, $25746eb61037a613$export$873e90337ab80c46).WindSource]: 'Wind Source',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Ant]: 'Ant',
    [(0, $25746eb61037a613$export$873e90337ab80c46).FireAnt]: 'Fire Ant',
    [(0, $25746eb61037a613$export$873e90337ab80c46).IceAnt]: 'Ice Ant',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Worm]: 'Worm',
    [(0, $25746eb61037a613$export$873e90337ab80c46).LightSource]: 'Light Source',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Mirror]: 'Mirror',
    [(0, $25746eb61037a613$export$873e90337ab80c46).LightDetector]: 'Light Detector',
    [(0, $25746eb61037a613$export$873e90337ab80c46).LightBulb]: 'Light Bulb'
};



let $b3061062413ea8d6$export$ecc9565f40160774 = null;
let $b3061062413ea8d6$export$9c55e7f59a726e = null;
let $b3061062413ea8d6$export$a908bacd8fc58efd = false;
let $b3061062413ea8d6$export$aa312658ee6f0824 = 0;
let $b3061062413ea8d6$export$cab8fead4289574 = 0;
let $b3061062413ea8d6$var$drawingInterval = null;
let $b3061062413ea8d6$var$drawingStartPoint = null;
let $b3061062413ea8d6$var$isShiftPressed = false;
let $b3061062413ea8d6$var$isHorizontalMode = null;
const $b3061062413ea8d6$var$hoveredPointDescriptionElement = document.createElement('div');
$b3061062413ea8d6$var$hoveredPointDescriptionElement.classList.add('hovered-point-description');
$b3061062413ea8d6$var$hoveredPointDescriptionElement.classList.add('hidden');
document.body.appendChild($b3061062413ea8d6$var$hoveredPointDescriptionElement);
const $b3061062413ea8d6$var$IGNORED_KEYS = [
    'temperature',
    'speed',
    'visualCoordinates',
    'wasDeleted',
    'coordinates'
];
const $b3061062413ea8d6$var$getVectorDiv = (vector)=>{
    const normalizedVector = {
        x: vector.x / Math.sqrt(vector.x ** 2 + vector.y ** 2),
        y: vector.y / Math.sqrt(vector.x ** 2 + vector.y ** 2)
    };
    if (!normalizedVector.x && !normalizedVector.y) return `<div class="vector-container">
            <div class="vector-dot"></div>
        </div>`;
    return `<div class="vector-container">
        <div class="vector-arrow" style="transform: rotate(${Math.atan2(normalizedVector.y, normalizedVector.x) * 180 / Math.PI}deg);"></div>
    </div>`;
};
const $b3061062413ea8d6$var$camelCaseToLabel = (key)=>{
    return key.replace(/([A-Z])/g, ' $1').replace(/^./, function(str) {
        return str.toUpperCase();
    });
};
const $b3061062413ea8d6$var$renderDataPair = (key, value)=>{
    if ($b3061062413ea8d6$var$IGNORED_KEYS.includes(key)) return null;
    const label = $b3061062413ea8d6$var$camelCaseToLabel(key);
    if (value === null) return `${label}: empty`;
    if (typeof value === 'number') return `${label}: ${Math.round(value * 100) / 100}`;
    if (typeof value === 'boolean') return `${label}: ${value ? 'Yes' : 'No'}`;
    if (typeof value === 'object') {
        const vectorValue = value;
        if (typeof vectorValue.x === 'number' && typeof vectorValue.y === 'number') return `${label}: ${$b3061062413ea8d6$var$getVectorDiv(vectorValue)}`;
        const keyValuePairs = Object.entries(value).map(([key, value])=>$b3061062413ea8d6$var$renderDataPair(key, value)).filter(Boolean).map((pair)=>`&nbsp;&nbsp;&nbsp;&nbsp;${pair}`).join('<br>');
        if (!keyValuePairs.trim()) return null;
        return `${label}:<br>${keyValuePairs}`;
    }
    if (typeof value === 'string') return `${label}: ${value}`;
    if (Array.isArray(value)) return value.map((item)=>$b3061062413ea8d6$var$renderDataPair(key, item)).filter(Boolean).join('<br>');
    return `${label}: ${value}`;
};
const $b3061062413ea8d6$var$getDescription = (point)=>{
    return [
        `${point.coordinates.x}:${point.coordinates.y} ${(0, $8a53c0929bfa4893$export$e486465b517b3350)[point.type] ?? point.type} #${point.id}`,
        `${Math.round(point.data.temperature)} \xb0C`,
        `Light: ${Math.round((0, $57a22ed606f2167f$export$3e593816f425a913).getLightIntensity(point.coordinates.x, point.coordinates.y) * 1000)}`,
        `Speed: ${Math.round(Math.sqrt(point.speed.x ** 2 + point.speed.y ** 2) * 100) / 100} ${$b3061062413ea8d6$var$getVectorDiv(point.speed)}`,
        ...Object.entries(point.data).map(([key, value])=>$b3061062413ea8d6$var$renderDataPair(key, value)).filter(Boolean)
    ].join('<br>');
};
const $b3061062413ea8d6$var$updateHoveredPointDescription = ()=>{
    const brushSize = (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getBrushSize();
    const pointX = $b3061062413ea8d6$export$ecc9565f40160774?.coordinates.x;
    const pointY = $b3061062413ea8d6$export$ecc9565f40160774?.coordinates.y;
    const hoveredX = $b3061062413ea8d6$export$9c55e7f59a726e?.x;
    const hoveredY = $b3061062413ea8d6$export$9c55e7f59a726e?.y;
    if ($b3061062413ea8d6$export$ecc9565f40160774 && pointX === hoveredX && pointY === hoveredY && typeof pointX === 'number' && typeof pointY === 'number') {
        $b3061062413ea8d6$var$hoveredPointDescriptionElement.classList.remove('hidden');
        $b3061062413ea8d6$var$hoveredPointDescriptionElement.innerHTML = $b3061062413ea8d6$var$getDescription($b3061062413ea8d6$export$ecc9565f40160774);
        // Calculate position
        let posX = pointX * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize + 15 * brushSize;
        let posY = pointY * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize - 10 * brushSize;
        // Get window and element dimensions
        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;
        const elemWidth = $b3061062413ea8d6$var$hoveredPointDescriptionElement.offsetWidth;
        const elemHeight = $b3061062413ea8d6$var$hoveredPointDescriptionElement.offsetHeight;
        // Adjust positions if needed to stay within viewport
        if (posX + elemWidth > windowWidth) posX = windowWidth - elemWidth;
        if (posY + elemHeight > windowHeight) posY = windowHeight - elemHeight;
        // Ensure positions are never negative
        posX = Math.max(0, posX);
        posY = Math.max(0, posY);
        $b3061062413ea8d6$var$hoveredPointDescriptionElement.style.transform = `translate(${posX}px, ${posY}px)`;
    } else {
        $b3061062413ea8d6$var$hoveredPointDescriptionElement.classList.add('hidden');
        return;
    }
};
setInterval($b3061062413ea8d6$var$updateHoveredPointDescription, 50);
(0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).subscribe('brushSize', $b3061062413ea8d6$var$updateHoveredPointDescription);
// Temperature change amount per application
const $b3061062413ea8d6$var$HEAT_AMOUNT = 8;
const $b3061062413ea8d6$var$COOL_AMOUNT = -8;
const $b3061062413ea8d6$export$95d0815810fa2c63 = (element, events, callback)=>{
    events.forEach((event)=>{
        element.addEventListener(event, callback);
    });
};
const $b3061062413ea8d6$export$520c40045967cb15 = (x, y)=>{
    const brushSize = (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getBrushSize() - 1;
    const area = [];
    for(let i = -brushSize; i <= brushSize; i++)for(let j = -brushSize; j <= brushSize; j++)area.push({
        x: x + i,
        y: y + j
    });
    return area;
};
const $b3061062413ea8d6$var$createConnection = (x, y, drawingType)=>{
    const startPoint = (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getConnectionStartPoint();
    const endPoint = {
        x: x,
        y: y
    };
    if (startPoint && (startPoint.x !== endPoint.x || startPoint.y !== endPoint.y)) {
        // Add connection
        (0, $f243af196a25f578$export$f3ea0776119f0e84).addConnection({
            from: startPoint,
            to: endPoint,
            type: drawingType === (0, $25746eb61037a613$export$873e90337ab80c46).Wire ? 'wire' : 'pipe',
            lastUsed: 0
        });
        const pointOnStart = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPointByCoordinates(startPoint);
        if (pointOnStart) (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markNeighboursAsUsed(pointOnStart);
        const pointOnEnd = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPointByCoordinates(endPoint);
        if (pointOnEnd) (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markNeighboursAsUsed(pointOnEnd);
    }
    // Reset connection mode
    (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).setIsConnectionMode(false);
    (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).setConnectionStartPoint(null);
};
const $b3061062413ea8d6$export$ff927f87b332d562 = ()=>{
    $b3061062413ea8d6$export$95d0815810fa2c63((0, $4c0f0ee047d80e21$export$67ea982130081db), [
        'mousedown',
        'touchstart'
    ], (e)=>{
        const drawingType = (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getDrawingType();
        e.preventDefault();
        const offsetX = e.offsetX ?? e.touches[0].clientX ?? 0;
        const offsetY = e.offsetY ?? e.touches[0].clientY ?? 0;
        const x = Math.floor(offsetX / (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize);
        const y = Math.floor(offsetY / (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize);
        $b3061062413ea8d6$var$drawingStartPoint = {
            x: x,
            y: y
        };
        $b3061062413ea8d6$export$aa312658ee6f0824 = x;
        $b3061062413ea8d6$export$cab8fead4289574 = y;
        // Handle connection drawing (wire/pipe)
        if (drawingType === (0, $25746eb61037a613$export$873e90337ab80c46).Wire || drawingType === (0, $25746eb61037a613$export$873e90337ab80c46).Pipe) {
            if (!(0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getIsConnectionMode()) {
                (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).setIsConnectionMode(true);
                (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).setConnectionStartPoint({
                    x: x,
                    y: y
                });
            } else $b3061062413ea8d6$var$createConnection(x, y, drawingType);
            return;
        }
        // Regular drawing
        $b3061062413ea8d6$export$a908bacd8fc58efd = true;
        $b3061062413ea8d6$var$drawingInterval = setInterval(()=>{
            const points = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPoints();
            const neighboursAndSelf = $b3061062413ea8d6$export$520c40045967cb15(0, 0);
            if (drawingType === 'eraser') {
                neighboursAndSelf.forEach(({ x: x, y: y })=>{
                    const pointOnThisPlace = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPointByCoordinates({
                        x: $b3061062413ea8d6$export$aa312658ee6f0824 + x,
                        y: $b3061062413ea8d6$export$cab8fead4289574 + y
                    });
                    if (pointOnThisPlace) (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).deletePoint(pointOnThisPlace);
                    const connections = (0, $f243af196a25f578$export$f3ea0776119f0e84).getConnectionFromOrTo({
                        x: $b3061062413ea8d6$export$aa312658ee6f0824 + x,
                        y: $b3061062413ea8d6$export$cab8fead4289574 + y
                    });
                    for (const connection of connections)(0, $f243af196a25f578$export$f3ea0776119f0e84).removeConnection(connection);
                });
                return;
            }
            if (drawingType === 'heatTool' || drawingType === 'coolTool') {
                const temperatureChange = drawingType === 'heatTool' ? $b3061062413ea8d6$var$HEAT_AMOUNT : $b3061062413ea8d6$var$COOL_AMOUNT;
                neighboursAndSelf.forEach(({ x: x, y: y })=>{
                    const pointOnThisPlace = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPointByCoordinates({
                        x: $b3061062413ea8d6$export$aa312658ee6f0824 + x,
                        y: $b3061062413ea8d6$export$cab8fead4289574 + y
                    });
                    if (pointOnThisPlace) {
                        // Initialize temperature data if it doesn't exist
                        if (!pointOnThisPlace.data.temperature) pointOnThisPlace.data.temperature = (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getBaseTemperature();
                        // Apply temperature change
                        pointOnThisPlace.data.temperature += temperatureChange;
                        // Mark the point as used so it gets processed in the simulation
                        (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markPointAsUsed(pointOnThisPlace);
                    }
                });
                return;
            }
            neighboursAndSelf.forEach(({ x: x, y: y })=>{
                const pointThere = points.find((point)=>point.coordinates.x === $b3061062413ea8d6$export$aa312658ee6f0824 + x && point.coordinates.y === $b3061062413ea8d6$export$cab8fead4289574 + y);
                if (pointThere) {
                    if (!(0, $fac5033712cbc0e8$export$40edfb7eeb78c4e8)) return;
                }
                (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).addPoint({
                    coordinates: {
                        x: $b3061062413ea8d6$export$aa312658ee6f0824 + x,
                        y: $b3061062413ea8d6$export$cab8fead4289574 + y
                    },
                    type: drawingType,
                    speed: {
                        x: 0,
                        y: 0
                    },
                    data: {
                        ...(0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getDrawingData()
                    }
                });
            });
        }, 5);
    });
    // Add ESC key handler to cancel connection mode
    window.addEventListener("keydown", (e)=>{
        if (e.key === "Escape" && (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getIsConnectionMode()) {
            (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).setIsConnectionMode(false);
            (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).setConnectionStartPoint(null);
        }
        if (e.key === "Shift") $b3061062413ea8d6$var$isShiftPressed = true;
    });
    window.addEventListener("keyup", (e)=>{
        if (e.key === "Shift") $b3061062413ea8d6$var$isShiftPressed = false;
    });
    $b3061062413ea8d6$export$95d0815810fa2c63((0, $4c0f0ee047d80e21$export$67ea982130081db), [
        'mouseup',
        'touchend',
        'touchcancel',
        'mouseout'
    ], (e)=>{
        const drawingType = (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getDrawingType();
        if (drawingType === (0, $25746eb61037a613$export$873e90337ab80c46).Wire || drawingType === (0, $25746eb61037a613$export$873e90337ab80c46).Pipe) {
            if ((0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getIsConnectionMode()) $b3061062413ea8d6$var$createConnection($b3061062413ea8d6$export$aa312658ee6f0824, $b3061062413ea8d6$export$cab8fead4289574, drawingType);
        }
        $b3061062413ea8d6$export$a908bacd8fc58efd = false;
        if ($b3061062413ea8d6$var$drawingInterval) clearInterval($b3061062413ea8d6$var$drawingInterval);
        $b3061062413ea8d6$var$drawingStartPoint = null;
        $b3061062413ea8d6$var$isHorizontalMode = null;
        $b3061062413ea8d6$export$9c55e7f59a726e = null;
        $b3061062413ea8d6$export$ecc9565f40160774 = null;
        $b3061062413ea8d6$var$updateHoveredPointDescription();
    });
    $b3061062413ea8d6$export$95d0815810fa2c63((0, $4c0f0ee047d80e21$export$67ea982130081db), [
        'mousemove',
        'touchmove'
    ], (e)=>{
        e.preventDefault();
        const offsetX = e.offsetX ?? e.touches[0].clientX ?? 0;
        const offsetY = e.offsetY ?? e.touches[0].clientY ?? 0;
        const x = Math.floor(offsetX / (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize);
        const y = Math.floor(offsetY / (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize);
        if ($b3061062413ea8d6$export$a908bacd8fc58efd && $b3061062413ea8d6$var$isShiftPressed && $b3061062413ea8d6$var$drawingStartPoint) {
            if ($b3061062413ea8d6$var$isHorizontalMode === null) {
                const dx = Math.abs(x - $b3061062413ea8d6$var$drawingStartPoint.x);
                const dy = Math.abs(y - $b3061062413ea8d6$var$drawingStartPoint.y);
                if (dx > 2 || dy > 2) $b3061062413ea8d6$var$isHorizontalMode = dx > dy;
            }
            if ($b3061062413ea8d6$var$isHorizontalMode) {
                $b3061062413ea8d6$export$aa312658ee6f0824 = x;
                $b3061062413ea8d6$export$cab8fead4289574 = $b3061062413ea8d6$var$drawingStartPoint.y;
            } else {
                $b3061062413ea8d6$export$aa312658ee6f0824 = $b3061062413ea8d6$var$drawingStartPoint.x;
                $b3061062413ea8d6$export$cab8fead4289574 = y;
            }
        } else {
            $b3061062413ea8d6$export$aa312658ee6f0824 = x;
            $b3061062413ea8d6$export$cab8fead4289574 = y;
            $b3061062413ea8d6$var$isHorizontalMode = null;
        }
        $b3061062413ea8d6$export$9c55e7f59a726e = {
            x: $b3061062413ea8d6$export$aa312658ee6f0824,
            y: $b3061062413ea8d6$export$cab8fead4289574
        };
        $b3061062413ea8d6$export$ecc9565f40160774 = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPointByCoordinates({
            x: $b3061062413ea8d6$export$aa312658ee6f0824,
            y: $b3061062413ea8d6$export$cab8fead4289574
        }) || null;
        $b3061062413ea8d6$var$updateHoveredPointDescription();
    });
};







class $07a0e0a0b93620bf$export$3cdec2bba15e3523 {
    static{
        this.data = {
            fps: 0,
            averageSpeed: 0,
            load: 0,
            elapsedTime: 0,
            renderTime: 0
        };
    }
    static setLoad(load) {
        $07a0e0a0b93620bf$export$3cdec2bba15e3523.data.load = load;
    }
    static setFps(fps) {
        $07a0e0a0b93620bf$export$3cdec2bba15e3523.data.fps = fps;
    }
    static setAverageSpeed(speed) {
        $07a0e0a0b93620bf$export$3cdec2bba15e3523.data.averageSpeed = speed;
    }
    static setElapsedTime(elapsedTime) {
        $07a0e0a0b93620bf$export$3cdec2bba15e3523.data.elapsedTime = elapsedTime;
    }
    static setRenderTime(renderTime) {
        $07a0e0a0b93620bf$export$3cdec2bba15e3523.data.renderTime = renderTime;
    }
}











const $621f3774f67738fc$var$previouslyUsedPixels = new Set();
let $621f3774f67738fc$var$frame = 0;
let $621f3774f67738fc$var$lastFrameTime = 0;
let $621f3774f67738fc$var$wasFaviconUpdated = false;
let $621f3774f67738fc$var$lastTimeWithoutLightSources = Date.now();
let $621f3774f67738fc$var$lastTimeWithLightSources = Date.now();
const $621f3774f67738fc$var$BACKGROUND_FADE_TIME = 1000;
const $621f3774f67738fc$var$BACKGROUND_OPACITY_WHEN_THERE_IS_LIGHT_SOURCES = 0.6;
const $621f3774f67738fc$export$eb71c4cc8f5a3475 = ()=>{
    const startTime = performance.now();
    const debugMode = (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getDebugMode();
    const points = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPoints();
    const hasLightSources = (0, $57a22ed606f2167f$export$3e593816f425a913).getLightSourcePoints().size > 0;
    (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).fillStyle = 'white';
    (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).fillRect(0, 0, (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).canvas.width, (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).canvas.height);
    const timeSinceLastLightSource = Date.now() - $621f3774f67738fc$var$lastTimeWithLightSources;
    if (!hasLightSources && timeSinceLastLightSource < $621f3774f67738fc$var$BACKGROUND_FADE_TIME) {
        const fadeFactor = $621f3774f67738fc$var$BACKGROUND_OPACITY_WHEN_THERE_IS_LIGHT_SOURCES - Math.min($621f3774f67738fc$var$BACKGROUND_OPACITY_WHEN_THERE_IS_LIGHT_SOURCES, timeSinceLastLightSource / $621f3774f67738fc$var$BACKGROUND_FADE_TIME);
        (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).fillStyle = `rgba(0, 0, 0, ${fadeFactor})`;
        (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).fillRect(0, 0, (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).canvas.width, (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).canvas.height);
    }
    if (!hasLightSources) {
        $621f3774f67738fc$var$lastTimeWithoutLightSources = Date.now();
        (0, $4c0f0ee047d80e21$export$1482ba6ca761618).clearRect(0, 0, (0, $4c0f0ee047d80e21$export$94c3e10bf18350c).width, (0, $4c0f0ee047d80e21$export$94c3e10bf18350c).height);
    }
    // Calculate time since last frame for smooth interpolation
    const currentTime = performance.now();
    const timeElapsed = (currentTime - $621f3774f67738fc$var$lastFrameTime) * (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getSimulationSpeed();
    $621f3774f67738fc$var$lastFrameTime = currentTime;
    // Update visual coordinates with interpolation factor if smooth movement is enabled
    const isSmoothMovementEnabled = (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getIsSmoothMovementEnabled();
    if (isSmoothMovementEnabled) (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).updateVisualCoordinates((0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).movementSmoothness * timeElapsed);
    const iteration = (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).get('iteration', 0);
    $621f3774f67738fc$var$previouslyUsedPixels.clear();
    points.forEach((point)=>{
        if (!point.visualCoordinates) point.visualCoordinates = {
            ...point.coordinates
        };
        // If smooth movement is disabled, set visual coordinates to match actual coordinates
        if (!isSmoothMovementEnabled) {
            point.visualCoordinates.x = point.coordinates.x;
            point.visualCoordinates.y = point.coordinates.y;
        }
        const key = `${Math.round(point.visualCoordinates.x)}:${Math.round(point.visualCoordinates.y)}`;
        const thereIsPointAlready = $621f3774f67738fc$var$previouslyUsedPixels.has(key);
        // Get base color
        let baseColor;
        if (point.colorVariation !== undefined) {
            baseColor = (0, $70e4e14f6ee7315a$export$e919a8af435a7734)(point);
            // Convert to RGB object
            const result = /^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/.exec(baseColor);
            if (result) baseColor = {
                r: parseInt(result[1]),
                g: parseInt(result[2]),
                b: parseInt(result[3])
            };
            else baseColor = (0, $b0107f5265abe006$export$5551a2d24ff40153)(point);
        } else baseColor = (0, $b0107f5265abe006$export$5551a2d24ff40153)(point);
        if (debugMode && thereIsPointAlready) {
            baseColor = {
                r: 255,
                g: 0,
                b: 0
            }; // Red for overlapping points in debug mode
            $621f3774f67738fc$var$previouslyUsedPixels.add(key);
        }
        // Apply lighting effect to color
        const finalColor = {
            ...baseColor
        };
        (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).fillStyle = `rgb(${Math.round(finalColor.r)}, ${Math.round(finalColor.g)}, ${Math.round(finalColor.b)})`;
        // Use visual coordinates for rendering
        (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).fillRect(point.visualCoordinates.x * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize, point.visualCoordinates.y * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize, (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize, (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize);
        if (debugMode) {
            const speedLength = Math.sqrt(point.speed.x ** 2 + point.speed.y ** 2);
            if (speedLength > 0.1) {
                const centerX = point.visualCoordinates.x * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize + (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize / 2;
                const centerY = point.visualCoordinates.y * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize + (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize / 2;
                const speedX = point.speed.x * 50;
                const speedY = point.speed.y * 50;
                (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).strokeStyle = 'red';
                (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).beginPath();
                (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).moveTo(centerX, centerY);
                (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineTo(centerX + speedX, centerY + speedY);
                (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).stroke();
            }
        }
        if (debugMode && point.data.directionToGround) {
            const centerX = point.visualCoordinates.x * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize + (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize / 2;
            const centerY = point.visualCoordinates.y * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize + (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize / 2;
            const arrowSize = 5;
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).beginPath();
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).moveTo(centerX, centerY);
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineTo(centerX + point.data.directionToGround.x * arrowSize, centerY + point.data.directionToGround.y * arrowSize);
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).strokeStyle = 'rgba(0, 0, 0, 0.5)';
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).stroke();
        }
        if (point.data.lastCloneStep) {
            const stepsSinceClone = iteration - point.data.lastCloneStep;
            if (stepsSinceClone < 10) {
                (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).fillStyle = `rgba(255, 255, 255, ${Math.min(1, stepsSinceClone / 10)})`;
                (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).fillRect(point.visualCoordinates.x * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize, point.visualCoordinates.y * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize, (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize, (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize);
            }
        }
        if (point.data.charge) {
            // yellowish color depending on charge value
            const chargeColor = `rgba(255, 255, 0, ${Math.min(1, Math.max(0, point.data.charge / 10))})`;
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).fillStyle = chargeColor;
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).fillRect(point.visualCoordinates.x * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize, point.visualCoordinates.y * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize, (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize, (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize);
        }
        if (point.data.carriedPoint) {
            // round dot in the center of the point
            const pointColor = (0, $b0107f5265abe006$export$5551a2d24ff40153)(point.data.carriedPoint);
            const color = `rgba(${pointColor.r}, ${pointColor.g}, ${pointColor.b}, 1)`;
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).fillStyle = color;
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).beginPath();
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).arc(point.visualCoordinates.x * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize + (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize / 2, point.visualCoordinates.y * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize + (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize / 2, (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize / 3, 0, 2 * Math.PI);
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).fill();
        }
        if (point.type === (0, $25746eb61037a613$export$873e90337ab80c46).Metal && point.data.temperature > 0) {
            // add a red overlay depending on temperature
            const temperatureColor = `rgba(255, 0, 0, ${Math.min(1, Math.max(0, (point.data.temperature - 20) / 300))})`;
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).fillStyle = temperatureColor;
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).fillRect(point.visualCoordinates.x * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize, point.visualCoordinates.y * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize, (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize, (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize);
        }
        if (debugMode) {
            if ((0, $8c2070529dc8eec8$export$1c787534cb11aa3e).isUnused(point)) {
                // draw a cross on unused points
                (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).beginPath();
                (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).moveTo(point.visualCoordinates.x * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize, point.visualCoordinates.y * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize);
                (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineTo((point.visualCoordinates.x + 1) * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize, (point.visualCoordinates.y + 1) * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize);
                (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).moveTo((point.visualCoordinates.x + 1) * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize, point.visualCoordinates.y * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize);
                (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineTo(point.visualCoordinates.x * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize, (point.visualCoordinates.y + 1) * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize);
                (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).strokeStyle = 'rgba(0, 0, 0, 0.6)';
                (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).stroke();
            }
        }
    });
    if (debugMode) {
        const bounds = (0, $bab86e660d8728eb$export$c4e9d269599ab4b4).getBounds();
        const minTemperature = (0, $f401cf2536c45f5a$export$a83c692ac725e2ca).getMinTemperature();
        const maxTemperature = (0, $f401cf2536c45f5a$export$a83c692ac725e2ca).getMaxTemperature();
        for(let x = bounds.left; x <= bounds.right; x++)for(let y = bounds.top; y <= bounds.bottom; y++){
            const temperature = (0, $f401cf2536c45f5a$export$a83c692ac725e2ca).getTemperatureOnPoint(x, y);
            const temperatureColor = temperature > 0 ? `rgba(${Math.round(255 * temperature / maxTemperature)}, 0, 0, 0.3)` : `rgba(0, 0, ${Math.round(255 * -temperature / minTemperature)}, 0.3)`;
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).fillStyle = temperatureColor;
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).fillRect(x * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize, y * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize, (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize, (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize);
        }
    }
    // draw a rectangle around the drawing area (drawingX and drawingY variables)
    (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).strokeStyle = 'rgba(0, 0, 0, 0.5)';
    (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineWidth = 1;
    const brushSize = (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getBrushSize();
    (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).strokeRect(((0, $b3061062413ea8d6$export$aa312658ee6f0824) + 1) * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize - brushSize * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize, ((0, $b3061062413ea8d6$export$cab8fead4289574) + 1) * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize - brushSize * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize, (brushSize * 2 - 1) * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize, (brushSize * 2 - 1) * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize);
    if (hasLightSources) {
        $621f3774f67738fc$var$lastTimeWithLightSources = Date.now();
        (0, $4c0f0ee047d80e21$export$1482ba6ca761618).fillStyle = 'black';
        (0, $4c0f0ee047d80e21$export$1482ba6ca761618).fillRect(0, 0, (0, $4c0f0ee047d80e21$export$94c3e10bf18350c).width, (0, $4c0f0ee047d80e21$export$94c3e10bf18350c).height);
        const timeSinceLastLightSource = Date.now() - $621f3774f67738fc$var$lastTimeWithoutLightSources;
        const fadeFactor = Math.min($621f3774f67738fc$var$BACKGROUND_OPACITY_WHEN_THERE_IS_LIGHT_SOURCES, timeSinceLastLightSource / $621f3774f67738fc$var$BACKGROUND_FADE_TIME);
        (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).fillStyle = `rgba(0, 0, 0, ${fadeFactor})`;
        (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).fillRect(0, 0, (0, $4c0f0ee047d80e21$export$94c3e10bf18350c).width, (0, $4c0f0ee047d80e21$export$94c3e10bf18350c).height);
        $621f3774f67738fc$var$lastTimeWithLightSources = Date.now();
        const bounds = (0, $bab86e660d8728eb$export$c4e9d269599ab4b4).getBounds();
        // Render light in 2x2 boxes instead of per-pixel
        for(let x = bounds.left; x <= bounds.right; x += 2)for(let y = bounds.top; y <= bounds.bottom; y += 2){
            // Get light intensity from the center point of each 2x2 box
            const centerX = x;
            const centerY = y;
            const lightIntensities = [
                (0, $57a22ed606f2167f$export$3e593816f425a913).getLightIntensity(centerX, centerY),
                (0, $57a22ed606f2167f$export$3e593816f425a913).getLightIntensity(centerX + 1, centerY),
                (0, $57a22ed606f2167f$export$3e593816f425a913).getLightIntensity(centerX, centerY + 1),
                (0, $57a22ed606f2167f$export$3e593816f425a913).getLightIntensity(centerX + 1, centerY + 1)
            ];
            const lightIntensity = Math.max(...lightIntensities);
            if (lightIntensity > 0) {
                let opacity = Math.min(1, lightIntensity / 15);
                (0, $4c0f0ee047d80e21$export$1482ba6ca761618).fillStyle = `rgba(255, 255, 255, ${opacity})`;
                // Draw a 2x2 box
                (0, $4c0f0ee047d80e21$export$1482ba6ca761618).fillRect(x * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize, y * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize, 2 * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize, 2 * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize);
            }
        }
    }
    $621f3774f67738fc$var$updateStats();
    $621f3774f67738fc$export$bddb3321ac6025cc();
    $621f3774f67738fc$var$drawWindVectors();
    $621f3774f67738fc$var$drawRays();
    if (points.length && ($621f3774f67738fc$var$frame % 200 === 0 || !$621f3774f67738fc$var$wasFaviconUpdated)) {
        $621f3774f67738fc$var$updateFavicon();
        $621f3774f67738fc$var$wasFaviconUpdated = true;
    }
    const renderTime = performance.now() - startTime;
    (0, $07a0e0a0b93620bf$export$3cdec2bba15e3523).setRenderTime(renderTime);
    requestAnimationFrame($621f3774f67738fc$export$eb71c4cc8f5a3475);
};
const $621f3774f67738fc$var$limitLineLength = (line, maxLength)=>{
    return line.length > maxLength ? line.substring(0, maxLength) + '...' : line;
};
const $621f3774f67738fc$var$drawRays = ()=>{
    if (!(0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getDebugMode()) return;
    (0, $57a22ed606f2167f$export$3e593816f425a913).lastRays.forEach(({ fromX: fromX, fromY: fromY, toX: toX, toY: toY })=>{
        (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).beginPath();
        (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).moveTo(fromX * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize, fromY * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize);
        (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineTo(toX * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize, toY * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize);
        (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).strokeStyle = 'rgba(0, 0, 0, 0.1)';
        (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineWidth = 1;
        (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).stroke();
    });
};
const $621f3774f67738fc$var$updateStats = ()=>{
    const debugMode = (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getDebugMode();
    const iteration = (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).get('iteration', 0);
    const stats = document.querySelector('.stats');
    if ($621f3774f67738fc$var$frame++ % 20 === 0) {
        const pointsGroupedByType = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPoints().reduce((acc, point)=>{
            acc[point.type] = (acc[point.type] || 0) + 1;
            return acc;
        }, {});
        stats.innerHTML = [
            debugMode && `Cache: ${(0, $3a70ac1fe66fc73f$export$beda572814268322).getCacheStats().hits} hits, ${(0, $3a70ac1fe66fc73f$export$beda572814268322).getCacheStats().misses} misses`,
            debugMode && `Random: ${(0, $6de2ed3e5d01eb29$export$ff07e02f86da72e2)()} from random, ${(0, $6de2ed3e5d01eb29$export$8707e673f135b79e)()} from buffer`,
            `Commit: ${$621f3774f67738fc$var$limitLineLength("Update domain", 20)}`,
            `Frame: ${(Math.round((0, $07a0e0a0b93620bf$export$3cdec2bba15e3523).data.elapsedTime * 10) / 10).toFixed(1)} ms`,
            `Render: ${(Math.round((0, $07a0e0a0b93620bf$export$3cdec2bba15e3523).data.renderTime * 10) / 10).toFixed(1)} ms`,
            `Iteration: ${iteration}`,
            Object.entries(pointsGroupedByType).sort((a, b)=>a[0].localeCompare(b[0])).sort((a, b)=>b[1] - a[1]).map(([type, count])=>`${(0, $8a53c0929bfa4893$export$e486465b517b3350)[type] || type}: ${count}`).join('<br>')
        ].filter(Boolean).join('<br>');
    }
};
const $621f3774f67738fc$export$bddb3321ac6025cc = ()=>{
    const connections = (0, $f243af196a25f578$export$f3ea0776119f0e84).getAllConnections();
    const iteration = (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).get('iteration', 0);
    connections.forEach((connection)=>{
        let opacity = 0.2;
        if (connection.lastUsed && iteration - connection.lastUsed < 30) // more visible if used recently
        opacity = 1 - (iteration - connection.lastUsed) / 30;
        const startX = connection.from.x * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize + (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize / 2;
        const startY = connection.from.y * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize + (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize / 2;
        const endX = connection.to.x * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize + (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize / 2;
        const endY = connection.to.y * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize + (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize / 2;
        if (connection.type === 'wire') {
            // Draw a steppy line for wires (horizontal then vertical)
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).beginPath();
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).moveTo(startX, startY);
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineTo(endX, startY);
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineTo(endX, endY);
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).strokeStyle = `rgba(0, 0, 0, ${opacity})`;
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineWidth = 2;
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).stroke();
        } else {
            // Draw pipe with thickness and rounded caps
            const midX = (startX + endX) / 2;
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).beginPath();
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).moveTo(startX, startY);
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineTo(midX, startY);
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineTo(midX, endY);
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineTo(endX, endY);
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).strokeStyle = `rgba(0, 0, 255, ${opacity})`;
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineWidth = 4;
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineCap = 'round';
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineJoin = 'round';
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).stroke();
            // Add a lighter color in the middle to give a 3D pipe effect
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).beginPath();
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).moveTo(startX, startY);
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineTo(midX, startY);
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineTo(midX, endY);
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineTo(endX, endY);
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).strokeStyle = `rgba(100, 180, 255, ${opacity})`;
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineWidth = 2;
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).stroke();
            // Reset line cap and join
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineCap = 'butt';
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineJoin = 'miter';
        }
    });
    // Draw the connection in progress if in connection mode
    if ((0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getIsConnectionMode() && (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getConnectionStartPoint()) {
        const startPoint = (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getConnectionStartPoint();
        const hoverPoint = (0, $b3061062413ea8d6$export$9c55e7f59a726e) || {
            x: 0,
            y: 0
        };
        const startX = startPoint.x * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize + (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize / 2;
        const startY = startPoint.y * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize + (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize / 2;
        const endX = hoverPoint.x * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize + (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize / 2;
        const endY = hoverPoint.y * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize + (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize / 2;
        const drawingType = (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getDrawingType();
        (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).setLineDash([
            5,
            5
        ]); // Dashed line for in-progress connections
        if (drawingType === (0, $25746eb61037a613$export$873e90337ab80c46).Wire) {
            // Steppy preview for wire
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).beginPath();
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).moveTo(startX, startY);
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineTo(endX, startY);
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineTo(endX, endY);
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).strokeStyle = 'black';
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineWidth = 2;
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).stroke();
        } else {
            // Steppy preview for pipe
            const midX = (startX + endX) / 2;
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).beginPath();
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).moveTo(startX, startY);
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineTo(midX, startY);
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineTo(midX, endY);
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineTo(endX, endY);
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).strokeStyle = 'blue';
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineWidth = 4;
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineCap = 'round';
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineJoin = 'round';
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).stroke();
            // Reset line cap and join
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineCap = 'butt';
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineJoin = 'miter';
        }
        (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).setLineDash([]); // Reset line style
    }
};
let $621f3774f67738fc$var$faviconElement = document.querySelector('link[rel="icon"]');
if (!$621f3774f67738fc$var$faviconElement) {
    $621f3774f67738fc$var$faviconElement = document.createElement('link');
    $621f3774f67738fc$var$faviconElement.rel = 'icon';
    document.head.appendChild($621f3774f67738fc$var$faviconElement);
}
const $621f3774f67738fc$var$updateFavicon = ()=>{
    // Create a temporary canvas for the favicon
    const faviconCanvas = document.createElement('canvas');
    const faviconSize = 32; // Standard favicon size
    faviconCanvas.width = faviconSize;
    faviconCanvas.height = faviconSize;
    // Get the context for drawing on the favicon canvas
    const faviconCtx = faviconCanvas.getContext('2d');
    if (!faviconCtx) return;
    // Sample the main canvas and draw it to the favicon canvas
    faviconCtx.drawImage((0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).canvas, 0, 0, (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).canvas.width, (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).canvas.height, 0, 0, faviconSize, faviconSize);
    // Convert the favicon canvas to a data URL (PNG format)
    const dataUrl = faviconCanvas.toDataURL('image/png');
    $621f3774f67738fc$var$faviconElement.href = dataUrl;
};
const $621f3774f67738fc$var$drawWindVectors = ()=>{
    if (0, $b3061062413ea8d6$export$a908bacd8fc58efd) return;
    if (!(0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getDebugMode()) return;
    const bounds = (0, $bab86e660d8728eb$export$c4e9d269599ab4b4).getBounds();
    const vectorsCount = (0, $3a70ac1fe66fc73f$export$beda572814268322).getVectorsCount();
    if (vectorsCount > 500 || !vectorsCount) return;
    for(let x = bounds.left; x <= bounds.right; x++)for(let y = bounds.top; y <= bounds.bottom; y++){
        const vectors = (0, $3a70ac1fe66fc73f$export$beda572814268322).getVectorsAffectingPoint({
            x: x,
            y: y
        });
        vectors.forEach((vector)=>{
            const startX = x * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize + (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize / 2;
            const startY = y * (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize + (0, $3a56dcb81cc6e4dc$export$1630b5343357e8b5).pixelSize / 2;
            const endX = startX + vector.x * vector.strength * 5;
            const endY = startY + vector.y * vector.strength * 5;
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).beginPath();
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).moveTo(startX, startY);
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineTo(endX, endY);
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).strokeStyle = 'rgba(0, 0, 0, 0.3)';
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).lineWidth = 1;
            (0, $4c0f0ee047d80e21$export$39f92e86d1722f3a).stroke();
        });
    }
};


// Initialize the canvas
(0, $4c0f0ee047d80e21$export$7f545ebf1bdfb9fd)();
// Initialize user interactions
(0, $b3061062413ea8d6$export$ff927f87b332d562)();
// Start the rendering loop
(0, $621f3774f67738fc$export$eb71c4cc8f5a3475)();








const $643aaa39e8412f3b$export$bfb00cec0048377d = (point)=>{
    const gravityState = (0, $0db6937e29869b9b$export$60c0aaabc4c77337).rounded.down;
    const weight = Math.min(3, (0, $4683e24c4ad0e9dc$export$e9fdf378c59a59c7)[point.type]);
    const x = gravityState.x * weight * 0.01;
    const y = gravityState.y * weight * 0.01;
    point.speed.x += x;
    point.speed.y += y;
};







// Viscosity coefficients for different liquid types
const $bc08c0f85735f9ec$var$VISCOSITY = {
    [(0, $25746eb61037a613$export$873e90337ab80c46).Water]: 1.0,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Lava]: 5.0,
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidGlass]: 5.0,
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidGas]: 0.3,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Acid]: 1.2,
    [(0, $25746eb61037a613$export$873e90337ab80c46).MoltenMetal]: 8.0,
    default: 1.0
};
// Density coefficients for different liquid types
const $bc08c0f85735f9ec$var$DENSITY = {
    [(0, $25746eb61037a613$export$873e90337ab80c46).Water]: 1.0,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Lava]: 3.0,
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidGlass]: 3.0,
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidGas]: 0.5,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Acid]: 1.1,
    [(0, $25746eb61037a613$export$873e90337ab80c46).MoltenMetal]: 7.0,
    default: 1.0
};
// Surface tension coefficients
const $bc08c0f85735f9ec$var$SURFACE_TENSION = {
    [(0, $25746eb61037a613$export$873e90337ab80c46).Water]: 0.8,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Lava]: 1.2,
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidGlass]: 1.2,
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidGas]: 0.2,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Acid]: 0.7,
    [(0, $25746eb61037a613$export$873e90337ab80c46).MoltenMetal]: 1.5,
    default: 0.8
};
let $bc08c0f85735f9ec$var$SLOTS = [
    {
        slot: (0, $0db6937e29869b9b$export$60c0aaabc4c77337).rounded.left,
        coefficient: 2.4
    },
    {
        slot: (0, $0db6937e29869b9b$export$60c0aaabc4c77337).rounded.right,
        coefficient: 2.4
    },
    {
        slot: (0, $0db6937e29869b9b$export$60c0aaabc4c77337).rounded.bottomLeft,
        coefficient: 2
    },
    {
        slot: (0, $0db6937e29869b9b$export$60c0aaabc4c77337).rounded.bottomRight,
        coefficient: 2
    },
    {
        slot: (0, $0db6937e29869b9b$export$60c0aaabc4c77337).rounded.down,
        coefficient: 1
    }
];
const $bc08c0f85735f9ec$var$SLOTS_LENGTH = $bc08c0f85735f9ec$var$SLOTS.length;
// Shuffle slots periodically to add some randomness to the flow
setInterval(()=>{
    $bc08c0f85735f9ec$var$SLOTS = (0, $8e9b18f56b659120$export$267b06a7460aa7d3)($bc08c0f85735f9ec$var$SLOTS);
}, 100);
const $bc08c0f85735f9ec$var$BASE_MOVEMENT_POWER = 0.04;
const $bc08c0f85735f9ec$var$TURBULENCE_FACTOR = 0.015;
const $bc08c0f85735f9ec$var$TEMPERATURE_INFLUENCE = 0.0008;
const $bc08c0f85735f9ec$var$PRESSURE_FACTOR = 0.02;
const $bc08c0f85735f9ec$var$MAX_PRESSURE_DEPTH = 10;
// Calculate pressure based on depth (number of liquid particles above)
const $bc08c0f85735f9ec$var$calculatePressure = (point)=>{
    let pressure = 0;
    let depth = 0;
    // Check up to MAX_PRESSURE_DEPTH cells above
    for(let y = 1; y <= $bc08c0f85735f9ec$var$MAX_PRESSURE_DEPTH; y++){
        const checkPoint = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPointByCoordinates({
            x: point.coordinates.x,
            y: point.coordinates.y - y
        });
        if (!checkPoint) break;
        // Only count liquid-type points for pressure
        if ($bc08c0f85735f9ec$var$VISCOSITY[checkPoint.type] !== undefined) {
            depth++;
            pressure += $bc08c0f85735f9ec$var$DENSITY[checkPoint.type] || $bc08c0f85735f9ec$var$DENSITY.default;
        }
    }
    return pressure;
};
// Check if a point is at a liquid surface (has air above it)
const $bc08c0f85735f9ec$var$isAtSurface = (point)=>{
    const abovePoint = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPointByCoordinates({
        x: point.coordinates.x,
        y: point.coordinates.y - 1
    });
    return !abovePoint;
};
const $bc08c0f85735f9ec$export$28b3a3501a7f949 = (point)=>{
    // Get viscosity for this liquid type
    const viscosity = $bc08c0f85735f9ec$var$VISCOSITY[point.type] || $bc08c0f85735f9ec$var$VISCOSITY.default;
    const density = $bc08c0f85735f9ec$var$DENSITY[point.type] || $bc08c0f85735f9ec$var$DENSITY.default;
    const surfaceTension = $bc08c0f85735f9ec$var$SURFACE_TENSION[point.type] || $bc08c0f85735f9ec$var$SURFACE_TENSION.default;
    // Calculate temperature effect on viscosity (hotter = less viscous)
    const temperature = point.data.temperature || 20;
    const temperatureEffect = 1 - (temperature > 20 ? $bc08c0f85735f9ec$var$TEMPERATURE_INFLUENCE * (temperature - 20) : 0);
    const effectiveViscosity = Math.max(0.1, viscosity * temperatureEffect);
    // Calculate pressure effect
    const pressure = $bc08c0f85735f9ec$var$calculatePressure(point);
    const pressureEffect = 1 + pressure * $bc08c0f85735f9ec$var$PRESSURE_FACTOR;
    // Adjust movement power based on viscosity, density and pressure
    const movementPower = $bc08c0f85735f9ec$var$BASE_MOVEMENT_POWER / effectiveViscosity * pressureEffect;
    // Add turbulence based on temperature and pressure
    const turbulence = $bc08c0f85735f9ec$var$TURBULENCE_FACTOR * (temperature / 100) * pressure;
    // Apply surface tension effect if at liquid surface
    const isAtLiquidSurface = $bc08c0f85735f9ec$var$isAtSurface(point);
    const surfaceEffect = isAtLiquidSurface ? surfaceTension : 1;
    const roundedSpeed = (0, $0db6937e29869b9b$export$60c0aaabc4c77337).getRoundedSpeed(point, true, $bc08c0f85735f9ec$var$SLOTS.map((slot)=>slot.slot));
    const pointBySpeed = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPointBySpeed(point, roundedSpeed);
    // Check if the point is moving diagonally into a solid
    if (point.speed.x !== 0 && point.speed.y !== 0) {
        const direction = {
            x: point.coordinates.x + roundedSpeed.x,
            y: point.coordinates.y + roundedSpeed.y
        };
        const pointThere = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPointByCoordinates(direction);
        if (!pointThere) {
            // Apply surface tension effect for diagonal movement
            if (isAtLiquidSurface) {
                point.speed.x *= 0.95;
                point.speed.y *= 0.95;
            }
            return;
        }
    }
    if (pointBySpeed) {
        let availableSlotCount = 0;
        const availableSlots = [];
        // Find available slots for movement
        for(let i = 0; i < $bc08c0f85735f9ec$var$SLOTS_LENGTH; i++){
            const slot = $bc08c0f85735f9ec$var$SLOTS[i];
            const pointBySlot = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPointBySpeed(point, slot.slot);
            if (!pointBySlot) {
                // Apply surface tension for horizontal movement at surface
                if (isAtLiquidSurface && slot.slot.x !== 0 && slot.slot.y === 0) {
                    const adjustedSlot = {
                        ...slot,
                        coefficient: slot.coefficient * surfaceEffect
                    };
                    availableSlots[availableSlotCount++] = adjustedSlot;
                } else availableSlots[availableSlotCount++] = slot;
            }
        }
        if (availableSlotCount > 0) {
            // Add some randomness to the slot selection based on turbulence
            const slotIndex = Math.floor((0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() * availableSlotCount);
            const slot = availableSlots[slotIndex];
            // Apply turbulence effect
            const turbulenceX = ((0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() - 0.5) * turbulence;
            const turbulenceY = ((0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() - 0.5) * turbulence;
            // Apply movement with all effects combined
            point.speed.x += slot.slot.x * movementPower * slot.coefficient + turbulenceX;
            point.speed.y += slot.slot.y * movementPower * slot.coefficient * density + turbulenceY;
            // Apply damping based on viscosity
            point.speed.x *= 1 - 0.01 * effectiveViscosity;
            point.speed.y *= 1 - 0.01 * effectiveViscosity;
        }
    }
};







const $3f224b00819a80d5$export$d13855a853696c6e = (point)=>{
    const roundedSpeed = (0, $0db6937e29869b9b$export$60c0aaabc4c77337).getRoundedSpeed(point);
    // Early return if no movement
    if (roundedSpeed.x === 0 && roundedSpeed.y === 0) return;
    const { coordinates: coordinates } = point;
    const targetCoordinates = {
        x: coordinates.x + roundedSpeed.x,
        y: coordinates.y + roundedSpeed.y
    };
    const pointBySpeed = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPointByCoordinates(targetCoordinates);
    if (!pointBySpeed) return;
    const shouldIgnore = (0, $8cf8e02aa778f380$export$e6907e933a8789b6)[pointBySpeed.type] || (0, $8cf8e02aa778f380$export$e6907e933a8789b6)[point.type];
    if (shouldIgnore) return;
    const myWeight = (0, $4683e24c4ad0e9dc$export$e9fdf378c59a59c7)[point.type];
    const neighbourWeight = (0, $4683e24c4ad0e9dc$export$e9fdf378c59a59c7)[pointBySpeed.type];
    if (myWeight > neighbourWeight) {
        // Check for empty spaces around the lighter point first
        const emptySpaces = [];
        // Check all 8 directions around the lighter point
        for (const direction of (0, $0db6937e29869b9b$export$60c0aaabc4c77337).possibleNeighbours){
            const checkCoordinates = {
                x: pointBySpeed.coordinates.x + direction.x,
                y: pointBySpeed.coordinates.y + direction.y
            };
            // Skip the original point's position
            if (checkCoordinates.x === coordinates.x && checkCoordinates.y === coordinates.y) continue;
            // If there's an empty space, add it to the list
            if (!(0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPointByCoordinates(checkCoordinates)) emptySpaces.push(checkCoordinates);
        }
        // If there are empty spaces, move the lighter point to one of them instead of swapping
        if (emptySpaces.length > 0) {
            // Choose a random empty space
            const randomIndex = Math.floor(Math.random() * emptySpaces.length);
            const emptySpace = emptySpaces[randomIndex];
            // Move the lighter point to the empty space
            const tempCoordinates = {
                ...pointBySpeed.coordinates
            };
            pointBySpeed.coordinates = emptySpace;
            // Update the points index
            (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).deletePointInIndex(tempCoordinates);
            (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).setPointInIndex(pointBySpeed.coordinates, pointBySpeed);
            // Update iteration tracking
            const currentIteration = (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).get('iteration', 0);
            pointBySpeed.lastMoveOnIteration = currentIteration;
            pointBySpeed.speed.x -= roundedSpeed.x * 0.04;
            pointBySpeed.speed.y -= roundedSpeed.y * 0.04;
            // Mark neighbors as used
            (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markNeighboursAsUsed(pointBySpeed);
        } else {
            // No empty spaces, do the original swap
            // Swap coordinates
            const tempCoordinates = {
                ...point.coordinates
            };
            point.coordinates = pointBySpeed.coordinates;
            pointBySpeed.coordinates = tempCoordinates;
            // Update the points index
            (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).deletePointInIndex(point.coordinates);
            (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).deletePointInIndex(pointBySpeed.coordinates);
            (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).setPointInIndex(point.coordinates, point);
            (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).setPointInIndex(pointBySpeed.coordinates, pointBySpeed);
            // Update iteration tracking
            const currentIteration = (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).get('iteration', 0);
            point.lastMoveOnIteration = currentIteration;
            pointBySpeed.lastMoveOnIteration = currentIteration;
            // Mark neighbors as used
            (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markNeighboursAsUsed(point);
            (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markNeighboursAsUsed(pointBySpeed);
        }
    }
};





const $673553dceb4ff2ca$export$281dd2c0701f42d = (from, to)=>(point)=>{
        if (!point.data) point.data = {
            lifetime: 0
        };
        if (!point.data.lifetime) point.data.lifetime = 0;
        point.data.lifetime++;
        point.lastMoveOnIteration = (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).get('iteration', 0);
        if (point.data.lifetime > from) {
            const rest = point.data.lifetime - from;
            const length = to - from;
            const probability = rest / length;
            if (point.data.lifetime > to) {
                (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).deletePoint(point);
                return;
            }
            if ((0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() < probability) (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).deletePoint(point);
        }
    };







const $6e624ffca832b22c$var$STARTING_EXPLOSION_POWER = 10;
const $6e624ffca832b22c$var$CONVERTION_MAP = {
    [(0, $25746eb61037a613$export$873e90337ab80c46).StaticStone]: (0, $25746eb61037a613$export$873e90337ab80c46).Stone,
    [(0, $25746eb61037a613$export$873e90337ab80c46).StaticSand]: (0, $25746eb61037a613$export$873e90337ab80c46).Sand,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Glass]: (0, $25746eb61037a613$export$873e90337ab80c46).Sand
};
const $6e624ffca832b22c$export$7b82f38e9ee2ae8 = (point, processedPoints, rest = 3)=>{
    (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markNeighboursAsUsed(point);
    if (rest === 0) return;
    if (point.type === (0, $25746eb61037a613$export$873e90337ab80c46).Border) return;
    const neighbors = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getNeighbours(point);
    const force = $6e624ffca832b22c$var$STARTING_EXPLOSION_POWER * rest;
    neighbors.forEach((neighbor)=>{
        if (neighbor.type !== (0, $25746eb61037a613$export$873e90337ab80c46).Border && !processedPoints.has(neighbor)) {
            const directionToNeighborX = neighbor.coordinates.x - point.coordinates.x;
            const directionToNeighborY = neighbor.coordinates.y - point.coordinates.y;
            neighbor.speed.x = directionToNeighborX * force * ((0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() + 0.5);
            neighbor.speed.y = directionToNeighborY * force * ((0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() + 0.5);
            neighbor.data.temperature = (neighbor.data.temperature ?? 0) + 30;
            if ($6e624ffca832b22c$var$CONVERTION_MAP[neighbor.type]) {
                neighbor.type = $6e624ffca832b22c$var$CONVERTION_MAP[neighbor.type];
                (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).onPointUpdated(neighbor);
            }
            processedPoints.add(neighbor);
        }
    });
    neighbors.forEach((neighbor)=>{
        $6e624ffca832b22c$export$7b82f38e9ee2ae8(neighbor, processedPoints, rest - 1);
    });
};


const $a8b22a175d834801$export$9d55c124158acbaa = (point)=>{
    if (!point.data) point.data = {
        lifetime: 0
    };
    if (!point.data.lifetime) point.data.lifetime = 0;
    point.data.lifetime++;
    if (point.data.lifetime > 100 && (0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() < 0.1 || point.data.temperature > 900) {
        (0, $6e624ffca832b22c$export$7b82f38e9ee2ae8)(point, new Set([
            point
        ]));
        (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).deletePoint(point);
    }
};


const $078fde33c51460bb$export$379842eafe3b6fc4 = (point)=>{
    point.speed = {
        x: 0,
        y: 0
    };
};





const $89cf9da42421fdf6$export$f1b5197bcca347ac = (power = 1)=>(point)=>{
        point.speed.x += ((0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() * 2 - 1) * 0.0002 * power;
        point.speed.y += ((0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() * 2 - 1) * 0.0002 * power;
    };




const $1a0347cf9847c28d$export$b5910bb267c78233 = (point)=>{
    const neighbors = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getNeighbours(point, false);
    for (const neighbor of neighbors)if (neighbor.type !== (0, $25746eb61037a613$export$873e90337ab80c46).Void) (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).deletePoint(neighbor);
};






const $e2f63daf950d40c1$export$9cd59f9826255e47 = (point, step)=>{
    if (!point.data.cloneType) {
        const neighbors = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getNeighbours(point).filter((neighbor)=>neighbor.type !== (0, $25746eb61037a613$export$873e90337ab80c46).Clone && neighbor.type !== (0, $25746eb61037a613$export$873e90337ab80c46).Border);
        const randomNeighbor = neighbors[Math.floor((0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() * neighbors.length)];
        if (randomNeighbor) point.data.cloneType = randomNeighbor.type;
        return;
    }
    for (const direction of (0, $0db6937e29869b9b$export$60c0aaabc4c77337).possibleNeighbours){
        if ((0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() > 0.5) continue;
        const neighbor = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPointByCoordinates({
            x: point.coordinates.x + direction.x,
            y: point.coordinates.y + direction.y
        });
        if (!neighbor) {
            point.data.lastCloneStep = step;
            (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).addPoint({
                coordinates: {
                    x: point.coordinates.x + direction.x,
                    y: point.coordinates.y + direction.y
                },
                type: point.data.cloneType,
                speed: {
                    x: 0,
                    y: 0
                }
            });
        }
    }
};






const $0776bf216c37efbf$export$8f35fbd5db0f3634 = (point, targetType, repulsiveForce = 0.1)=>{
    let wasEmitted = false;
    for (const direction of (0, $0db6937e29869b9b$export$60c0aaabc4c77337).possibleNeighbours){
        if ((0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() < 0.8) continue;
        const neighbour = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPointByCoordinates({
            x: point.coordinates.x + direction.x,
            y: point.coordinates.y + direction.y
        });
        if (!neighbour) {
            (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).addPoint({
                coordinates: {
                    x: point.coordinates.x + direction.x,
                    y: point.coordinates.y + direction.y
                },
                speed: {
                    x: direction.x * repulsiveForce,
                    y: direction.y * repulsiveForce
                },
                type: targetType
            });
            wasEmitted = true;
        }
    }
    return wasEmitted;
};


const $c5f541a474ce53e1$export$bad24218ebd77223 = (pointType, intencity = 1, repulsiveForce = 0.1)=>(point)=>{
        if ((0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() < 0.9) return;
        if ((0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() > intencity) return;
        (0, $0776bf216c37efbf$export$8f35fbd5db0f3634)(point, pointType, repulsiveForce);
    };







const $6cc45a05d0b5cca9$export$5079890eb1f19149 = (point)=>{
    if (point.data.temperature > 500) {
        if (point.data.explodeTimeout == null) point.data.explodeTimeout = 200;
        point.data.explodeTimeout--;
        point.data.temperature = 900;
        if ((0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() < 0.1) (0, $0776bf216c37efbf$export$8f35fbd5db0f3634)(point, (0, $25746eb61037a613$export$873e90337ab80c46).Fire);
        if (point.data.explodeTimeout <= 0) {
            (0, $6e624ffca832b22c$export$7b82f38e9ee2ae8)(point, new Set([
                point
            ]));
            (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).deletePoint(point);
        }
    }
};



const $fac1c38a27d55666$export$2690b4089f4a5314 = (point)=>{
    point.data.distanceToGround = 0;
    point.data.directionToGround = (0, $0db6937e29869b9b$export$60c0aaabc4c77337).self;
    point.data.charge = 0;
};





const $5b7cefe10d40dcb8$export$86a7974906ea63ee = (point)=>{
    if ((0, $f243af196a25f578$export$f3ea0776119f0e84).getWireFromPoint(point.coordinates).length > 0) {
        point.data.distanceToGround = 0;
        point.data.directionToGround = (0, $0db6937e29869b9b$export$60c0aaabc4c77337).self;
        point.data.charge = 0;
        return;
    }
    const neighbours = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getNeighbours(point, false);
    let closestToGroundPoint = null;
    let closestToGroundDistance = null;
    for (const neighbour of neighbours){
        if (neighbour.data.directionToGround) {
            if (closestToGroundDistance === null || neighbour.data.distanceToGround < closestToGroundDistance) {
                closestToGroundPoint = neighbour;
                closestToGroundDistance = neighbour.data.distanceToGround;
            }
        }
    }
    if (closestToGroundPoint !== null) {
        point.data.distanceToGround = closestToGroundDistance + 1;
        point.data.directionToGround = {
            x: closestToGroundPoint.coordinates.x - point.coordinates.x,
            y: closestToGroundPoint.coordinates.y - point.coordinates.y
        };
        (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markNeighboursAsUsed(point);
    }
};


const $8a4805714fec5cfe$export$de363e709c412c8a = (processor, throttleTimes)=>{
    let callIndex = 0;
    return (point, step)=>{
        if (callIndex === 0) processor(point, step);
        callIndex = (callIndex + 1) % throttleTimes;
    };
};





const $83ea61d1a5a363bc$export$32465a74bc98bd3 = (point)=>{
    if (!point.data.lifetime || point.data.lifetime < 2) {
        point.data.lifetime = (point.data.lifetime ?? 0) + 1;
        return;
    }
    const neighbours = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getNeighbours(point);
    if (neighbours.length === 0) return;
    const neighboursCanReceiveCharge = neighbours.filter((neighbour)=>(0, $62f2f2603999608f$export$5d2a1c3aa5eff4b5)[neighbour.type]);
    if (neighboursCanReceiveCharge.length !== 0) {
        const randomNeighbour = neighboursCanReceiveCharge[Math.floor(Math.random() * neighboursCanReceiveCharge.length)];
        randomNeighbour.data.charge = (randomNeighbour.data.charge ?? 0) + 1;
        (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).deletePoint(point);
        return;
    }
    const hasNeighboursOfOtherTypeExceptClone = neighbours.some((neighbour)=>neighbour.type !== (0, $25746eb61037a613$export$873e90337ab80c46).Clone && neighbour.type !== point.type);
    if (hasNeighboursOfOtherTypeExceptClone) (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).deletePoint(point);
};







const $146e33189fd76c7e$var$sendChargeFromTo = (from, to)=>{
    const amoutToSend = from.data.charge ?? 0;
    to.data.charge = (to.data.charge ?? 0) + amoutToSend;
    from.data.charge = 0;
    to.data.temperature += amoutToSend * 0.002;
    (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markNeighboursAsUsed(from);
    (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markNeighboursAsUsed(to);
};
const $146e33189fd76c7e$export$fe5c94ae8809abbf = (point, iteration)=>{
    // Check for wires first
    const wires = (0, $f243af196a25f578$export$f3ea0776119f0e84).getWireFromPoint(point.coordinates);
    for (const wire of wires){
        const endPoint = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPointByCoordinates(wire.to);
        if (endPoint && (0, $62f2f2603999608f$export$5d2a1c3aa5eff4b5)[endPoint.type]) {
            wire.lastUsed = iteration;
            $146e33189fd76c7e$var$sendChargeFromTo(point, endPoint);
            return;
        }
    }
    // Original logic continues
    const groundDirection = point.data.directionToGround;
    if (groundDirection) {
        const pointThere = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPointByCoordinates({
            x: point.coordinates.x + groundDirection.x,
            y: point.coordinates.y + groundDirection.y
        });
        if (pointThere) {
            $146e33189fd76c7e$var$sendChargeFromTo(point, pointThere);
            return;
        }
    } else {
        const neighbours = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getNeighbours(point, false);
        const neighboursCanReceiveCharge = neighbours.filter((neighbour)=>(0, $62f2f2603999608f$export$5d2a1c3aa5eff4b5)[neighbour.type]);
        const randomNeighbour = neighboursCanReceiveCharge[Math.floor(Math.random() * neighboursCanReceiveCharge.length)];
        if (randomNeighbour) {
            $146e33189fd76c7e$var$sendChargeFromTo(point, randomNeighbour);
            return;
        }
    }
    if (point.data.charge >= 20) while((0, $0776bf216c37efbf$export$8f35fbd5db0f3634)(point, (0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Spark, 0.5) && point.data.charge)point.data.charge -= 20;
    point.data.charge *= 0.9;
};


const $6b8de827413d54bc$export$43d09383182f2860 = (point)=>{
    point.data.charge = 1;
};







let $8fea30ee075cdb87$var$stepsSinceLastActivity = 0;
const $8fea30ee075cdb87$export$523813489278ed1b = ()=>{
    $8fea30ee075cdb87$var$stepsSinceLastActivity = ($8fea30ee075cdb87$var$stepsSinceLastActivity ?? 0) + 1;
};
const $8fea30ee075cdb87$export$ada59f48e9c8aa76 = (point)=>{
    const neighbors = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getNeighbours(point);
    for (const neighbor of neighbors){
        // Skip Void and Clone points as per requirements
        if ((0, $8cf8e02aa778f380$export$f38b826e47487d07)[neighbor.type]) continue;
        (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markPointAsUsed(point);
        if ((0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() < 0.01) {
            neighbor.data.originalType = neighbor.type;
            neighbor.type = (0, $25746eb61037a613$export$873e90337ab80c46).Virus;
            (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).onPointUpdated(neighbor);
            (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markNeighboursAsUsed(neighbor);
            $8fea30ee075cdb87$var$stepsSinceLastActivity = 0;
        }
    }
    if (neighbors.length < 4) (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markPointAsUsed(point);
    if ($8fea30ee075cdb87$var$stepsSinceLastActivity > 20) {
        const possibleDirections = (0, $0db6937e29869b9b$export$60c0aaabc4c77337).possibleNeighbours;
        const randomDirection = possibleDirections[Math.floor((0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() * possibleDirections.length)];
        const pointThere = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPointByCoordinates({
            x: point.coordinates.x + randomDirection.x,
            y: point.coordinates.y + randomDirection.y
        });
        if (!pointThere) {
            (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).addPoint({
                ...point,
                coordinates: {
                    x: point.coordinates.x + randomDirection.x,
                    y: point.coordinates.y + randomDirection.y
                }
            });
            $8fea30ee075cdb87$var$stepsSinceLastActivity = 0;
        }
    }
};





const $8f5e076b98546ba7$export$96d44c043787991 = (point)=>{
    const neighbors = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getNeighbours(point);
    let hasVirusNearby = false;
    for (const neighbor of neighbors)if (neighbor.type === (0, $25746eb61037a613$export$873e90337ab80c46).Virus && (0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() < 0.25) {
        hasVirusNearby = true;
        neighbor.type = (0, $25746eb61037a613$export$873e90337ab80c46).Heal;
        (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).onPointUpdated(neighbor);
        point.data.lastHealType = point.data.lastHealType ?? neighbor.data.originalType;
        (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markNeighboursAsUsed(neighbor);
        (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markPointAsUsed(point);
        point.data.stepsSinceLastHeal = 0;
    }
    if (!hasVirusNearby) {
        (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markPointAsUsed(point);
        point.data.stepsSinceLastHeal = (point.data.stepsSinceLastHeal ?? 0) + 1;
        if (point.data.stepsSinceLastHeal > 400) {
            if (point.data.lastHealType) {
                point.type = point.data.lastHealType;
                point.data.lastHealType = undefined;
                (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).onPointUpdated(point);
            } else (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).deletePoint(point);
        }
    }
};





const $f25c790b9ef3dd7c$export$7d3de262635cdb78 = (point)=>{
    const neighbors = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getNeighbours(point);
    point.data.dissolvedCount = point.data.dissolvedCount || 0;
    for (const neighbor of neighbors){
        // Skip points that should be ignored
        if ((0, $8cf8e02aa778f380$export$888605cfd55923ba)[neighbor.type]) continue;
        // Acid dissolves the neighbor and itself
        if ((0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() < 0.1) {
            (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).deletePoint(neighbor);
            point.data.dissolvedCount++;
            break;
        }
    }
    // If acid dissolved something, it also gets consumed
    if (point.data.dissolvedCount > 4) (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).deletePoint(point);
};





const $30dde81763ac839e$export$f0ce781d01221ce8 = (point)=>{
    if (point.data.temperature < 1) return;
    if (point.data.energy === undefined) point.data.energy = Math.floor(Math.random() * ((0, $8cf8e02aa778f380$export$aca86d12099f09).to - (0, $8cf8e02aa778f380$export$aca86d12099f09).from)) + (0, $8cf8e02aa778f380$export$aca86d12099f09).from;
    if (point.data.energy <= -20) {
        (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).deletePoint(point);
        return;
    }
    const belowPoints = [
        {
            x: point.coordinates.x,
            y: point.coordinates.y + 1
        },
        {
            x: point.coordinates.x - 1,
            y: point.coordinates.y + 1
        },
        {
            x: point.coordinates.x + 1,
            y: point.coordinates.y + 1
        }
    ];
    const pointBelow = belowPoints.map((coordinates)=>(0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPointByCoordinates(coordinates)).filter(Boolean)[0];
    if (!pointBelow || !(0, $8cf8e02aa778f380$export$5db4bcc9f0e2124b)[pointBelow.type]) {
        (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markPointAsUsed(point);
        point.data.energy -= 1;
        return;
    }
    if (point.data.energy <= 0) return;
    const possibleGrowthPoints = [
        {
            x: point.coordinates.x,
            y: point.coordinates.y - 1
        },
        {
            x: point.coordinates.x - 1,
            y: point.coordinates.y - 1
        },
        {
            x: point.coordinates.x + 1,
            y: point.coordinates.y - 1
        }
    ];
    const isGrowthBlocked = possibleGrowthPoints.some((coordinates)=>(0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPointByCoordinates(coordinates));
    if (isGrowthBlocked) return;
    (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markPointAsUsed(point);
    if (Math.random() < 0.1) {
        const availablePoints = possibleGrowthPoints.filter((coordinates)=>!(0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPointByCoordinates(coordinates));
        const randomGrowthPoint = availablePoints[Math.floor(Math.random() * availablePoints.length)];
        if (randomGrowthPoint) {
            point.type = (0, $25746eb61037a613$export$873e90337ab80c46).Plant;
            (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).onPointUpdated(point);
            if (pointBelow.type === (0, $25746eb61037a613$export$873e90337ab80c46).PlantSeed) {
                pointBelow.type = (0, $25746eb61037a613$export$873e90337ab80c46).Plant;
                (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).onPointUpdated(pointBelow);
            }
            (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).addPoint({
                coordinates: randomGrowthPoint,
                type: (0, $25746eb61037a613$export$873e90337ab80c46).Plant,
                speed: {
                    x: 0,
                    y: 0
                },
                data: {
                    energy: point.data.energy - 1
                }
            });
        }
    }
};



const $b781f1d20b6b1dc9$export$d7577165d402903e = (point)=>{
    if (point.data.charge) {
        (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markPointAsUsed(point);
        point.data.temperature = (point.data.temperature || 20) + (point.data.charge || 0) * 5;
        point.data.charge = 0;
    }
};



const $0dd4009868c7c58d$export$21fba3be6b5d0322 = (point)=>{
    if (point.data.charge > 0 && point.data.temperature) {
        (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markPointAsUsed(point);
        point.data.temperature = (point.data.temperature || 20) - (point.data.charge || 0) * 20;
        point.data.charge = 0;
    }
};




const $4fd03a07d5c38165$export$1aa3c2e7d0293b6c = (point)=>{
    const temperature = point.data.temperature ?? 20;
    if (temperature < -10) {
        (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markPointAsUsed(point);
        point.data.charge = 1;
        const baseTemperature = (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getBaseTemperature();
        if (temperature < baseTemperature) point.data.temperature = baseTemperature + (temperature - baseTemperature) * 0.9;
    }
};




const $5842d09de7ff22c8$export$69315e3ed2c8e74b = (point)=>{
    const temperature = point.data.temperature ?? 20;
    if (temperature > 40) {
        (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markPointAsUsed(point);
        point.data.charge = 1;
        const baseTemperature = (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getBaseTemperature();
        if (temperature > baseTemperature) point.data.temperature = baseTemperature + (temperature - baseTemperature) * 0.9;
    }
};




const $16d6e7cd696a8e6f$export$bc39e1390df11af7 = {
    [(0, $25746eb61037a613$export$873e90337ab80c46).Water]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Lava]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidGas]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).MoltenMetal]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidGlass]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Acid]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Oil]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).BurningOil]: true
};


const $d806ef420ea0ed11$export$46865550ddf4da25 = (point)=>{
    const neighbors = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getNeighbours(point);
    if (neighbors.some((neighbor)=>neighbor && (0, $16d6e7cd696a8e6f$export$bc39e1390df11af7)[neighbor.type])) {
        (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markPointAsUsed(point);
        point.data.charge = 1;
    }
};





const $316e54a969622f19$export$4abfe13a488de0cb = (point, iteration)=>{
    if (!(0, $16d6e7cd696a8e6f$export$bc39e1390df11af7)[point.type]) return;
    const pipes = (0, $f243af196a25f578$export$f3ea0776119f0e84).getPipeFromPoint(point.coordinates);
    for (const pipe of pipes){
        const endPoint = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPointByCoordinates(pipe.to);
        if (!endPoint) {
            pipe.lastUsed = iteration;
            // Teleport liquid to the end of the pipe
            (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).deletePoint(point);
            (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).addPoint({
                coordinates: pipe.to,
                type: point.type,
                speed: {
                    ...point.speed
                },
                data: {
                    ...point.data
                }
            });
            break;
        }
    }
};




const $19796f17d1ec4f4c$export$16878d158c6858af = (point)=>{
    const neighbors = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getNeighbours(point);
    neighbors.forEach((neighbor)=>{
        neighbor.colorVariation = (neighbor.colorVariation ?? 0) - 0.01;
    });
};


const $e5d2913a8e1ed613$export$a5cee0aeceb00e3b = (point)=>{
    if (!point.data.charge) point.data.charge = 0;
    point.data.charge = Math.min(point.data.charge * 1.2, 100);
};



const $f58d1bf749440041$var$MAGNET_FORCE = 0.01;
const $f58d1bf749440041$export$f90e9c4771e50ae2 = (attractTo)=>(point)=>{
        const neighbors = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getNeighbours(point, true, 4);
        // Find any metal neighbors
        const metalNeighbors = neighbors.filter((neighbor)=>attractTo[neighbor.type]);
        // If no metal neighbors, nothing to do
        if (metalNeighbors.length === 0) return;
        // Mark point as used since we're applying a force to it
        (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markPointAsUsed(point);
        // For each metal neighbor, apply an attraction force
        for (const metalPoint of metalNeighbors){
            // Calculate direction vector toward the metal
            const dirX = metalPoint.coordinates.x - point.coordinates.x;
            const dirY = metalPoint.coordinates.y - point.coordinates.y;
            // the more distance, the less force
            const distanceCoefficient = 1 / Math.sqrt(dirX ** 2 + dirY ** 2);
            // Apply a slight attraction force in that direction
            // The force decreases with distance (naturally gets stronger as particles get closer)
            point.speed.x += dirX * $f58d1bf749440041$var$MAGNET_FORCE * distanceCoefficient;
            point.speed.y += dirY * $f58d1bf749440041$var$MAGNET_FORCE * distanceCoefficient;
            point.speed.x *= 0.95;
            point.speed.y *= 0.95;
        }
    };







// Configuration: elements that are completely unaffected by wind
const $2b47835c5be32ad2$var$WIND_IMMUNE_ELEMENTS = {
    [(0, $25746eb61037a613$export$873e90337ab80c46).Border]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).StaticStone]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Glass]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Wire]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Pipe]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Wood]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Metal]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Clone]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Void]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Ground]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Source]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Amplifier]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Heater]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Cooler]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).ColdDetector]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).HotDetector]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidDetector]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).WindSource]: true
};
// Wind resistance factor by element weight
const $2b47835c5be32ad2$var$getWindResistance = (weight)=>{
    if (weight === Infinity) return 0; // Immovable objects aren't affected
    if (weight < 0) return 2; // Gases and floating particles are affected more
    return 1 / (weight + 0.1); // Lighter elements are affected more
};
const $2b47835c5be32ad2$export$cd9d494829c88f13 = (point)=>{
    // Skip elements immune to wind
    if ($2b47835c5be32ad2$var$WIND_IMMUNE_ELEMENTS[point.type]) return;
    // Get all wind vectors affecting this point
    const windVectors = (0, $3a70ac1fe66fc73f$export$beda572814268322).getVectorsAffectingPoint(point.coordinates);
    if (windVectors.length === 0) return; // No wind affecting this point
    // Calculate wind resistance based on point weight
    const weight = (0, $4683e24c4ad0e9dc$export$e9fdf378c59a59c7)[point.type] || 1;
    const windResistance = $2b47835c5be32ad2$var$getWindResistance(weight);
    // Apply each wind vector's effect
    windVectors.forEach((vector)=>{
        // Calculate force based on wind strength and element's wind resistance
        const forceX = vector.x * vector.strength * windResistance;
        const forceY = vector.y * vector.strength * windResistance;
        // Apply force to point's speed
        point.speed.x += forceX;
        point.speed.y += forceY;
        // Mark the point as used so its position updates
        (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markPointAsUsed(point);
    });
};




const $ced95d3a67904a0f$export$c9689a18abf9ff13 = (point)=>{
    // Make the point static
    point.speed.x = 0;
    point.speed.y = 0;
    // Set default wind properties if they don't exist
    if (!point.data.windDirection) point.data.windDirection = {
        x: 0,
        y: -1
    }; // Default: upward wind
    if (!point.data.windStrength) point.data.windStrength = 1; // Default strength
    if (!point.data.windRadius) point.data.windRadius = 10; // Default radius
    // Create or update the wind vector
    (0, $3a70ac1fe66fc73f$export$beda572814268322).addVector(point.coordinates, {
        x: point.data.windDirection.x,
        y: point.data.windDirection.y,
        strength: point.data.windStrength,
        radius: point.data.windRadius
    });
    // Mark the point as used to ensure it stays in the simulation
    (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markPointAsUsed(point);
};





const $bf2fdf8b5f3feb98$export$264f7bbef4fe8370 = (array)=>{
    return array[Math.floor(Math.random() * array.length)];
};




const $6f7c6516fe2a3f13$export$629a2bd3f5a49ecc = (obj)=>{
    if (typeof obj !== 'object' || obj === null) return obj;
    const copy = {};
    for(const key in obj)if (typeof obj[key] === 'object' && obj[key] !== null) copy[key] = $6f7c6516fe2a3f13$export$629a2bd3f5a49ecc(obj[key]);
    else copy[key] = obj[key];
    return copy;
};


const $bc73bb53ad63b988$export$9286dfc00713df40 = {
    [(0, $25746eb61037a613$export$873e90337ab80c46).Sand]: (0, $25746eb61037a613$export$873e90337ab80c46).StaticSand,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Stone]: (0, $25746eb61037a613$export$873e90337ab80c46).StaticStone,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Snow]: (0, $25746eb61037a613$export$873e90337ab80c46).Ice
};
const $bc73bb53ad63b988$var$CHANCE_TO_EAT_POINT = {
    [(0, $25746eb61037a613$export$873e90337ab80c46).StaticSand]: 0.001,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Sand]: 0.07,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Wood]: 0.004
};
const $bc73bb53ad63b988$var$CHANCE_TO_CARRY_POINT = {
    [(0, $25746eb61037a613$export$873e90337ab80c46).StaticSand]: 0.04,
    [(0, $25746eb61037a613$export$873e90337ab80c46).StaticStone]: 0.04,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Wood]: 0.08,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Water]: 0.04,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Ant]: 0,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Glass]: 0,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Border]: 0,
    default: 0.01
};
const $bc73bb53ad63b988$var$CHANCE_TO_PUT_POINT = 0.1;
const $bc73bb53ad63b988$var$CHANCE_TO_KEEP_POINT_AFTER_PUT = 0.27;
const $bc73bb53ad63b988$var$CHANCE_TO_REPRODUCE = 0.0006;
const $bc73bb53ad63b988$var$AGE_TO_REPRODUCE = 1500;
const $bc73bb53ad63b988$var$DIE_IF_TOUCHED_POINT = {
    [(0, $25746eb61037a613$export$873e90337ab80c46).Water]: true
};
const $bc73bb53ad63b988$var$CANT_WALK_ON_POINT = {
    ...$bc73bb53ad63b988$var$DIE_IF_TOUCHED_POINT,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Border]: true
};
const $bc73bb53ad63b988$var$moveTo = (point, target, iteration)=>{
    if (!(0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPointByCoordinates(target)) {
        (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).deletePointInIndex(point.coordinates);
        point.coordinates = target;
        point.speed.x = 0;
        point.speed.y = 0;
        point.data.lastMoveOnIteration = iteration;
        (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).setPointInIndex(point.coordinates, point);
        (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markPointAsUsed(point);
    }
};
const $bc73bb53ad63b988$var$STEP_TO_MOVE = 3;
const $bc73bb53ad63b988$var$MAX_STEPS_WITHOUT_MOVE = 600;
const $bc73bb53ad63b988$var$MAX_AGE = 10000;
const $bc73bb53ad63b988$var$CHANCE_TO_DIE_OF_OLD_AGE = 0.0005;
const $bc73bb53ad63b988$var$LOWER_CHANCE_TO_TAKE_POINT_FOR_STEPS = 200;
const $bc73bb53ad63b988$var$die = (point, reason)=>{
    console.log(`Ant died: ${reason}`);
    (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).deletePoint(point);
    if (point.data.carriedPoint) (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).addPoint({
        coordinates: point.coordinates,
        type: point.data.carriedPoint.type,
        speed: {
            x: 0,
            y: 0
        },
        data: (0, $6f7c6516fe2a3f13$export$629a2bd3f5a49ecc)(point.data.carriedPoint.data)
    });
};
const $bc73bb53ad63b988$export$d3ca56550673b6ea = (point, step)=>{
    if (step % $bc73bb53ad63b988$var$STEP_TO_MOVE !== 0) return;
    const lastMoveOnIteration = point.data.lastMoveOnIteration;
    if (lastMoveOnIteration && step - lastMoveOnIteration > $bc73bb53ad63b988$var$MAX_STEPS_WITHOUT_MOVE) {
        $bc73bb53ad63b988$var$die(point, 'Max steps without move');
        return;
    }
    point.data.reproduceSteps = (point.data.reproduceSteps ?? 0) + 1;
    point.data.age = (point.data.age ?? 0) + 1;
    if (point.data.age > $bc73bb53ad63b988$var$MAX_AGE) {
        if ((0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() < $bc73bb53ad63b988$var$CHANCE_TO_DIE_OF_OLD_AGE) {
            $bc73bb53ad63b988$var$die(point, 'Died of old age');
            return;
        }
    }
    if ((0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() < $bc73bb53ad63b988$var$CHANCE_TO_REPRODUCE && point.data.reproduceSteps > $bc73bb53ad63b988$var$AGE_TO_REPRODUCE) {
        const firstAvailablePosition = (0, $0db6937e29869b9b$export$60c0aaabc4c77337).possibleNeighbours.find((position)=>!(0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPointByCoordinates({
                x: position.x + point.coordinates.x,
                y: position.y + point.coordinates.y
            }));
        if (firstAvailablePosition) {
            point.data.reproduceSteps = -$bc73bb53ad63b988$var$AGE_TO_REPRODUCE * 10;
            console.log('Ant: Reproduce');
            (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).addPoint({
                coordinates: {
                    x: firstAvailablePosition.x + point.coordinates.x,
                    y: firstAvailablePosition.y + point.coordinates.y
                },
                type: point.type,
                speed: {
                    x: 0,
                    y: 0
                }
            });
        }
    }
    const neighbors = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getNeighbours(point);
    const possibleTargets = {};
    for (const neighbor of neighbors){
        if (neighbor.type === point.type) continue;
        if ($bc73bb53ad63b988$var$DIE_IF_TOUCHED_POINT[neighbor.type]) {
            if ((0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() < 0.001) {
                $bc73bb53ad63b988$var$die(point, 'Died if touched point');
                return;
            }
            continue;
        }
        if ($bc73bb53ad63b988$var$CANT_WALK_ON_POINT[neighbor.type]) continue;
        // Carry point
        const wasPutByAntRecently = point.data.wasPutByAntOnIteration && step - point.data.wasPutByAntOnIteration < $bc73bb53ad63b988$var$LOWER_CHANCE_TO_TAKE_POINT_FOR_STEPS;
        const chanceModifier = wasPutByAntRecently ? 0.3 : 1;
        const chanceToCarryPointForThisType = $bc73bb53ad63b988$var$CHANCE_TO_CARRY_POINT[neighbor.type] ?? $bc73bb53ad63b988$var$CHANCE_TO_CARRY_POINT.default;
        const chanceToCarryPoint = !point.data.carriedPoint && chanceToCarryPointForThisType;
        if (chanceToCarryPoint && (0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() < chanceToCarryPoint * chanceModifier) {
            point.data.carriedPoint = neighbor;
            (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).deletePoint(neighbor);
            continue;
        }
        // Eat point
        const chanceToEatPoint = $bc73bb53ad63b988$var$CHANCE_TO_EAT_POINT[neighbor.type];
        if (chanceToEatPoint && (0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() < chanceToEatPoint) {
            point.data.previousTarget = {
                x: neighbor.coordinates.x - point.coordinates.x,
                y: neighbor.coordinates.y - point.coordinates.y
            };
            (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).deletePoint(neighbor);
            continue;
        }
        // Convert on touch
        const convertOnTouch = $bc73bb53ad63b988$export$9286dfc00713df40[neighbor.type];
        if (convertOnTouch) {
            neighbor.type = convertOnTouch;
            (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).onPointUpdated(neighbor);
        }
        for (const position of (0, $0db6937e29869b9b$export$60c0aaabc4c77337).possibleNeighbours){
            const target = {
                x: neighbor.coordinates.x + position.x,
                y: neighbor.coordinates.y + position.y
            };
            if (Math.abs(target.x - point.coordinates.x) > 1 || Math.abs(target.y - point.coordinates.y) > 1) continue;
            if (!(0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPointByCoordinates(target)) possibleTargets[target.x + '-' + target.y] = target;
        }
    }
    if (Object.keys(possibleTargets).length > 0) {
        const targets = Object.values(possibleTargets);
        const previousTarget = point.data.previousTarget || (0, $0db6937e29869b9b$export$60c0aaabc4c77337).self;
        const targetsWithSimilarityWithPreviousTarget = targets.map((target)=>{
            const targetDiffX = target.x - point.coordinates.x;
            const targetDiffY = target.y - point.coordinates.y;
            const targetVector = {
                x: targetDiffX,
                y: targetDiffY
            };
            const previousTargetVector = previousTarget;
            const diffOfVectors = {
                x: targetVector.x - previousTargetVector.x,
                y: targetVector.y - previousTargetVector.y
            };
            const distanceBetweenVectors = Math.abs(diffOfVectors.x * diffOfVectors.x + diffOfVectors.y * diffOfVectors.y);
            return {
                target: target,
                distance: distanceBetweenVectors
            };
        });
        const minDistance = Math.min(...targetsWithSimilarityWithPreviousTarget.map((target)=>target.distance));
        const targetsWithMinDistance = targetsWithSimilarityWithPreviousTarget.filter((target)=>target.distance === minDistance);
        const randomTargetData = targetsWithMinDistance.length ? (0, $bf2fdf8b5f3feb98$export$264f7bbef4fe8370)(targetsWithMinDistance) : (0, $bf2fdf8b5f3feb98$export$264f7bbef4fe8370)(targetsWithSimilarityWithPreviousTarget);
        const randomTarget = randomTargetData.target;
        const targetDiffX = randomTarget.x - point.coordinates.x;
        const targetDiffY = randomTarget.y - point.coordinates.y;
        point.data.previousTarget = {
            x: targetDiffX,
            y: targetDiffY
        };
        const oldCoordinatesX = point.coordinates.x;
        const oldCoordinatesY = point.coordinates.y;
        $bc73bb53ad63b988$var$moveTo(point, randomTarget, step);
        const carriedPoint = point.data.carriedPoint;
        if (carriedPoint && (0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() < $bc73bb53ad63b988$var$CHANCE_TO_PUT_POINT) {
            (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).addPoint({
                coordinates: {
                    x: oldCoordinatesX,
                    y: oldCoordinatesY
                },
                type: carriedPoint.type,
                speed: {
                    x: 0,
                    y: 0
                },
                data: {
                    ...(0, $6f7c6516fe2a3f13$export$629a2bd3f5a49ecc)(carriedPoint.data),
                    wasPutByAntOnIteration: step
                }
            });
            if ((0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() > $bc73bb53ad63b988$var$CHANCE_TO_KEEP_POINT_AFTER_PUT) point.data.carriedPoint = null;
        }
        return;
    }
    for(let i = 0; i < $bc73bb53ad63b988$var$STEP_TO_MOVE; i++)(0, $643aaa39e8412f3b$export$bfb00cec0048377d)(point, step);
    point.data.lastMoveOnIteration = step;
};



const $2d41405929bb48bc$export$131e2c11fb039ba = (chance, processor)=>(point, step)=>{
        if ((0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() < chance) processor(point, step);
    };










const $2ed0c7239744f36a$var$CANT_MOVE_THROUGH_POINTS = {
    [(0, $25746eb61037a613$export$873e90337ab80c46).Border]: true,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Worm]: true,
    ...(0, $16d6e7cd696a8e6f$export$bc39e1390df11af7)
};
const $2ed0c7239744f36a$var$CHANCE_TO_EAT = {
    [(0, $25746eb61037a613$export$873e90337ab80c46).Worm]: 0.01,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Wood]: 0.01,
    [(0, $25746eb61037a613$export$873e90337ab80c46).Sand]: 0.01,
    default: 0.003
};
const $2ed0c7239744f36a$var$MOVE_EACH_ITERATION = 6;
const $2ed0c7239744f36a$var$DIRECTION_CHANGE_CHANCE = 0.1;
const $2ed0c7239744f36a$var$REPRODUCTION_CHANCE = 0.005;
const $2ed0c7239744f36a$var$moveTo = (point, target, iteration)=>{
    const pointThere = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPointByCoordinates(target);
    const oldX = point.coordinates.x;
    const oldY = point.coordinates.y;
    (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).deletePointInIndex(point.coordinates);
    const chanceToEat = pointThere ? $2ed0c7239744f36a$var$CHANCE_TO_EAT[pointThere.type] || $2ed0c7239744f36a$var$CHANCE_TO_EAT.default : $2ed0c7239744f36a$var$CHANCE_TO_EAT.default;
    const shouldEat = (0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() < chanceToEat;
    if (pointThere) {
        (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).deletePointInIndex(pointThere.coordinates);
        if (shouldEat) (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).deletePoint(pointThere);
        else pointThere.coordinates = {
            x: oldX,
            y: oldY
        };
    }
    point.coordinates = {
        x: target.x,
        y: target.y
    };
    if (pointThere && !shouldEat) {
        (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).setPointInIndex(pointThere.coordinates, pointThere);
        (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markNeighboursAsUsed(pointThere);
    }
    (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).setPointInIndex(point.coordinates, point);
    point.speed.x = 0;
    point.speed.y = 0;
    point.data.lastMoveOnIteration = iteration;
    (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markNeighboursAsUsed(point);
};
const $2ed0c7239744f36a$var$isDirectionAvailable = (direction, point)=>{
    const pointThere = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPointByCoordinates({
        x: point.coordinates.x + direction.x,
        y: point.coordinates.y + direction.y
    });
    return pointThere && !$2ed0c7239744f36a$var$CANT_MOVE_THROUGH_POINTS[pointThere.type];
};
const $2ed0c7239744f36a$var$getNewDirection = (point)=>{
    const possibleDirections = [];
    for (const direction of (0, $0db6937e29869b9b$export$60c0aaabc4c77337).possibleNeighbours)if ($2ed0c7239744f36a$var$isDirectionAvailable(direction, point)) possibleDirections.push(direction);
    if (possibleDirections.length === 0) return undefined;
    return possibleDirections[Math.floor((0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() * possibleDirections.length)];
};
const $2ed0c7239744f36a$var$getNextDirection = (point, previousDirection)=>{
    if (!previousDirection) return $2ed0c7239744f36a$var$getNewDirection(point);
    if (!$2ed0c7239744f36a$var$isDirectionAvailable(previousDirection, point) || (0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() < $2ed0c7239744f36a$var$DIRECTION_CHANGE_CHANCE) return $2ed0c7239744f36a$var$getNewDirection(point);
    return previousDirection;
};
const $2ed0c7239744f36a$export$2d9ba2b09d91631d = (point, step)=>{
    const possibleNeighbours = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getNeighbours(point).filter((neighbour)=>!$2ed0c7239744f36a$var$CANT_MOVE_THROUGH_POINTS[neighbour.type]);
    if (step % $2ed0c7239744f36a$var$MOVE_EACH_ITERATION !== 0 || possibleNeighbours.length === 0) {
        (0, $643aaa39e8412f3b$export$bfb00cec0048377d)(point, step);
        return;
    }
    for (const neighbour of possibleNeighbours){
        const convertedType = (0, $bc73bb53ad63b988$export$9286dfc00713df40)[neighbour.type];
        if (convertedType) {
            neighbour.type = convertedType;
            (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).onPointUpdated(neighbour);
        }
    }
    if ((0, $6de2ed3e5d01eb29$export$4385e60b38654f68)() < $2ed0c7239744f36a$var$REPRODUCTION_CHANCE) {
        const slot = (0, $0db6937e29869b9b$export$60c0aaabc4c77337).possibleNeighbours.find((direction)=>{
            const pointThere = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPointByCoordinates({
                x: point.coordinates.x + direction.x,
                y: point.coordinates.y + direction.y
            });
            return !pointThere;
        });
        if (slot) (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).addPoint({
            coordinates: {
                x: point.coordinates.x + slot.x,
                y: point.coordinates.y + slot.y
            },
            type: (0, $25746eb61037a613$export$873e90337ab80c46).Worm,
            speed: {
                x: 0,
                y: 0
            },
            data: {}
        });
    }
    const previousDirection = point.data.previousDirection;
    const newDirection = $2ed0c7239744f36a$var$getNextDirection(point, previousDirection);
    if (newDirection) {
        point.data.previousDirection = newDirection;
        $2ed0c7239744f36a$var$moveTo(point, {
            x: point.coordinates.x + newDirection.x,
            y: point.coordinates.y + newDirection.y
        }, step);
    }
};





const $a44c208b5e8b1547$export$f5833ad2f79695c6 = (point)=>{
    const lightIntensity = (0, $57a22ed606f2167f$export$3e593816f425a913).getLightIntensity(point.coordinates.x, point.coordinates.y);
    // Emit electricity when light intensity is above 0.3
    if (lightIntensity > 0.001) {
        (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markPointAsUsed(point);
        point.data.charge = 1;
    }
};



const $8ed9e703020e5c6d$var$MAX_LIGHT_INTENSITY = 15;
const $8ed9e703020e5c6d$export$150f2d0f217639cb = (point)=>{
    if (!point.data.lightIntensity) point.data.lightIntensity = 0;
    if (point.data.charge) {
        (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markPointAsUsed(point);
        point.data.isLightSource = true;
        point.data.lightIntensity = Math.min(point.data.lightIntensity + point.data.charge * 0.01, $8ed9e703020e5c6d$var$MAX_LIGHT_INTENSITY);
        point.data.charge = 0;
    } else point.data.lightIntensity = Math.max(0, point.data.lightIntensity - 0.1);
};


const $26f90a9d628b605c$var$noopDetector = ()=>{};
const $26f90a9d628b605c$var$BASIC_TEMPERATURE_PROCESSORS = [
    $26f90a9d628b605c$var$noopDetector,
    (0, $8a4805714fec5cfe$export$de363e709c412c8a)((0, $0c03ddc232f6bf98$export$56b8754592079e56)(0.01), 10),
    (0, $0c03ddc232f6bf98$export$fb01a17bfbf0d787)
];
const $26f90a9d628b605c$var$BASIC_FORCES_EXCEPT_GRAVITY = [
    ...$26f90a9d628b605c$var$BASIC_TEMPERATURE_PROCESSORS,
    (0, $3f224b00819a80d5$export$d13855a853696c6e),
    (0, $2b47835c5be32ad2$export$cd9d494829c88f13)
];
const $26f90a9d628b605c$var$BASIC_FORCES = [
    ...$26f90a9d628b605c$var$BASIC_FORCES_EXCEPT_GRAVITY,
    (0, $643aaa39e8412f3b$export$bfb00cec0048377d)
];
const $26f90a9d628b605c$export$9d44bc286fa91593 = {
    [(0, $25746eb61037a613$export$873e90337ab80c46).Metal]: [
        ...$26f90a9d628b605c$var$BASIC_TEMPERATURE_PROCESSORS,
        (0, $078fde33c51460bb$export$379842eafe3b6fc4),
        (0, $8a4805714fec5cfe$export$de363e709c412c8a)((0, $5b7cefe10d40dcb8$export$86a7974906ea63ee), 10),
        (0, $146e33189fd76c7e$export$fe5c94ae8809abbf),
        (0, $0c03ddc232f6bf98$export$f36b1181189adb85)('more', 1500, (0, $25746eb61037a613$export$873e90337ab80c46).MoltenMetal)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).MoltenMetal]: [
        ...$26f90a9d628b605c$var$BASIC_FORCES,
        (0, $5b7cefe10d40dcb8$export$86a7974906ea63ee),
        (0, $146e33189fd76c7e$export$fe5c94ae8809abbf),
        (0, $0c03ddc232f6bf98$export$f36b1181189adb85)('less', 1400, (0, $25746eb61037a613$export$873e90337ab80c46).Metal)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Spark]: [
        ...$26f90a9d628b605c$var$BASIC_FORCES,
        (0, $89cf9da42421fdf6$export$f1b5197bcca347ac)(1),
        (0, $83ea61d1a5a363bc$export$32465a74bc98bd3)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Source]: [
        ...$26f90a9d628b605c$var$BASIC_TEMPERATURE_PROCESSORS,
        (0, $078fde33c51460bb$export$379842eafe3b6fc4),
        (0, $146e33189fd76c7e$export$fe5c94ae8809abbf),
        (0, $6b8de827413d54bc$export$43d09383182f2860),
        (0, $8a4805714fec5cfe$export$de363e709c412c8a)((0, $5b7cefe10d40dcb8$export$86a7974906ea63ee), 10)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Ground]: [
        ...$26f90a9d628b605c$var$BASIC_TEMPERATURE_PROCESSORS,
        (0, $078fde33c51460bb$export$379842eafe3b6fc4),
        (0, $8a4805714fec5cfe$export$de363e709c412c8a)((0, $fac1c38a27d55666$export$2690b4089f4a5314), 10)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Amplifier]: [
        ...$26f90a9d628b605c$var$BASIC_TEMPERATURE_PROCESSORS,
        (0, $078fde33c51460bb$export$379842eafe3b6fc4),
        (0, $e5d2913a8e1ed613$export$a5cee0aeceb00e3b),
        (0, $146e33189fd76c7e$export$fe5c94ae8809abbf),
        (0, $8a4805714fec5cfe$export$de363e709c412c8a)((0, $5b7cefe10d40dcb8$export$86a7974906ea63ee), 10)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Heater]: [
        ...$26f90a9d628b605c$var$BASIC_TEMPERATURE_PROCESSORS,
        (0, $b781f1d20b6b1dc9$export$d7577165d402903e),
        (0, $078fde33c51460bb$export$379842eafe3b6fc4),
        (0, $146e33189fd76c7e$export$fe5c94ae8809abbf),
        (0, $fac1c38a27d55666$export$2690b4089f4a5314)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Cooler]: [
        ...$26f90a9d628b605c$var$BASIC_TEMPERATURE_PROCESSORS,
        (0, $0dd4009868c7c58d$export$21fba3be6b5d0322),
        (0, $078fde33c51460bb$export$379842eafe3b6fc4),
        (0, $146e33189fd76c7e$export$fe5c94ae8809abbf),
        (0, $fac1c38a27d55666$export$2690b4089f4a5314)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Water]: [
        ...$26f90a9d628b605c$var$BASIC_FORCES,
        (0, $bc08c0f85735f9ec$export$28b3a3501a7f949),
        (0, $0c03ddc232f6bf98$export$f36b1181189adb85)('less', 0, (0, $25746eb61037a613$export$873e90337ab80c46).Ice),
        (0, $0c03ddc232f6bf98$export$f36b1181189adb85)('more', 100, (0, $25746eb61037a613$export$873e90337ab80c46).Steam)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidGas]: [
        ...$26f90a9d628b605c$var$BASIC_FORCES,
        (0, $bc08c0f85735f9ec$export$28b3a3501a7f949),
        (0, $0c03ddc232f6bf98$export$f36b1181189adb85)('more', -160, (0, $25746eb61037a613$export$873e90337ab80c46).Gas)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Lava]: [
        ...$26f90a9d628b605c$var$BASIC_FORCES,
        (0, $bc08c0f85735f9ec$export$28b3a3501a7f949),
        (0, $0c03ddc232f6bf98$export$f36b1181189adb85)('less', 1200, (0, $25746eb61037a613$export$873e90337ab80c46).StaticStone),
        (0, $54b1901f91ac083a$export$7da6434e793a8d85)(0.3)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).StaticSand]: [
        ...$26f90a9d628b605c$var$BASIC_TEMPERATURE_PROCESSORS,
        (0, $078fde33c51460bb$export$379842eafe3b6fc4),
        (0, $0c03ddc232f6bf98$export$f36b1181189adb85)('more', 1700, (0, $25746eb61037a613$export$873e90337ab80c46).LiquidGlass)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Sand]: [
        ...$26f90a9d628b605c$var$BASIC_FORCES,
        (0, $0c03ddc232f6bf98$export$f36b1181189adb85)('more', 1700, (0, $25746eb61037a613$export$873e90337ab80c46).LiquidGlass)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).StaticStone]: [
        ...$26f90a9d628b605c$var$BASIC_TEMPERATURE_PROCESSORS,
        (0, $078fde33c51460bb$export$379842eafe3b6fc4),
        (0, $0c03ddc232f6bf98$export$f36b1181189adb85)('more', 1300, (0, $25746eb61037a613$export$873e90337ab80c46).Lava)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Stone]: [
        ...$26f90a9d628b605c$var$BASIC_FORCES,
        (0, $0c03ddc232f6bf98$export$f36b1181189adb85)('more', 1300, (0, $25746eb61037a613$export$873e90337ab80c46).Lava)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Smoke]: [
        ...$26f90a9d628b605c$var$BASIC_FORCES,
        (0, $673553dceb4ff2ca$export$281dd2c0701f42d)(100, 200),
        (0, $19796f17d1ec4f4c$export$16878d158c6858af)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Fire]: [
        ...$26f90a9d628b605c$var$BASIC_FORCES,
        (0, $673553dceb4ff2ca$export$281dd2c0701f42d)(8, 50),
        (0, $0c03ddc232f6bf98$export$1becb524344efd56)(()=>(0, $de0cf5fb31f39b4f$export$f50ca6dc0891673f)[(0, $25746eb61037a613$export$873e90337ab80c46).Fire] ?? 2000),
        (0, $c5f541a474ce53e1$export$bad24218ebd77223)((0, $25746eb61037a613$export$873e90337ab80c46).Smoke, 0.02, 0.001),
        (0, $54b1901f91ac083a$export$7da6434e793a8d85)(0.3)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).IceFire]: [
        ...$26f90a9d628b605c$var$BASIC_FORCES,
        (0, $673553dceb4ff2ca$export$281dd2c0701f42d)(30, 120),
        (0, $0c03ddc232f6bf98$export$1becb524344efd56)(()=>(0, $de0cf5fb31f39b4f$export$f50ca6dc0891673f)[(0, $25746eb61037a613$export$873e90337ab80c46).IceFire] ?? -700)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Bomb]: [
        ...$26f90a9d628b605c$var$BASIC_FORCES,
        (0, $a8b22a175d834801$export$9d55c124158acbaa)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Dynamite]: [
        ...$26f90a9d628b605c$var$BASIC_TEMPERATURE_PROCESSORS,
        (0, $078fde33c51460bb$export$379842eafe3b6fc4),
        (0, $6cc45a05d0b5cca9$export$5079890eb1f19149)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Ice]: [
        ...$26f90a9d628b605c$var$BASIC_TEMPERATURE_PROCESSORS,
        (0, $078fde33c51460bb$export$379842eafe3b6fc4),
        (0, $0c03ddc232f6bf98$export$f36b1181189adb85)('more', 0, (0, $25746eb61037a613$export$873e90337ab80c46).Water)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Glass]: [
        ...$26f90a9d628b605c$var$BASIC_TEMPERATURE_PROCESSORS,
        (0, $078fde33c51460bb$export$379842eafe3b6fc4),
        (0, $0c03ddc232f6bf98$export$f36b1181189adb85)('more', 1400, (0, $25746eb61037a613$export$873e90337ab80c46).LiquidGlass)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidGlass]: [
        ...$26f90a9d628b605c$var$BASIC_FORCES,
        (0, $bc08c0f85735f9ec$export$28b3a3501a7f949),
        (0, $0c03ddc232f6bf98$export$f36b1181189adb85)('less', 1300, (0, $25746eb61037a613$export$873e90337ab80c46).Glass)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).ConstantCold]: [
        $26f90a9d628b605c$var$noopDetector,
        (0, $0c03ddc232f6bf98$export$1becb524344efd56)(()=>(0, $de0cf5fb31f39b4f$export$f50ca6dc0891673f)[(0, $25746eb61037a613$export$873e90337ab80c46).ConstantCold] ?? -500),
        (0, $078fde33c51460bb$export$379842eafe3b6fc4)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).ConstantHot]: [
        $26f90a9d628b605c$var$noopDetector,
        (0, $0c03ddc232f6bf98$export$1becb524344efd56)(()=>(0, $de0cf5fb31f39b4f$export$f50ca6dc0891673f)[(0, $25746eb61037a613$export$873e90337ab80c46).ConstantHot] ?? 500),
        (0, $078fde33c51460bb$export$379842eafe3b6fc4)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Gas]: [
        ...$26f90a9d628b605c$var$BASIC_FORCES,
        (0, $89cf9da42421fdf6$export$f1b5197bcca347ac)(1000),
        (0, $0c03ddc232f6bf98$export$f36b1181189adb85)('more', 400, (0, $25746eb61037a613$export$873e90337ab80c46).FireEmitter)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Wood]: [
        ...$26f90a9d628b605c$var$BASIC_TEMPERATURE_PROCESSORS,
        (0, $078fde33c51460bb$export$379842eafe3b6fc4),
        (0, $0c03ddc232f6bf98$export$f36b1181189adb85)('more', 300, (0, $25746eb61037a613$export$873e90337ab80c46).BurningWood)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).BurningWood]: [
        ...$26f90a9d628b605c$var$BASIC_TEMPERATURE_PROCESSORS,
        (0, $078fde33c51460bb$export$379842eafe3b6fc4),
        (0, $673553dceb4ff2ca$export$281dd2c0701f42d)(500, 1000),
        (0, $0c03ddc232f6bf98$export$1becb524344efd56)(()=>(0, $de0cf5fb31f39b4f$export$f50ca6dc0891673f)[(0, $25746eb61037a613$export$873e90337ab80c46).BurningWood] ?? 800),
        (0, $c5f541a474ce53e1$export$bad24218ebd77223)((0, $25746eb61037a613$export$873e90337ab80c46).Fire, 0.2),
        (0, $c5f541a474ce53e1$export$bad24218ebd77223)((0, $25746eb61037a613$export$873e90337ab80c46).Smoke, 0.2, 0.001),
        (0, $54b1901f91ac083a$export$7da6434e793a8d85)(0.3)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).FireEmitter]: [
        ...$26f90a9d628b605c$var$BASIC_FORCES,
        (0, $673553dceb4ff2ca$export$281dd2c0701f42d)(30, 120),
        (0, $c5f541a474ce53e1$export$bad24218ebd77223)((0, $25746eb61037a613$export$873e90337ab80c46).Fire),
        (0, $c5f541a474ce53e1$export$bad24218ebd77223)((0, $25746eb61037a613$export$873e90337ab80c46).Smoke, 0.05, 0.001)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Clone]: [
        ...$26f90a9d628b605c$var$BASIC_TEMPERATURE_PROCESSORS,
        (0, $078fde33c51460bb$export$379842eafe3b6fc4),
        (0, $e2f63daf950d40c1$export$9cd59f9826255e47)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Oil]: [
        ...$26f90a9d628b605c$var$BASIC_FORCES,
        (0, $bc08c0f85735f9ec$export$28b3a3501a7f949),
        (0, $0c03ddc232f6bf98$export$f36b1181189adb85)('more', 250, (0, $25746eb61037a613$export$873e90337ab80c46).BurningOil)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).BurningOil]: [
        ...$26f90a9d628b605c$var$BASIC_FORCES,
        (0, $bc08c0f85735f9ec$export$28b3a3501a7f949),
        (0, $c5f541a474ce53e1$export$bad24218ebd77223)((0, $25746eb61037a613$export$873e90337ab80c46).Fire, 0.5),
        (0, $c5f541a474ce53e1$export$bad24218ebd77223)((0, $25746eb61037a613$export$873e90337ab80c46).Smoke, 0.05, 0.001),
        (0, $0c03ddc232f6bf98$export$1becb524344efd56)(()=>(0, $de0cf5fb31f39b4f$export$f50ca6dc0891673f)[(0, $25746eb61037a613$export$873e90337ab80c46).BurningOil] ?? 400),
        (0, $673553dceb4ff2ca$export$281dd2c0701f42d)(100, 200),
        (0, $54b1901f91ac083a$export$7da6434e793a8d85)(0.3)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Steam]: [
        ...$26f90a9d628b605c$var$BASIC_FORCES,
        (0, $89cf9da42421fdf6$export$f1b5197bcca347ac)(100),
        (0, $0c03ddc232f6bf98$export$f36b1181189adb85)('less', 99, (0, $25746eb61037a613$export$873e90337ab80c46).Water),
        (0, $0c03ddc232f6bf98$export$56b8754592079e56)(0.02)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Border]: [
        $26f90a9d628b605c$var$noopDetector
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Void]: [
        ...$26f90a9d628b605c$var$BASIC_TEMPERATURE_PROCESSORS,
        (0, $1a0347cf9847c28d$export$b5910bb267c78233),
        (0, $078fde33c51460bb$export$379842eafe3b6fc4)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Virus]: [
        ...$26f90a9d628b605c$var$BASIC_TEMPERATURE_PROCESSORS,
        (0, $8fea30ee075cdb87$export$ada59f48e9c8aa76),
        (0, $078fde33c51460bb$export$379842eafe3b6fc4)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Heal]: [
        ...$26f90a9d628b605c$var$BASIC_FORCES,
        (0, $8f5e076b98546ba7$export$96d44c043787991)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Acid]: [
        ...$26f90a9d628b605c$var$BASIC_FORCES,
        (0, $bc08c0f85735f9ec$export$28b3a3501a7f949),
        (0, $f25c790b9ef3dd7c$export$7d3de262635cdb78)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Magnet]: [
        ...$26f90a9d628b605c$var$BASIC_FORCES,
        (0, $f58d1bf749440041$export$f90e9c4771e50ae2)((0, $8cf8e02aa778f380$export$6e249174ae4d7b22))
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Plant]: [
        ...$26f90a9d628b605c$var$BASIC_FORCES,
        (0, $078fde33c51460bb$export$379842eafe3b6fc4),
        (0, $30dde81763ac839e$export$f0ce781d01221ce8),
        (0, $0c03ddc232f6bf98$export$f36b1181189adb85)('more', 300, (0, $25746eb61037a613$export$873e90337ab80c46).BurningWood)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).PlantSeed]: [
        ...$26f90a9d628b605c$var$BASIC_FORCES,
        (0, $30dde81763ac839e$export$f0ce781d01221ce8),
        (0, $0c03ddc232f6bf98$export$f36b1181189adb85)('more', 300, (0, $25746eb61037a613$export$873e90337ab80c46).BurningWood)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).ColdDetector]: [
        ...$26f90a9d628b605c$var$BASIC_TEMPERATURE_PROCESSORS,
        (0, $078fde33c51460bb$export$379842eafe3b6fc4),
        (0, $4fd03a07d5c38165$export$1aa3c2e7d0293b6c),
        (0, $146e33189fd76c7e$export$fe5c94ae8809abbf),
        (0, $8a4805714fec5cfe$export$de363e709c412c8a)((0, $5b7cefe10d40dcb8$export$86a7974906ea63ee), 10)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).HotDetector]: [
        ...$26f90a9d628b605c$var$BASIC_TEMPERATURE_PROCESSORS,
        (0, $078fde33c51460bb$export$379842eafe3b6fc4),
        (0, $5842d09de7ff22c8$export$69315e3ed2c8e74b),
        (0, $146e33189fd76c7e$export$fe5c94ae8809abbf),
        (0, $8a4805714fec5cfe$export$de363e709c412c8a)((0, $5b7cefe10d40dcb8$export$86a7974906ea63ee), 10)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidDetector]: [
        ...$26f90a9d628b605c$var$BASIC_TEMPERATURE_PROCESSORS,
        (0, $078fde33c51460bb$export$379842eafe3b6fc4),
        (0, $d806ef420ea0ed11$export$46865550ddf4da25),
        (0, $146e33189fd76c7e$export$fe5c94ae8809abbf),
        (0, $8a4805714fec5cfe$export$de363e709c412c8a)((0, $5b7cefe10d40dcb8$export$86a7974906ea63ee), 10)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Snow]: [
        ...$26f90a9d628b605c$var$BASIC_FORCES,
        (0, $89cf9da42421fdf6$export$f1b5197bcca347ac)(5),
        (0, $0c03ddc232f6bf98$export$f36b1181189adb85)('more', 0, (0, $25746eb61037a613$export$873e90337ab80c46).Water)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Wire]: [
        ...$26f90a9d628b605c$var$BASIC_TEMPERATURE_PROCESSORS,
        (0, $078fde33c51460bb$export$379842eafe3b6fc4)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Pipe]: [
        ...$26f90a9d628b605c$var$BASIC_TEMPERATURE_PROCESSORS,
        (0, $078fde33c51460bb$export$379842eafe3b6fc4)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).WindSource]: [
        ...$26f90a9d628b605c$var$BASIC_TEMPERATURE_PROCESSORS,
        (0, $078fde33c51460bb$export$379842eafe3b6fc4),
        (0, $ced95d3a67904a0f$export$c9689a18abf9ff13)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Ant]: [
        ...$26f90a9d628b605c$var$BASIC_FORCES_EXCEPT_GRAVITY,
        (0, $bc73bb53ad63b988$export$d3ca56550673b6ea),
        (0, $0c03ddc232f6bf98$export$cd97518631d93b14)('more', 100),
        (0, $0c03ddc232f6bf98$export$cd97518631d93b14)('less', 0)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).FireAnt]: [
        ...$26f90a9d628b605c$var$BASIC_FORCES_EXCEPT_GRAVITY,
        (0, $bc73bb53ad63b988$export$d3ca56550673b6ea),
        (0, $c5f541a474ce53e1$export$bad24218ebd77223)((0, $25746eb61037a613$export$873e90337ab80c46).Smoke, 0.02, 0),
        (0, $8a4805714fec5cfe$export$de363e709c412c8a)((0, $0c03ddc232f6bf98$export$f42c036c4e9ecad7)(700), 2),
        (0, $0c03ddc232f6bf98$export$d73d835fa5131a64)(10, 2000),
        (0, $0c03ddc232f6bf98$export$cd97518631d93b14)('less', 0),
        (0, $2d41405929bb48bc$export$131e2c11fb039ba)(0.0003, (point)=>(0, $6e624ffca832b22c$export$7b82f38e9ee2ae8)(point, new Set([
                point
            ])))
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).IceAnt]: [
        ...$26f90a9d628b605c$var$BASIC_FORCES_EXCEPT_GRAVITY,
        (0, $bc73bb53ad63b988$export$d3ca56550673b6ea),
        (0, $c5f541a474ce53e1$export$bad24218ebd77223)((0, $25746eb61037a613$export$873e90337ab80c46).IceFire, 0.01, 0),
        (0, $8a4805714fec5cfe$export$de363e709c412c8a)((0, $0c03ddc232f6bf98$export$a30105674c24852a)(-500), 2),
        (0, $0c03ddc232f6bf98$export$e802a0b707365fb)(10, -1000),
        (0, $0c03ddc232f6bf98$export$cd97518631d93b14)('more', 0)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Worm]: [
        ...$26f90a9d628b605c$var$BASIC_FORCES_EXCEPT_GRAVITY,
        (0, $2ed0c7239744f36a$export$2d9ba2b09d91631d),
        (0, $0c03ddc232f6bf98$export$cd97518631d93b14)('more', 120),
        (0, $0c03ddc232f6bf98$export$cd97518631d93b14)('less', -20)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).LightSource]: [
        ...$26f90a9d628b605c$var$BASIC_TEMPERATURE_PROCESSORS,
        (0, $078fde33c51460bb$export$379842eafe3b6fc4),
        (0, $54b1901f91ac083a$export$7da6434e793a8d85)(1)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).Mirror]: [
        ...$26f90a9d628b605c$var$BASIC_TEMPERATURE_PROCESSORS,
        (0, $078fde33c51460bb$export$379842eafe3b6fc4),
        (0, $0c03ddc232f6bf98$export$f36b1181189adb85)('more', 1400, (0, $25746eb61037a613$export$873e90337ab80c46).LiquidGlass)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).LightDetector]: [
        ...$26f90a9d628b605c$var$BASIC_TEMPERATURE_PROCESSORS,
        (0, $078fde33c51460bb$export$379842eafe3b6fc4),
        (0, $a44c208b5e8b1547$export$f5833ad2f79695c6),
        (0, $146e33189fd76c7e$export$fe5c94ae8809abbf),
        (0, $8a4805714fec5cfe$export$de363e709c412c8a)((0, $5b7cefe10d40dcb8$export$86a7974906ea63ee), 10)
    ],
    [(0, $25746eb61037a613$export$873e90337ab80c46).LightBulb]: [
        ...$26f90a9d628b605c$var$BASIC_TEMPERATURE_PROCESSORS,
        (0, $078fde33c51460bb$export$379842eafe3b6fc4),
        (0, $8ed9e703020e5c6d$export$150f2d0f217639cb),
        (0, $146e33189fd76c7e$export$fe5c94ae8809abbf),
        (0, $fac1c38a27d55666$export$2690b4089f4a5314),
        (0, $0c03ddc232f6bf98$export$56b8754592079e56)(0.1)
    ]
};
Object.keys($26f90a9d628b605c$export$9d44bc286fa91593).forEach((type)=>{
    const hasNoopDetector = $26f90a9d628b605c$export$9d44bc286fa91593[type].some((force)=>force === $26f90a9d628b605c$var$noopDetector);
    if (!hasNoopDetector) console.warn(`Noop detector is missing for ${type}`);
    else $26f90a9d628b605c$export$9d44bc286fa91593[type] = $26f90a9d628b605c$export$9d44bc286fa91593[type].filter((force)=>force !== $26f90a9d628b605c$var$noopDetector);
    if ((0, $8cf8e02aa778f380$export$1477cfa3b314a285)[type] && !$26f90a9d628b605c$export$9d44bc286fa91593[type].some((force)=>force.processorName === (0, $54b1901f91ac083a$export$4a7158be66f0b395))) console.warn(`Light source is missing for ${type}`);
});
Object.keys((0, $16d6e7cd696a8e6f$export$bc39e1390df11af7)).forEach((type)=>{
    $26f90a9d628b605c$export$9d44bc286fa91593[type] = [
        ...$26f90a9d628b605c$export$9d44bc286fa91593[type],
        (0, $316e54a969622f19$export$4abfe13a488de0cb)
    ];
});


const $015e2c7abb0bee24$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));









const $cb12b8b8642d52ce$var$MAX_SPEED = 6;
const $cb12b8b8642d52ce$var$MAX_UNUSED_ITERATIONS = 50;
const $cb12b8b8642d52ce$var$USE_POINT_EVERY_N_ITERATION = $cb12b8b8642d52ce$var$MAX_UNUSED_ITERATIONS;
const $cb12b8b8642d52ce$var$MAX_UNUSED_SPEED = 0.3;
let $cb12b8b8642d52ce$var$iteration = (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).get('iteration', 0);
// Add a flag to track if we should process a single step
let $cb12b8b8642d52ce$var$shouldProcessStep = false;
const $cb12b8b8642d52ce$export$746623013149fc35 = ()=>{
    $cb12b8b8642d52ce$var$shouldProcessStep = true;
};
const $cb12b8b8642d52ce$var$processFrame = ()=>{
    const points = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getActivePoints();
    const { left: left, right: right, top: top, bottom: bottom } = (0, $bab86e660d8728eb$export$c4e9d269599ab4b4).getBounds();
    $cb12b8b8642d52ce$var$iteration++;
    (0, $8fea30ee075cdb87$export$523813489278ed1b)();
    for(const index in points){
        const point = points[index];
        let isUnused = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).isUnused(point);
        if (point.wasDeleted) continue;
        // Ensure visual coordinates are initialized
        if (!point.visualCoordinates) point.visualCoordinates = {
            ...point.coordinates
        };
        // If smooth movement is disabled, update visual coordinates immediately
        if (!(0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getIsSmoothMovementEnabled()) {
            point.visualCoordinates.x = point.coordinates.x;
            point.visualCoordinates.y = point.coordinates.y;
        }
        if ($cb12b8b8642d52ce$var$iteration % $cb12b8b8642d52ce$var$USE_POINT_EVERY_N_ITERATION === 0 && +index % 10 === 0) {
            (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markPointAsUsed(point);
            isUnused = false;
        }
        if (!isUnused) {
            const forcesList = (0, $26f90a9d628b605c$export$9d44bc286fa91593)[point.type] || [];
            for (const force of forcesList)force(point, $cb12b8b8642d52ce$var$iteration);
        }
        let speedLength = Math.sqrt(point.speed.x ** 2 + point.speed.y ** 2);
        if (speedLength > $cb12b8b8642d52ce$var$MAX_SPEED) {
            point.speed.x *= $cb12b8b8642d52ce$var$MAX_SPEED / speedLength;
            point.speed.y *= $cb12b8b8642d52ce$var$MAX_SPEED / speedLength;
            speedLength = $cb12b8b8642d52ce$var$MAX_SPEED;
        }
        let timesProcess = Math.min(Math.max(1, Math.ceil(speedLength)), 10);
        if (!(0, $360a87d5b9cd525c$export$508f9609af06e33b)[point.type] && speedLength < $cb12b8b8642d52ce$var$MAX_UNUSED_SPEED && point.lastMoveOnIteration && $cb12b8b8642d52ce$var$iteration - point.lastMoveOnIteration > $cb12b8b8642d52ce$var$MAX_UNUSED_ITERATIONS) (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markPointAsUnused(point);
        while(timesProcess--){
            const prevX = point.coordinates.x;
            const prevY = point.coordinates.y;
            if (!isUnused) {
                const roundedSpeed = (0, $0db6937e29869b9b$export$60c0aaabc4c77337).getRoundedSpeed(point, true);
                const pointBySpeed = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getPointBySpeed(point, roundedSpeed);
                point.speed.x *= 0.95;
                point.speed.y *= 0.95;
                if (!pointBySpeed) {
                    point.coordinates.x += roundedSpeed.x;
                    point.coordinates.y += roundedSpeed.y;
                    point.lastMoveOnIteration = $cb12b8b8642d52ce$var$iteration;
                    (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).markNeighboursAsUsed(point);
                    (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).deletePointInIndex({
                        x: prevX,
                        y: prevY
                    });
                    (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).setPointInIndex(point.coordinates, point);
                }
            }
        }
        if (+index % 100 === 0) (0, $0db6937e29869b9b$export$60c0aaabc4c77337).shufflePossibleNeighbours();
        const isOutOfBounds = point.coordinates.x < left || point.coordinates.x > right || point.coordinates.y < top || point.coordinates.y > bottom;
        if (isOutOfBounds) (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).deletePoint(point);
    }
    (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).save();
    (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).shufflePoints();
    (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).set('iteration', $cb12b8b8642d52ce$var$iteration);
    (0, $57a22ed606f2167f$export$3e593816f425a913).calculateLighting();
};
let $cb12b8b8642d52ce$var$framesTimes = [];
let $cb12b8b8642d52ce$var$frames = 0;
const $cb12b8b8642d52ce$var$availableTime = 1000 / 60;
let $cb12b8b8642d52ce$var$lastStatsUpdate = performance.now();
let $cb12b8b8642d52ce$var$lastTemperatureUpdate = performance.now();
const $cb12b8b8642d52ce$export$8d3783709eddecb8 = async ()=>{
    let shouldWaitFor60FPS = true;
    while(true){
        const now = performance.now();
        // Check if simulation is paused or if we should process a step
        if (!(0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getIsPaused() || $cb12b8b8642d52ce$var$shouldProcessStep) {
            // Reset step flag
            $cb12b8b8642d52ce$var$shouldProcessStep = false;
            // Get simulation speed (use 1 for step mode)
            const simulationSpeed = (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getIsPaused() ? 1 : (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getSimulationSpeed();
            // Run the simulation based on speed setting
            // For speeds < 1, we process frames less frequently
            // For speeds > 1, we process multiple frames per cycle
            if (simulationSpeed >= 1) {
                // Process multiple frames for higher speeds
                const framesToProcess = (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getIsPaused() ? 1 : Math.floor(simulationSpeed);
                for(let i = 0; i < framesToProcess; i++)$cb12b8b8642d52ce$var$processFrame();
            } else {
                // For slow motion, only process frames occasionally
                // e.g., at speed 0.5, process every other frame
                const shouldProcessThisFrame = Math.random() < simulationSpeed;
                if (shouldProcessThisFrame) $cb12b8b8642d52ce$var$processFrame();
            }
            if (now - $cb12b8b8642d52ce$var$lastTemperatureUpdate >= $cb12b8b8642d52ce$var$availableTime) {
                (0, $f401cf2536c45f5a$export$a83c692ac725e2ca).updateGridFromPoints();
                (0, $f401cf2536c45f5a$export$a83c692ac725e2ca).processTemperatureFrame();
                (0, $f401cf2536c45f5a$export$a83c692ac725e2ca).updatePointsFromGrid();
                $cb12b8b8642d52ce$var$lastTemperatureUpdate = now;
            }
        }
        const nowAfterProcess = performance.now();
        const elapsedTime = nowAfterProcess - now;
        const remainingTime = !shouldWaitFor60FPS ? 0 : $cb12b8b8642d52ce$var$availableTime - elapsedTime;
        (0, $07a0e0a0b93620bf$export$3cdec2bba15e3523).setElapsedTime(elapsedTime);
        const timeElapsedPercent = elapsedTime / $cb12b8b8642d52ce$var$availableTime;
        (0, $07a0e0a0b93620bf$export$3cdec2bba15e3523).setLoad(timeElapsedPercent);
        await (0, $015e2c7abb0bee24$export$5c069c93d2b7493f)(Math.max(0, remainingTime));
        $cb12b8b8642d52ce$var$frames++;
        $cb12b8b8642d52ce$var$framesTimes.push(performance.now() - now);
        if ($cb12b8b8642d52ce$var$frames % 60 === 0) shouldWaitFor60FPS = !(0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getDebugMode() && !(0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getMaxSpeedMode();
        if (now - $cb12b8b8642d52ce$var$lastStatsUpdate >= 1000) {
            $cb12b8b8642d52ce$var$framesTimes = $cb12b8b8642d52ce$var$framesTimes.slice(-100);
            const averageFrameTime = $cb12b8b8642d52ce$var$framesTimes.reduce((acc, time)=>acc + time, 0) / $cb12b8b8642d52ce$var$framesTimes.length;
            const fps = 1000 / averageFrameTime;
            (0, $07a0e0a0b93620bf$export$3cdec2bba15e3523).setFps(fps);
            (0, $07a0e0a0b93620bf$export$3cdec2bba15e3523).setAverageSpeed((0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getActivePoints().reduce((acc, point)=>acc + Math.abs(point.speed.x) + Math.abs(point.speed.y), 0) / (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getActivePoints().length);
            $cb12b8b8642d52ce$var$lastStatsUpdate = now;
        }
    }
};









const $2bc8b61bc422460f$var$api = {
    Points: $8c2070529dc8eec8$export$1c787534cb11aa3e,
    Controls: $6b3e82ea4b803b12$export$c7c44baae9d9f25f,
    Speed: $0db6937e29869b9b$export$60c0aaabc4c77337,
    Bounds: $bab86e660d8728eb$export$c4e9d269599ab4b4,
    TemperatureGrid: $f401cf2536c45f5a$export$a83c692ac725e2ca,
    Connections: $f243af196a25f578$export$f3ea0776119f0e84,
    random: {
        __fromRandomCount: $6de2ed3e5d01eb29$export$ff07e02f86da72e2,
        __fromBufferCount: $6de2ed3e5d01eb29$export$8707e673f135b79e,
        __bufferSize: $6de2ed3e5d01eb29$export$1edf699114815981
    }
};
const $2bc8b61bc422460f$export$262288d7716e04c6 = ()=>{
    window.api = $2bc8b61bc422460f$var$api;
};


var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));




parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $6c32d828ed838d7b$export$8a75c83865bcf9dd(control) {
    const [localValue, setLocalValue] = (0, $acw62.useState)((0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).state[control]);
    (0, $acw62.useEffect)(()=>{
        return (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).subscribe(control, (state)=>setLocalValue(state[control]));
    }, [
        control
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).setState(control, localValue);
    }, [
        localValue
    ]);
    return [
        localValue,
        setLocalValue
    ];
}


var $a5bdec834b919a00$export$fb1b4b0e602f43f1;
var $a5bdec834b919a00$export$96d5d30b5a4a4c16;
var $a5bdec834b919a00$export$e8c9778bf415dd08;
var $a5bdec834b919a00$export$d01df6464fa48bad;
var $a5bdec834b919a00$export$bbd811db8e2a5b5e;
var $a5bdec834b919a00$export$f36792cb9bd81925;
var $a5bdec834b919a00$export$91bc5dc3bf221ff4;
var $a5bdec834b919a00$export$1ca1ec8b29a4ce27;
var $a5bdec834b919a00$export$ffacadc13768e1a3;
var $a5bdec834b919a00$export$775ab2407e846dbe;
var $a5bdec834b919a00$export$4c7897fafd92b108;
var $a5bdec834b919a00$export$e72cf0edcb61a6cd;
var $a5bdec834b919a00$export$84387c39da17f8d8;
var $a5bdec834b919a00$export$ec0409edb5e28490;
$a5bdec834b919a00$export$fb1b4b0e602f43f1 = `EdyUFG_appear`;
$a5bdec834b919a00$export$fb1b4b0e602f43f1;
$a5bdec834b919a00$export$96d5d30b5a4a4c16 = `EdyUFG_disappear`;
$a5bdec834b919a00$export$96d5d30b5a4a4c16;
$a5bdec834b919a00$export$e8c9778bf415dd08 = `EdyUFG_divider`;
$a5bdec834b919a00$export$d01df6464fa48bad = `EdyUFG_elementsRow`;
$a5bdec834b919a00$export$bbd811db8e2a5b5e = `EdyUFG_floatingButton`;
$a5bdec834b919a00$export$f36792cb9bd81925 = `EdyUFG_groupContainer`;
$a5bdec834b919a00$export$91bc5dc3bf221ff4 = `EdyUFG_groupTitle`;
$a5bdec834b919a00$export$1ca1ec8b29a4ce27 = `EdyUFG_icon`;
$a5bdec834b919a00$export$ffacadc13768e1a3 = `EdyUFG_isClosing`;
$a5bdec834b919a00$export$775ab2407e846dbe = `EdyUFG_isOpened`;
$a5bdec834b919a00$export$4c7897fafd92b108 = `EdyUFG_last`;
$a5bdec834b919a00$export$e72cf0edcb61a6cd = `EdyUFG_panelButton`;
$a5bdec834b919a00$export$84387c39da17f8d8 = `EdyUFG_panelContainer`;
$a5bdec834b919a00$export$ec0409edb5e28490 = `EdyUFG_shortcut`;


var $60313e3b9e75c852$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, $60313e3b9e75c852$exports) {
        classNames.default = classNames;
        $60313e3b9e75c852$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



/*
* React Tooltip
* {@link https://github.com/ReactTooltip/react-tooltip}
* @copyright ReactTooltip Team
* @license MIT
*/ 
var $acw62 = parcelRequire("acw62");
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $10310cf078d13212$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $10310cf078d13212$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $10310cf078d13212$export$803cd8101b6c182b = /*#__PURE__*/ $10310cf078d13212$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[0], side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[1]), []);
const $10310cf078d13212$export$96ec731ed4dcb222 = Math.min;
const $10310cf078d13212$export$8960430cfd85939f = Math.max;
const $10310cf078d13212$export$2077e0241d6afd3c = Math.round;
const $10310cf078d13212$export$a3fe094919f356fd = Math.floor;
const $10310cf078d13212$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $10310cf078d13212$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $10310cf078d13212$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $10310cf078d13212$export$7d15b64cf5a3a4c4(start, value, end) {
    return $10310cf078d13212$export$8960430cfd85939f(start, $10310cf078d13212$export$96ec731ed4dcb222(value, end));
}
function $10310cf078d13212$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $10310cf078d13212$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $10310cf078d13212$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $10310cf078d13212$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $10310cf078d13212$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $10310cf078d13212$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($10310cf078d13212$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $10310cf078d13212$export$2b57e0052a6d6d4c(placement) {
    return $10310cf078d13212$export$8a000a963141ac32($10310cf078d13212$export$f28e8f882010718a(placement));
}
function $10310cf078d13212$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    const alignmentAxis = $10310cf078d13212$export$2b57e0052a6d6d4c(placement);
    const length = $10310cf078d13212$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $10310cf078d13212$export$496432a3699e50b1(placement) {
    const oppositePlacement = $10310cf078d13212$export$9c5e28bad23365fa(placement);
    return [
        $10310cf078d13212$export$2b182c584985588b(placement),
        oppositePlacement,
        $10310cf078d13212$export$2b182c584985588b(oppositePlacement)
    ];
}
function $10310cf078d13212$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$10310cf078d13212$var$oppositeAlignmentMap[alignment]);
}
function $10310cf078d13212$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $10310cf078d13212$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    let list = $10310cf078d13212$var$getSideList($10310cf078d13212$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($10310cf078d13212$export$2b182c584985588b));
    }
    return list;
}
function $10310cf078d13212$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$10310cf078d13212$var$oppositeSideMap[side]);
}
function $10310cf078d13212$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $10310cf078d13212$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $10310cf078d13212$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $10310cf078d13212$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $973e4da43f2a375d$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $10310cf078d13212$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $10310cf078d13212$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $10310cf078d13212$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $973e4da43f2a375d$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $973e4da43f2a375d$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $10310cf078d13212$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $10310cf078d13212$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $973e4da43f2a375d$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $10310cf078d13212$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $10310cf078d13212$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $10310cf078d13212$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $10310cf078d13212$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $10310cf078d13212$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $973e4da43f2a375d$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $10310cf078d13212$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $10310cf078d13212$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $973e4da43f2a375d$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $10310cf078d13212$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $10310cf078d13212$export$803cd8101b6c182b) ? $973e4da43f2a375d$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $10310cf078d13212$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $10310cf078d13212$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $10310cf078d13212$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $973e4da43f2a375d$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $10310cf078d13212$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $10310cf078d13212$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $10310cf078d13212$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $10310cf078d13212$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $10310cf078d13212$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $973e4da43f2a375d$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $973e4da43f2a375d$var$isAnySideFullyClipped(overflow) {
    return (0, $10310cf078d13212$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $973e4da43f2a375d$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $973e4da43f2a375d$var$getBoundingRect(rects) {
    const minX = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $10310cf078d13212$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $10310cf078d13212$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $973e4da43f2a375d$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $10310cf078d13212$export$ee05aea0aeecbad4)($973e4da43f2a375d$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $973e4da43f2a375d$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $973e4da43f2a375d$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $10310cf078d13212$export$ee05aea0aeecbad4)($973e4da43f2a375d$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $10310cf078d13212$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $10310cf078d13212$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $973e4da43f2a375d$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $10310cf078d13212$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $973e4da43f2a375d$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $973e4da43f2a375d$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $973e4da43f2a375d$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $10310cf078d13212$export$f28e8f882010718a)((0, $10310cf078d13212$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $10310cf078d13212$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $973e4da43f2a375d$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $10310cf078d13212$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $10310cf078d13212$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $10310cf078d13212$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $973e4da43f2a375d$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $10310cf078d13212$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $10310cf078d13212$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $238ac70369f38756$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $238ac70369f38756$export$651544f548703224(node) {
    if ($238ac70369f38756$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $238ac70369f38756$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $238ac70369f38756$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($238ac70369f38756$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $238ac70369f38756$export$8ee0fc9ee280b4ee(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Node;
}
function $238ac70369f38756$export$45a5e7f76e0caa8d(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Element;
}
function $238ac70369f38756$export$1b3bfaa9684536aa(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).HTMLElement;
}
function $238ac70369f38756$export$af51f0f06c0f328a(value) {
    if (!$238ac70369f38756$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $238ac70369f38756$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $238ac70369f38756$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $238ac70369f38756$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($238ac70369f38756$export$651544f548703224(element));
}
function $238ac70369f38756$export$89e651af02346cd4(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $238ac70369f38756$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $238ac70369f38756$export$78551043582a6a98();
    const css = $238ac70369f38756$export$45a5e7f76e0caa8d(elementOrCss) ? $238ac70369f38756$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective'
    ].some((value)=>css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $238ac70369f38756$export$940d8225183e1404(element) {
    let currentNode = $238ac70369f38756$export$4e12058fc4d51d56(element);
    while($238ac70369f38756$export$1b3bfaa9684536aa(currentNode) && !$238ac70369f38756$export$d1162fb0b6d4cd51(currentNode)){
        if ($238ac70369f38756$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($238ac70369f38756$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $238ac70369f38756$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $238ac70369f38756$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $238ac70369f38756$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($238ac70369f38756$export$651544f548703224(node));
}
function $238ac70369f38756$export$3735103072e4a80(element) {
    return $238ac70369f38756$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $238ac70369f38756$export$dc8fc79fa2800137(element) {
    if ($238ac70369f38756$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $238ac70369f38756$export$4e12058fc4d51d56(node) {
    if ($238ac70369f38756$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $238ac70369f38756$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $238ac70369f38756$export$e495491855dc5418(node);
    return $238ac70369f38756$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $238ac70369f38756$export$7cd01a57c8ca906c(node) {
    const parentNode = $238ac70369f38756$export$4e12058fc4d51d56(node);
    if ($238ac70369f38756$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($238ac70369f38756$export$1b3bfaa9684536aa(parentNode) && $238ac70369f38756$export$989e911fa9af580a(parentNode)) return parentNode;
    return $238ac70369f38756$export$7cd01a57c8ca906c(parentNode);
}
function $238ac70369f38756$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $238ac70369f38756$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $238ac70369f38756$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $238ac70369f38756$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $238ac70369f38756$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $238ac70369f38756$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $238ac70369f38756$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $238ac70369f38756$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $461947879dcdbcd4$var$getCssDimensions(element) {
    const css = (0, $238ac70369f38756$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $10310cf078d13212$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $10310cf078d13212$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $461947879dcdbcd4$var$unwrapElement(element) {
    return !(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $461947879dcdbcd4$var$getScale(element) {
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    if (!(0, $238ac70369f38756$export$1b3bfaa9684536aa)(domElement)) return (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $461947879dcdbcd4$var$getCssDimensions(domElement);
    let x = ($ ? (0, $10310cf078d13212$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $10310cf078d13212$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $461947879dcdbcd4$var$noOffsets = /*#__PURE__*/ (0, $10310cf078d13212$export$a397704b5e280835)(0);
function $461947879dcdbcd4$var$getVisualOffsets(element) {
    const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(element);
    if (!(0, $238ac70369f38756$export$78551043582a6a98)() || !win.visualViewport) return $461947879dcdbcd4$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $461947879dcdbcd4$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $238ac70369f38756$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $461947879dcdbcd4$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    let scale = (0, $10310cf078d13212$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(offsetParent)) scale = $461947879dcdbcd4$var$getScale(offsetParent);
        } else scale = $461947879dcdbcd4$var$getScale(element);
    }
    const visualOffsets = $461947879dcdbcd4$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $461947879dcdbcd4$var$getVisualOffsets(domElement) : (0, $10310cf078d13212$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $238ac70369f38756$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $238ac70369f38756$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $238ac70369f38756$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $461947879dcdbcd4$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $238ac70369f38756$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $238ac70369f38756$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $238ac70369f38756$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $10310cf078d13212$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $461947879dcdbcd4$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $461947879dcdbcd4$var$getBoundingClientRect((0, $238ac70369f38756$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $461947879dcdbcd4$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $238ac70369f38756$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $238ac70369f38756$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const offsets = (0, $10310cf078d13212$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $238ac70369f38756$export$651544f548703224)(offsetParent) !== 'body' || (0, $238ac70369f38756$export$989e911fa9af580a)(documentElement)) scroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $238ac70369f38756$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent);
            scale = $461947879dcdbcd4$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll, true) : (0, $10310cf078d13212$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $461947879dcdbcd4$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $461947879dcdbcd4$var$getDocumentRect(element) {
    const html = (0, $238ac70369f38756$export$e495491855dc5418)(element);
    const scroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $10310cf078d13212$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $10310cf078d13212$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $461947879dcdbcd4$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $238ac70369f38756$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $10310cf078d13212$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getViewportRect(element, strategy) {
    const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(element);
    const html = (0, $238ac70369f38756$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $238ac70369f38756$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $461947879dcdbcd4$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(element) ? $461947879dcdbcd4$var$getScale(element) : (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $461947879dcdbcd4$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $461947879dcdbcd4$var$getDocumentRect((0, $238ac70369f38756$export$e495491855dc5418)(element));
    else if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $461947879dcdbcd4$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $461947879dcdbcd4$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $10310cf078d13212$export$ee05aea0aeecbad4)(rect);
}
function $461947879dcdbcd4$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $238ac70369f38756$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(parentNode) || (0, $238ac70369f38756$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $238ac70369f38756$export$3735103072e4a80)(parentNode).position === 'fixed' || $461947879dcdbcd4$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $461947879dcdbcd4$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $238ac70369f38756$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(el) && (0, $238ac70369f38756$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $238ac70369f38756$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $238ac70369f38756$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(currentNode) && !(0, $238ac70369f38756$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $238ac70369f38756$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $238ac70369f38756$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $238ac70369f38756$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $461947879dcdbcd4$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $238ac70369f38756$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $461947879dcdbcd4$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $238ac70369f38756$export$89e651af02346cd4)(element) ? [] : $461947879dcdbcd4$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $10310cf078d13212$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $10310cf078d13212$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $10310cf078d13212$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $10310cf078d13212$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $461947879dcdbcd4$var$getDimensions(element) {
    const { width: width, height: height } = $461947879dcdbcd4$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $461947879dcdbcd4$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $238ac70369f38756$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $10310cf078d13212$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $238ac70369f38756$export$651544f548703224)(offsetParent) !== 'body' || (0, $238ac70369f38756$export$989e911fa9af580a)(documentElement)) scroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $461947879dcdbcd4$var$getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll) : (0, $10310cf078d13212$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $461947879dcdbcd4$var$isStaticPositioned(element) {
    return (0, $238ac70369f38756$export$3735103072e4a80)(element).position === 'static';
}
function $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $238ac70369f38756$export$1b3bfaa9684536aa)(element) || (0, $238ac70369f38756$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $238ac70369f38756$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $461947879dcdbcd4$var$getOffsetParent(element, polyfill) {
    const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(element);
    if ((0, $238ac70369f38756$export$89e651af02346cd4)(element)) return win;
    if (!(0, $238ac70369f38756$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $238ac70369f38756$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $238ac70369f38756$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$461947879dcdbcd4$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $238ac70369f38756$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $238ac70369f38756$export$71535ffaa902797f)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent))offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $238ac70369f38756$export$d1162fb0b6d4cd51)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent) && !(0, $238ac70369f38756$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $238ac70369f38756$export$940d8225183e1404)(element) || win;
}
const $461947879dcdbcd4$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $461947879dcdbcd4$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $461947879dcdbcd4$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $461947879dcdbcd4$var$isRTL(element) {
    return (0, $238ac70369f38756$export$3735103072e4a80)(element).direction === 'rtl';
}
const $461947879dcdbcd4$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $238ac70369f38756$export$e495491855dc5418,
    getClippingRect: $461947879dcdbcd4$var$getClippingRect,
    getOffsetParent: $461947879dcdbcd4$var$getOffsetParent,
    getElementRects: $461947879dcdbcd4$var$getElementRects,
    getClientRects: $461947879dcdbcd4$var$getClientRects,
    getDimensions: $461947879dcdbcd4$var$getDimensions,
    getScale: $461947879dcdbcd4$var$getScale,
    isElement: $238ac70369f38756$export$45a5e7f76e0caa8d,
    isRTL: $461947879dcdbcd4$var$isRTL
};
function $461947879dcdbcd4$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $461947879dcdbcd4$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $238ac70369f38756$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $10310cf078d13212$export$a3fe094919f356fd)(top);
        const insetRight = (0, $10310cf078d13212$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $10310cf078d13212$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $10310cf078d13212$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $10310cf078d13212$export$8960430cfd85939f)(0, (0, $10310cf078d13212$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$461947879dcdbcd4$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $461947879dcdbcd4$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $461947879dcdbcd4$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $238ac70369f38756$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $238ac70369f38756$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $461947879dcdbcd4$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $461947879dcdbcd4$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $461947879dcdbcd4$var$getBoundingClientRect(reference);
        if (prevRefRect && !$461947879dcdbcd4$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $461947879dcdbcd4$export$37b6bde19b108ecc = (0, $973e4da43f2a375d$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $461947879dcdbcd4$export$cc800923e997bb8 = (0, $973e4da43f2a375d$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $461947879dcdbcd4$export$91fb6ecbd551914 = (0, $973e4da43f2a375d$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $461947879dcdbcd4$export$fba63a578e423eb = (0, $973e4da43f2a375d$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $461947879dcdbcd4$export$8a83211c878a3f1f = (0, $973e4da43f2a375d$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $461947879dcdbcd4$export$346677f925de839c = (0, $973e4da43f2a375d$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $461947879dcdbcd4$export$fe8985bb6374093c = (0, $973e4da43f2a375d$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $461947879dcdbcd4$export$f2120bbfa5450bd2 = (0, $973e4da43f2a375d$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $461947879dcdbcd4$export$18c8ad048e32c7d5 = (0, $973e4da43f2a375d$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $461947879dcdbcd4$export$7bf07e38f3dc4b69 = (0, $973e4da43f2a375d$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $461947879dcdbcd4$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $461947879dcdbcd4$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $973e4da43f2a375d$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};




var $hPtJY = parcelRequire("hPtJY");
const $b6649b19c980ca22$var$h = "react-tooltip-core-styles", $b6649b19c980ca22$var$w = "react-tooltip-base-styles", $b6649b19c980ca22$var$b = {
    core: !1,
    base: !1
};
function $b6649b19c980ca22$var$S({ css: e, id: t = $b6649b19c980ca22$var$w, type: o = "base", ref: l }) {
    var r, n;
    if (!e || "undefined" == typeof document || $b6649b19c980ca22$var$b[o]) return;
    if ("core" === o && "undefined" != typeof $hPtJY && (null === (r = null === $hPtJY || void 0 === $hPtJY ? void 0 : $hPtJY.env) || void 0 === r ? void 0 : r.REACT_TOOLTIP_DISABLE_CORE_STYLES)) return;
    if ("base" !== o && "undefined" != typeof $hPtJY && (null === (n = null === $hPtJY || void 0 === $hPtJY ? void 0 : $hPtJY.env) || void 0 === n ? void 0 : n.REACT_TOOLTIP_DISABLE_BASE_STYLES)) return;
    "core" === o && (t = $b6649b19c980ca22$var$h), l || (l = {});
    const { insertAt: i } = l;
    if (document.getElementById(t)) return;
    const c = document.head || document.getElementsByTagName("head")[0], s = document.createElement("style");
    s.id = t, s.type = "text/css", "top" === i && c.firstChild ? c.insertBefore(s, c.firstChild) : c.appendChild(s), s.styleSheet ? s.styleSheet.cssText = e : s.appendChild(document.createTextNode(e)), $b6649b19c980ca22$var$b[o] = !0;
}
function $b6649b19c980ca22$export$afe978aceb0adefd({ type: e = "base", id: t = $b6649b19c980ca22$var$w } = {}) {
    if (!$b6649b19c980ca22$var$b[e]) return;
    "core" === e && (t = $b6649b19c980ca22$var$h);
    const o = document.getElementById(t);
    "style" === (null == o ? void 0 : o.tagName) ? null == o || o.remove() : console.warn(`[react-tooltip] Failed to remove 'style' element with id '${t}'. Call \`injectStyle()\` first`), $b6649b19c980ca22$var$b[e] = !1;
}
const $b6649b19c980ca22$var$E = async ({ elementReference: e = null, tooltipReference: t = null, tooltipArrowReference: o = null, place: l = "top", offset: r = 10, strategy: n = "absolute", middlewares: i = [
    (0, $461947879dcdbcd4$export$cc800923e997bb8)(Number(r)),
    (0, $461947879dcdbcd4$export$8a83211c878a3f1f)({
        fallbackAxisSideDirection: "start"
    }),
    (0, $461947879dcdbcd4$export$fba63a578e423eb)({
        padding: 5
    })
], border: c })=>{
    if (!e) return {
        tooltipStyles: {},
        tooltipArrowStyles: {},
        place: l
    };
    if (null === t) return {
        tooltipStyles: {},
        tooltipArrowStyles: {},
        place: l
    };
    const s = i;
    return o ? (s.push((0, $461947879dcdbcd4$export$f2120bbfa5450bd2)({
        element: o,
        padding: 5
    })), (0, $461947879dcdbcd4$export$48a53dcb22e581d0)(e, t, {
        placement: l,
        strategy: n,
        middleware: s
    }).then(({ x: e, y: t, placement: o, middlewareData: l })=>{
        var r, n;
        const i = {
            left: `${e}px`,
            top: `${t}px`,
            border: c
        }, { x: s, y: a } = null !== (r = l.arrow) && void 0 !== r ? r : {
            x: 0,
            y: 0
        }, u = null !== (n = ({
            top: "bottom",
            right: "left",
            bottom: "top",
            left: "right"
        })[o.split("-")[0]]) && void 0 !== n ? n : "bottom", d = c && {
            borderBottom: c,
            borderRight: c
        };
        let p = 0;
        if (c) {
            const e = `${c}`.match(/(\d+)px/);
            p = (null == e ? void 0 : e[1]) ? Number(e[1]) : 1;
        }
        return {
            tooltipStyles: i,
            tooltipArrowStyles: {
                left: null != s ? `${s}px` : "",
                top: null != a ? `${a}px` : "",
                right: "",
                bottom: "",
                ...d,
                [u]: `-${4 + p}px`
            },
            place: o
        };
    })) : (0, $461947879dcdbcd4$export$48a53dcb22e581d0)(e, t, {
        placement: "bottom",
        strategy: n,
        middleware: s
    }).then(({ x: e, y: t, placement: o })=>({
            tooltipStyles: {
                left: `${e}px`,
                top: `${t}px`
            },
            tooltipArrowStyles: {},
            place: o
        }));
}, $b6649b19c980ca22$var$A = (e, t)=>!("CSS" in window && "supports" in window.CSS) || window.CSS.supports(e, t), $b6649b19c980ca22$var$_ = (e, t, o)=>{
    let l = null;
    const r = function(...r) {
        const n = ()=>{
            l = null, o || e.apply(this, r);
        };
        o && !l && (e.apply(this, r), l = setTimeout(n, t)), o || (l && clearTimeout(l), l = setTimeout(n, t));
    };
    return r.cancel = ()=>{
        l && (clearTimeout(l), l = null);
    }, r;
}, $b6649b19c980ca22$var$O = (e)=>null !== e && !Array.isArray(e) && "object" == typeof e, $b6649b19c980ca22$var$k = (e, t)=>{
    if (e === t) return !0;
    if (Array.isArray(e) && Array.isArray(t)) return e.length === t.length && e.every((e, o)=>$b6649b19c980ca22$var$k(e, t[o]));
    if (Array.isArray(e) !== Array.isArray(t)) return !1;
    if (!$b6649b19c980ca22$var$O(e) || !$b6649b19c980ca22$var$O(t)) return e === t;
    const o = Object.keys(e), l = Object.keys(t);
    return o.length === l.length && o.every((o)=>$b6649b19c980ca22$var$k(e[o], t[o]));
}, $b6649b19c980ca22$var$T = (e)=>{
    if (!(e instanceof HTMLElement || e instanceof SVGElement)) return !1;
    const t = getComputedStyle(e);
    return [
        "overflow",
        "overflow-x",
        "overflow-y"
    ].some((e)=>{
        const o = t.getPropertyValue(e);
        return "auto" === o || "scroll" === o;
    });
}, $b6649b19c980ca22$var$L = (e)=>{
    if (!e) return null;
    let t = e.parentElement;
    for(; t;){
        if ($b6649b19c980ca22$var$T(t)) return t;
        t = t.parentElement;
    }
    return document.scrollingElement || document.documentElement;
}, $b6649b19c980ca22$var$C = "undefined" != typeof window ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect), $b6649b19c980ca22$var$R = (e)=>{
    e.current && (clearTimeout(e.current), e.current = null);
}, $b6649b19c980ca22$var$x = "DEFAULT_TOOLTIP_ID", $b6649b19c980ca22$var$N = {
    anchorRefs: new Set,
    activeAnchor: {
        current: null
    },
    attach: ()=>{},
    detach: ()=>{},
    setActiveAnchor: ()=>{}
}, $b6649b19c980ca22$var$$ = (0, $acw62.createContext)({
    getTooltipData: ()=>$b6649b19c980ca22$var$N
}), $b6649b19c980ca22$export$f78649fb9ca566b8 = ({ children: t })=>{
    const [o, l] = (0, $acw62.useState)({
        [$b6649b19c980ca22$var$x]: new Set
    }), [c, s] = (0, $acw62.useState)({
        [$b6649b19c980ca22$var$x]: {
            current: null
        }
    }), a = (e, ...t)=>{
        l((o)=>{
            var l;
            const r = null !== (l = o[e]) && void 0 !== l ? l : new Set;
            return t.forEach((e)=>r.add(e)), {
                ...o,
                [e]: new Set(r)
            };
        });
    }, u = (e, ...t)=>{
        l((o)=>{
            const l = o[e];
            return l ? (t.forEach((e)=>l.delete(e)), {
                ...o
            }) : o;
        });
    }, d = (0, $acw62.useCallback)((e = $b6649b19c980ca22$var$x)=>{
        var t, l;
        return {
            anchorRefs: null !== (t = o[e]) && void 0 !== t ? t : new Set,
            activeAnchor: null !== (l = c[e]) && void 0 !== l ? l : {
                current: null
            },
            attach: (...t)=>a(e, ...t),
            detach: (...t)=>u(e, ...t),
            setActiveAnchor: (t)=>((e, t)=>{
                    s((o)=>{
                        var l;
                        return (null === (l = o[e]) || void 0 === l ? void 0 : l.current) === t.current ? o : {
                            ...o,
                            [e]: t
                        };
                    });
                })(e, t)
        };
    }, [
        o,
        c,
        a,
        u
    ]), p = (0, $acw62.useMemo)(()=>({
            getTooltipData: d
        }), [
        d
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b6649b19c980ca22$var$$.Provider, {
        value: p
    }, t);
};
function $b6649b19c980ca22$var$j(e = $b6649b19c980ca22$var$x) {
    return (0, $acw62.useContext)($b6649b19c980ca22$var$$).getTooltipData(e);
}
const $b6649b19c980ca22$export$57a09c4864b20b90 = ({ tooltipId: t, children: l, className: r, place: n, content: i, html: c, variant: a, offset: u, wrapper: d, events: p, positionStrategy: v, delayShow: m, delayHide: f })=>{
    const { attach: h, detach: w } = $b6649b19c980ca22$var$j(t), b = (0, $acw62.useRef)(null);
    return (0, $acw62.useEffect)(()=>(h(b), ()=>{
            w(b);
        }), []), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ref: b,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("react-tooltip-wrapper", r),
        "data-tooltip-place": n,
        "data-tooltip-content": i,
        "data-tooltip-html": c,
        "data-tooltip-variant": a,
        "data-tooltip-offset": u,
        "data-tooltip-wrapper": d,
        "data-tooltip-events": p,
        "data-tooltip-position-strategy": v,
        "data-tooltip-delay-show": m,
        "data-tooltip-delay-hide": f
    }, l);
};
var $b6649b19c980ca22$var$z = {
    tooltip: "core-styles-module_tooltip__3vRRp",
    fixed: "core-styles-module_fixed__pcSol",
    arrow: "core-styles-module_arrow__cvMwQ",
    noArrow: "core-styles-module_noArrow__xock6",
    clickable: "core-styles-module_clickable__ZuTTB",
    show: "core-styles-module_show__Nt9eE",
    closing: "core-styles-module_closing__sGnxF"
}, $b6649b19c980ca22$var$D = {
    tooltip: "styles-module_tooltip__mnnfp",
    arrow: "styles-module_arrow__K0L3T",
    dark: "styles-module_dark__xNqje",
    light: "styles-module_light__Z6W-X",
    success: "styles-module_success__A2AKt",
    warning: "styles-module_warning__SCK0X",
    error: "styles-module_error__JvumD",
    info: "styles-module_info__BWdHW"
};
const $b6649b19c980ca22$var$q = ({ forwardRef: t, id: l, className: i, classNameArrow: c, variant: u = "dark", anchorId: d, anchorSelect: p, place: v = "top", offset: m = 10, events: h = [
    "hover"
], openOnClick: w = !1, positionStrategy: b = "absolute", middlewares: S, wrapper: g, delayShow: A = 0, delayHide: O = 0, float: T = !1, hidden: x = !1, noArrow: N = !1, clickable: $ = !1, closeOnEsc: I = !1, closeOnScroll: B = !1, closeOnResize: q = !1, openEvents: H, closeEvents: M, globalCloseEvents: W, imperativeModeOnly: P, style: V, position: F, afterShow: K, afterHide: U, disableTooltip: X, content: Y, contentWrapperRef: G, isOpen: Z, defaultIsOpen: J = !1, setIsOpen: Q, activeAnchor: ee, setActiveAnchor: te, border: oe, opacity: le, arrowColor: re, role: ne = "tooltip" })=>{
    var ie;
    const ce = (0, $acw62.useRef)(null), se = (0, $acw62.useRef)(null), ae = (0, $acw62.useRef)(null), ue = (0, $acw62.useRef)(null), de = (0, $acw62.useRef)(null), [pe, ve] = (0, $acw62.useState)({
        tooltipStyles: {},
        tooltipArrowStyles: {},
        place: v
    }), [me, fe] = (0, $acw62.useState)(!1), [ye, he] = (0, $acw62.useState)(!1), [we, be] = (0, $acw62.useState)(null), Se = (0, $acw62.useRef)(!1), ge = (0, $acw62.useRef)(null), { anchorRefs: Ee, setActiveAnchor: Ae } = $b6649b19c980ca22$var$j(l), _e = (0, $acw62.useRef)(!1), [Oe, ke] = (0, $acw62.useState)([]), Te = (0, $acw62.useRef)(!1), Le = w || h.includes("click"), Ce = Le || (null == H ? void 0 : H.click) || (null == H ? void 0 : H.dblclick) || (null == H ? void 0 : H.mousedown), Re = H ? {
        ...H
    } : {
        mouseover: !0,
        focus: !0,
        mouseenter: !1,
        click: !1,
        dblclick: !1,
        mousedown: !1
    };
    !H && Le && Object.assign(Re, {
        mouseenter: !1,
        focus: !1,
        mouseover: !1,
        click: !0
    });
    const xe = M ? {
        ...M
    } : {
        mouseout: !0,
        blur: !0,
        mouseleave: !1,
        click: !1,
        dblclick: !1,
        mouseup: !1
    };
    !M && Le && Object.assign(xe, {
        mouseleave: !1,
        blur: !1,
        mouseout: !1
    });
    const Ne = W ? {
        ...W
    } : {
        escape: I || !1,
        scroll: B || !1,
        resize: q || !1,
        clickOutsideAnchor: Ce || !1
    };
    P && (Object.assign(Re, {
        mouseenter: !1,
        focus: !1,
        click: !1,
        dblclick: !1,
        mousedown: !1
    }), Object.assign(xe, {
        mouseleave: !1,
        blur: !1,
        click: !1,
        dblclick: !1,
        mouseup: !1
    }), Object.assign(Ne, {
        escape: !1,
        scroll: !1,
        resize: !1,
        clickOutsideAnchor: !1
    })), $b6649b19c980ca22$var$C(()=>(Te.current = !0, ()=>{
            Te.current = !1;
        }), []);
    const $e = (e)=>{
        Te.current && (e && he(!0), setTimeout(()=>{
            Te.current && (null == Q || Q(e), void 0 === Z && fe(e));
        }, 10));
    };
    (0, $acw62.useEffect)(()=>{
        if (void 0 === Z) return ()=>null;
        Z && he(!0);
        const e = setTimeout(()=>{
            fe(Z);
        }, 10);
        return ()=>{
            clearTimeout(e);
        };
    }, [
        Z
    ]), (0, $acw62.useEffect)(()=>{
        if (me !== Se.current) {
            if ($b6649b19c980ca22$var$R(de), Se.current = me, me) null == K || K();
            else {
                const e = ((e)=>{
                    const t = e.match(/^([\d.]+)(ms|s)$/);
                    if (!t) return 0;
                    const [, o, l] = t;
                    return Number(o) * ("ms" === l ? 1 : 1e3);
                })(getComputedStyle(document.body).getPropertyValue("--rt-transition-show-delay"));
                de.current = setTimeout(()=>{
                    he(!1), be(null), null == U || U();
                }, e + 25);
            }
        }
    }, [
        me
    ]);
    const Ie = (e)=>{
        ve((t)=>$b6649b19c980ca22$var$k(t, e) ? t : e);
    }, je = (e = A)=>{
        $b6649b19c980ca22$var$R(ae), ye ? $e(!0) : ae.current = setTimeout(()=>{
            $e(!0);
        }, e);
    }, Be = (e = O)=>{
        $b6649b19c980ca22$var$R(ue), ue.current = setTimeout(()=>{
            _e.current || $e(!1);
        }, e);
    }, ze = (e)=>{
        var t;
        if (!e) return;
        const o = null !== (t = e.currentTarget) && void 0 !== t ? t : e.target;
        if (!(null == o ? void 0 : o.isConnected)) return te(null), void Ae({
            current: null
        });
        A ? je() : $e(!0), te(o), Ae({
            current: o
        }), $b6649b19c980ca22$var$R(ue);
    }, De = ()=>{
        $ ? Be(O || 100) : O ? Be() : $e(!1), $b6649b19c980ca22$var$R(ae);
    }, qe = ({ x: e, y: t })=>{
        var o;
        const l = {
            getBoundingClientRect: ()=>({
                    x: e,
                    y: t,
                    width: 0,
                    height: 0,
                    top: t,
                    left: e,
                    right: e,
                    bottom: t
                })
        };
        $b6649b19c980ca22$var$E({
            place: null !== (o = null == we ? void 0 : we.place) && void 0 !== o ? o : v,
            offset: m,
            elementReference: l,
            tooltipReference: ce.current,
            tooltipArrowReference: se.current,
            strategy: b,
            middlewares: S,
            border: oe
        }).then((e)=>{
            Ie(e);
        });
    }, He = (e)=>{
        if (!e) return;
        const t = e, o = {
            x: t.clientX,
            y: t.clientY
        };
        qe(o), ge.current = o;
    }, Me = (e)=>{
        var t;
        if (!me) return;
        const o = e.target;
        if (!o.isConnected) return;
        if (null === (t = ce.current) || void 0 === t ? void 0 : t.contains(o)) return;
        [
            document.querySelector(`[id='${d}']`),
            ...Oe
        ].some((e)=>null == e ? void 0 : e.contains(o)) || ($e(!1), $b6649b19c980ca22$var$R(ae));
    }, We = $b6649b19c980ca22$var$_(ze, 50, !0), Pe = $b6649b19c980ca22$var$_(De, 50, !0), Ve = (e)=>{
        Pe.cancel(), We(e);
    }, Fe = ()=>{
        We.cancel(), Pe();
    }, Ke = (0, $acw62.useCallback)(()=>{
        var e, t;
        const o = null !== (e = null == we ? void 0 : we.position) && void 0 !== e ? e : F;
        o ? qe(o) : T ? ge.current && qe(ge.current) : (null == ee ? void 0 : ee.isConnected) && $b6649b19c980ca22$var$E({
            place: null !== (t = null == we ? void 0 : we.place) && void 0 !== t ? t : v,
            offset: m,
            elementReference: ee,
            tooltipReference: ce.current,
            tooltipArrowReference: se.current,
            strategy: b,
            middlewares: S,
            border: oe
        }).then((e)=>{
            Te.current && Ie(e);
        });
    }, [
        me,
        ee,
        Y,
        V,
        v,
        null == we ? void 0 : we.place,
        m,
        b,
        F,
        null == we ? void 0 : we.position,
        T
    ]);
    (0, $acw62.useEffect)(()=>{
        var e, t;
        const o = new Set(Ee);
        Oe.forEach((e)=>{
            (null == X ? void 0 : X(e)) || o.add({
                current: e
            });
        });
        const l = document.querySelector(`[id='${d}']`);
        l && !(null == X ? void 0 : X(l)) && o.add({
            current: l
        });
        const r = ()=>{
            $e(!1);
        }, n = $b6649b19c980ca22$var$L(ee), i = $b6649b19c980ca22$var$L(ce.current);
        Ne.scroll && (window.addEventListener("scroll", r), null == n || n.addEventListener("scroll", r), null == i || i.addEventListener("scroll", r));
        let c = null;
        Ne.resize ? window.addEventListener("resize", r) : ee && ce.current && (c = (0, $461947879dcdbcd4$export$deee3a793edee05f)(ee, ce.current, Ke, {
            ancestorResize: !0,
            elementResize: !0,
            layoutShift: !0
        }));
        const s = (e)=>{
            "Escape" === e.key && $e(!1);
        };
        Ne.escape && window.addEventListener("keydown", s), Ne.clickOutsideAnchor && window.addEventListener("click", Me);
        const a = [], u = (e)=>{
            me && (null == e ? void 0 : e.target) === ee || ze(e);
        }, p = (e)=>{
            me && (null == e ? void 0 : e.target) === ee && De();
        }, v = [
            "mouseover",
            "mouseout",
            "mouseenter",
            "mouseleave",
            "focus",
            "blur"
        ], m = [
            "click",
            "dblclick",
            "mousedown",
            "mouseup"
        ];
        Object.entries(Re).forEach(([e, t])=>{
            t && (v.includes(e) ? a.push({
                event: e,
                listener: Ve
            }) : m.includes(e) && a.push({
                event: e,
                listener: u
            }));
        }), Object.entries(xe).forEach(([e, t])=>{
            t && (v.includes(e) ? a.push({
                event: e,
                listener: Fe
            }) : m.includes(e) && a.push({
                event: e,
                listener: p
            }));
        }), T && a.push({
            event: "pointermove",
            listener: He
        });
        const y = ()=>{
            _e.current = !0;
        }, h = ()=>{
            _e.current = !1, De();
        };
        return $ && !Ce && (null === (e = ce.current) || void 0 === e || e.addEventListener("mouseenter", y), null === (t = ce.current) || void 0 === t || t.addEventListener("mouseleave", h)), a.forEach(({ event: e, listener: t })=>{
            o.forEach((o)=>{
                var l;
                null === (l = o.current) || void 0 === l || l.addEventListener(e, t);
            });
        }), ()=>{
            var e, t;
            Ne.scroll && (window.removeEventListener("scroll", r), null == n || n.removeEventListener("scroll", r), null == i || i.removeEventListener("scroll", r)), Ne.resize ? window.removeEventListener("resize", r) : null == c || c(), Ne.clickOutsideAnchor && window.removeEventListener("click", Me), Ne.escape && window.removeEventListener("keydown", s), $ && !Ce && (null === (e = ce.current) || void 0 === e || e.removeEventListener("mouseenter", y), null === (t = ce.current) || void 0 === t || t.removeEventListener("mouseleave", h)), a.forEach(({ event: e, listener: t })=>{
                o.forEach((o)=>{
                    var l;
                    null === (l = o.current) || void 0 === l || l.removeEventListener(e, t);
                });
            });
        };
    }, [
        ee,
        Ke,
        ye,
        Ee,
        Oe,
        H,
        M,
        W,
        Le,
        A,
        O
    ]), (0, $acw62.useEffect)(()=>{
        var e, t;
        let o = null !== (t = null !== (e = null == we ? void 0 : we.anchorSelect) && void 0 !== e ? e : p) && void 0 !== t ? t : "";
        !o && l && (o = `[data-tooltip-id='${l.replace(/'/g, "\\'")}']`);
        const r = new MutationObserver((e)=>{
            const t = [], r = [];
            e.forEach((e)=>{
                if ("attributes" === e.type && "data-tooltip-id" === e.attributeName) e.target.getAttribute("data-tooltip-id") === l ? t.push(e.target) : e.oldValue === l && r.push(e.target);
                if ("childList" === e.type) {
                    if (ee) {
                        const t = [
                            ...e.removedNodes
                        ].filter((e)=>1 === e.nodeType);
                        if (o) try {
                            r.push(...t.filter((e)=>e.matches(o))), r.push(...t.flatMap((e)=>[
                                    ...e.querySelectorAll(o)
                                ]));
                        } catch (e) {}
                        t.some((e)=>{
                            var t;
                            return !!(null === (t = null == e ? void 0 : e.contains) || void 0 === t ? void 0 : t.call(e, ee)) && (he(!1), $e(!1), te(null), $b6649b19c980ca22$var$R(ae), $b6649b19c980ca22$var$R(ue), !0);
                        });
                    }
                    if (o) try {
                        const l = [
                            ...e.addedNodes
                        ].filter((e)=>1 === e.nodeType);
                        t.push(...l.filter((e)=>e.matches(o))), t.push(...l.flatMap((e)=>[
                                ...e.querySelectorAll(o)
                            ]));
                    } catch (e) {}
                }
            }), (t.length || r.length) && ke((e)=>[
                    ...e.filter((e)=>!r.includes(e)),
                    ...t
                ]);
        });
        return r.observe(document.body, {
            childList: !0,
            subtree: !0,
            attributes: !0,
            attributeFilter: [
                "data-tooltip-id"
            ],
            attributeOldValue: !0
        }), ()=>{
            r.disconnect();
        };
    }, [
        l,
        p,
        null == we ? void 0 : we.anchorSelect,
        ee
    ]), (0, $acw62.useEffect)(()=>{
        Ke();
    }, [
        Ke
    ]), (0, $acw62.useEffect)(()=>{
        if (!(null == G ? void 0 : G.current)) return ()=>null;
        const e = new ResizeObserver(()=>{
            setTimeout(()=>Ke());
        });
        return e.observe(G.current), ()=>{
            e.disconnect();
        };
    }, [
        Y,
        null == G ? void 0 : G.current
    ]), (0, $acw62.useEffect)(()=>{
        var e;
        const t = document.querySelector(`[id='${d}']`), o = [
            ...Oe,
            t
        ];
        ee && o.includes(ee) || te(null !== (e = Oe[0]) && void 0 !== e ? e : t);
    }, [
        d,
        Oe,
        ee
    ]), (0, $acw62.useEffect)(()=>(J && $e(!0), ()=>{
            $b6649b19c980ca22$var$R(ae), $b6649b19c980ca22$var$R(ue);
        }), []), (0, $acw62.useEffect)(()=>{
        var e;
        let t = null !== (e = null == we ? void 0 : we.anchorSelect) && void 0 !== e ? e : p;
        if (!t && l && (t = `[data-tooltip-id='${l.replace(/'/g, "\\'")}']`), t) try {
            const e = Array.from(document.querySelectorAll(t));
            ke(e);
        } catch (e) {
            ke([]);
        }
    }, [
        l,
        p,
        null == we ? void 0 : we.anchorSelect
    ]), (0, $acw62.useEffect)(()=>{
        ae.current && ($b6649b19c980ca22$var$R(ae), je(A));
    }, [
        A
    ]);
    const Ue = null !== (ie = null == we ? void 0 : we.content) && void 0 !== ie ? ie : Y, Xe = me && Object.keys(pe.tooltipStyles).length > 0;
    return (0, $acw62.useImperativeHandle)(t, ()=>({
            open: (e)=>{
                if (null == e ? void 0 : e.anchorSelect) try {
                    document.querySelector(e.anchorSelect);
                } catch (t) {
                    return void console.warn(`[react-tooltip] "${e.anchorSelect}" is not a valid CSS selector`);
                }
                be(null != e ? e : null), (null == e ? void 0 : e.delay) ? je(e.delay) : $e(!0);
            },
            close: (e)=>{
                (null == e ? void 0 : e.delay) ? Be(e.delay) : $e(!1);
            },
            activeAnchor: ee,
            place: pe.place,
            isOpen: Boolean(ye && !x && Ue && Xe)
        })), ye && !x && Ue ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(g, {
        id: l,
        role: ne,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("react-tooltip", $b6649b19c980ca22$var$z.tooltip, $b6649b19c980ca22$var$D.tooltip, $b6649b19c980ca22$var$D[u], i, `react-tooltip__place-${pe.place}`, $b6649b19c980ca22$var$z[Xe ? "show" : "closing"], Xe ? "react-tooltip__show" : "react-tooltip__closing", "fixed" === b && $b6649b19c980ca22$var$z.fixed, $ && $b6649b19c980ca22$var$z.clickable),
        onTransitionEnd: (e)=>{
            $b6649b19c980ca22$var$R(de), me || "opacity" !== e.propertyName || (he(!1), be(null), null == U || U());
        },
        style: {
            ...V,
            ...pe.tooltipStyles,
            opacity: void 0 !== le && Xe ? le : void 0
        },
        ref: ce
    }, Ue, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(g, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("react-tooltip-arrow", $b6649b19c980ca22$var$z.arrow, $b6649b19c980ca22$var$D.arrow, c, N && $b6649b19c980ca22$var$z.noArrow),
        style: {
            ...pe.tooltipArrowStyles,
            background: re ? `linear-gradient(to right bottom, transparent 50%, ${re} 50%)` : void 0
        },
        ref: se
    })) : null;
}, $b6649b19c980ca22$var$H = ({ content: t })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dangerouslySetInnerHTML: {
            __html: t
        }
    }), $b6649b19c980ca22$export$28c660c63b792dea = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ id: t, anchorId: l, anchorSelect: n, content: i, html: c, render: a, className: u, classNameArrow: d, variant: p = "dark", place: v = "top", offset: m = 10, wrapper: f = "div", children: h = null, events: w = [
    "hover"
], openOnClick: b = !1, positionStrategy: S = "absolute", middlewares: g, delayShow: E = 0, delayHide: _ = 0, float: O = !1, hidden: k = !1, noArrow: T = !1, clickable: L = !1, closeOnEsc: C = !1, closeOnScroll: R = !1, closeOnResize: x = !1, openEvents: N, closeEvents: $, globalCloseEvents: I, imperativeModeOnly: B = !1, style: z, position: D, isOpen: M, defaultIsOpen: W = !1, disableStyleInjection: P = !1, border: V, opacity: F, arrowColor: K, setIsOpen: U, afterShow: X, afterHide: Y, disableTooltip: G, role: Z = "tooltip" }, J)=>{
    const [Q, ee] = (0, $acw62.useState)(i), [te, oe] = (0, $acw62.useState)(c), [le, re] = (0, $acw62.useState)(v), [ne, ie] = (0, $acw62.useState)(p), [ce, se] = (0, $acw62.useState)(m), [ae, ue] = (0, $acw62.useState)(E), [de, pe] = (0, $acw62.useState)(_), [ve, me] = (0, $acw62.useState)(O), [fe, ye] = (0, $acw62.useState)(k), [he, we] = (0, $acw62.useState)(f), [be, Se] = (0, $acw62.useState)(w), [ge, Ee] = (0, $acw62.useState)(S), [Ae, _e] = (0, $acw62.useState)(null), [Oe, ke] = (0, $acw62.useState)(null), Te = (0, $acw62.useRef)(P), { anchorRefs: Le, activeAnchor: Ce } = $b6649b19c980ca22$var$j(t), Re = (e)=>null == e ? void 0 : e.getAttributeNames().reduce((t, o)=>{
            var l;
            if (o.startsWith("data-tooltip-")) t[o.replace(/^data-tooltip-/, "")] = null !== (l = null == e ? void 0 : e.getAttribute(o)) && void 0 !== l ? l : null;
            return t;
        }, {}), xe = (e)=>{
        const t = {
            place: (e)=>{
                var t;
                re(null !== (t = e) && void 0 !== t ? t : v);
            },
            content: (e)=>{
                ee(null != e ? e : i);
            },
            html: (e)=>{
                oe(null != e ? e : c);
            },
            variant: (e)=>{
                var t;
                ie(null !== (t = e) && void 0 !== t ? t : p);
            },
            offset: (e)=>{
                se(null === e ? m : Number(e));
            },
            wrapper: (e)=>{
                var t;
                we(null !== (t = e) && void 0 !== t ? t : f);
            },
            events: (e)=>{
                const t = null == e ? void 0 : e.split(" ");
                Se(null != t ? t : w);
            },
            "position-strategy": (e)=>{
                var t;
                Ee(null !== (t = e) && void 0 !== t ? t : S);
            },
            "delay-show": (e)=>{
                ue(null === e ? E : Number(e));
            },
            "delay-hide": (e)=>{
                pe(null === e ? _ : Number(e));
            },
            float: (e)=>{
                me(null === e ? O : "true" === e);
            },
            hidden: (e)=>{
                ye(null === e ? k : "true" === e);
            },
            "class-name": (e)=>{
                _e(e);
            }
        };
        Object.values(t).forEach((e)=>e(null)), Object.entries(e).forEach(([e, o])=>{
            var l;
            null === (l = t[e]) || void 0 === l || l.call(t, o);
        });
    };
    (0, $acw62.useEffect)(()=>{
        ee(i);
    }, [
        i
    ]), (0, $acw62.useEffect)(()=>{
        oe(c);
    }, [
        c
    ]), (0, $acw62.useEffect)(()=>{
        re(v);
    }, [
        v
    ]), (0, $acw62.useEffect)(()=>{
        ie(p);
    }, [
        p
    ]), (0, $acw62.useEffect)(()=>{
        se(m);
    }, [
        m
    ]), (0, $acw62.useEffect)(()=>{
        ue(E);
    }, [
        E
    ]), (0, $acw62.useEffect)(()=>{
        pe(_);
    }, [
        _
    ]), (0, $acw62.useEffect)(()=>{
        me(O);
    }, [
        O
    ]), (0, $acw62.useEffect)(()=>{
        ye(k);
    }, [
        k
    ]), (0, $acw62.useEffect)(()=>{
        Ee(S);
    }, [
        S
    ]), (0, $acw62.useEffect)(()=>{
        Te.current !== P && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
    }, [
        P
    ]), (0, $acw62.useEffect)(()=>{
        "undefined" != typeof window && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", {
            detail: {
                disableCore: "core" === P,
                disableBase: P
            }
        }));
    }, []), (0, $acw62.useEffect)(()=>{
        var e;
        const o = new Set(Le);
        let r = n;
        if (!r && t && (r = `[data-tooltip-id='${t.replace(/'/g, "\\'")}']`), r) try {
            document.querySelectorAll(r).forEach((e)=>{
                o.add({
                    current: e
                });
            });
        } catch (e) {
            console.warn(`[react-tooltip] "${r}" is not a valid CSS selector`);
        }
        const i = document.querySelector(`[id='${l}']`);
        if (i && o.add({
            current: i
        }), !o.size) return ()=>null;
        const c = null !== (e = null != Oe ? Oe : i) && void 0 !== e ? e : Ce.current, s = new MutationObserver((e)=>{
            e.forEach((e)=>{
                var t;
                if (!c || "attributes" !== e.type || !(null === (t = e.attributeName) || void 0 === t ? void 0 : t.startsWith("data-tooltip-"))) return;
                const o = Re(c);
                xe(o);
            });
        }), a = {
            attributes: !0,
            childList: !1,
            subtree: !1
        };
        if (c) {
            const e = Re(c);
            xe(e), s.observe(c, a);
        }
        return ()=>{
            s.disconnect();
        };
    }, [
        Le,
        Ce,
        Oe,
        l,
        n
    ]), (0, $acw62.useEffect)(()=>{
        (null == z ? void 0 : z.border) && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), V && !$b6649b19c980ca22$var$A("border", `${V}`) && console.warn(`[react-tooltip] "${V}" is not a valid \`border\`.`), (null == z ? void 0 : z.opacity) && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), F && !$b6649b19c980ca22$var$A("opacity", `${F}`) && console.warn(`[react-tooltip] "${F}" is not a valid \`opacity\`.`);
    }, []);
    let Ne = h;
    const $e = (0, $acw62.useRef)(null);
    if (a) {
        const t = a({
            content: (null == Oe ? void 0 : Oe.getAttribute("data-tooltip-content")) || Q || null,
            activeAnchor: Oe
        });
        Ne = t ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ref: $e,
            className: "react-tooltip-content-wrapper"
        }, t) : null;
    } else Q && (Ne = Q);
    te && (Ne = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b6649b19c980ca22$var$H, {
        content: te
    }));
    const Ie = {
        forwardRef: J,
        id: t,
        anchorId: l,
        anchorSelect: n,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(u, Ae),
        classNameArrow: d,
        content: Ne,
        contentWrapperRef: $e,
        place: le,
        variant: ne,
        offset: ce,
        wrapper: he,
        events: be,
        openOnClick: b,
        positionStrategy: ge,
        middlewares: g,
        delayShow: ae,
        delayHide: de,
        float: ve,
        hidden: fe,
        noArrow: T,
        clickable: L,
        closeOnEsc: C,
        closeOnScroll: R,
        closeOnResize: x,
        openEvents: N,
        closeEvents: $,
        globalCloseEvents: I,
        imperativeModeOnly: B,
        style: z,
        position: D,
        isOpen: M,
        defaultIsOpen: W,
        border: V,
        opacity: F,
        arrowColor: K,
        setIsOpen: U,
        afterShow: X,
        afterHide: Y,
        disableTooltip: G,
        activeAnchor: Oe,
        setActiveAnchor: (e)=>ke(e),
        role: Z
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b6649b19c980ca22$var$q, {
        ...Ie
    });
});
"undefined" != typeof window && window.addEventListener("react-tooltip-inject-styles", (e)=>{
    e.detail.disableCore || $b6649b19c980ca22$var$S({
        css: `:root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9;--rt-transition-show-delay:0.15s;--rt-transition-closing-delay:0.15s}.core-styles-module_tooltip__3vRRp{position:absolute;top:0;left:0;pointer-events:none;opacity:0;will-change:opacity}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{opacity:var(--rt-opacity);transition:opacity var(--rt-transition-show-delay)ease-out}.core-styles-module_closing__sGnxF{opacity:0;transition:opacity var(--rt-transition-closing-delay)ease-in}`,
        type: "core"
    }), e.detail.disableBase || $b6649b19c980ca22$var$S({
        css: `
.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:8px;height:8px}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`,
        type: "base"
    });
});



const $879c5e1ef32da115$export$6a959b2fe514de23 = {
    [(0, $25746eb61037a613$export$873e90337ab80c46).Water]: "Water - Liquid that freezes at 0\xb0C and boils at 100\xb0C",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Sand]: "Sand - Basic particle affected by gravity, melts at 1700\xb0C",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Stone]: "Stone - Solid that melts into lava above 1300\xb0C",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Lava]: "Lava - Hot liquid that solidifies below 1200\xb0C",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Metal]: "Metal - Conducts electricity and melts above 1500\xb0C",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Ground]: 'Electricity Ground - Absorbs electrical charge',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Spark]: 'Electricity Spark - Moves chaotically and conducts electricity',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Source]: 'Electricity Source - Generates electrical charge',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Electricity_Amplifier]: 'Electricity Amplifier - Multiplies electrical charge',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Heater]: 'Heater - Consumes electricity to generate heat',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Cooler]: 'Cooler - Consumes electricity to absorb heat',
    [(0, $25746eb61037a613$export$873e90337ab80c46).ColdDetector]: "Cold Detector - Emits electricity when temperature falls below -50\xb0C",
    [(0, $25746eb61037a613$export$873e90337ab80c46).HotDetector]: "Hot Detector - Emits electricity when temperature rises above 90\xb0C",
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidDetector]: 'Liquid Detector - Emits electricity when in contact with liquids',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Wood]: "Wood - Burns at temperatures above 300\xb0C",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Border]: 'Border - Immovable boundary element',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Fire]: 'Fire - Short-lived hot element that burns nearby materials',
    [(0, $25746eb61037a613$export$873e90337ab80c46).IceFire]: 'Ice Fire - Cold fire that freezes nearby materials',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Bomb]: 'Bomb - Explodes on contact',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Dynamite]: 'Dynamite - Stationary explosive',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Ice]: "Ice - Solid water that melts at 0\xb0C",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Clone]: 'Clone - Copies adjacent elements',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Gas]: "Gas - Light particle that moves chaotically and ignites above 400\xb0C",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Void]: 'Void - Removes any element it touches',
    [(0, $25746eb61037a613$export$873e90337ab80c46).ConstantCold]: 'Constant Cold - Permanently emits extreme cold',
    [(0, $25746eb61037a613$export$873e90337ab80c46).ConstantHot]: 'Constant Hot - Permanently emits extreme heat',
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidGas]: "Liquid Gas - Cold liquid that evaporates at -160\xb0C",
    [(0, $25746eb61037a613$export$873e90337ab80c46).LiquidGlass]: "Liquid Glass - Molten glass that solidifies below 1300\xb0C",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Glass]: "Glass - Transparent solid material that melts at 1400\xb0C",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Virus]: 'Virus - Infects and transforms adjacent elements',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Heal]: 'Heal - Neutralizes viruses and restores infected elements',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Acid]: 'Acid - Corrosive liquid that dissolves various materials',
    [(0, $25746eb61037a613$export$873e90337ab80c46).PlantSeed]: 'Plant Seed - Grows into a plant when given the right conditions',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Wire]: 'Wire - Creates a direct electrical connection between two points',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Pipe]: 'Pipe - Creates a direct path for liquids to flow between two points',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Snow]: "Snow - Light particles that melt into water when heated above 0\xb0C",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Magnet]: 'Magnet - Dark-gray powder that is attracted to metal objects',
    [(0, $25746eb61037a613$export$873e90337ab80c46).WindSource]: 'Wind Source - Creates air currents that push lighter elements',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Ant]: 'Ant - A small creature that moves around and can carry small objects',
    [(0, $25746eb61037a613$export$873e90337ab80c46).FireAnt]: 'Fire Ant - A fiery version of ant that moves around and can carry small objects',
    [(0, $25746eb61037a613$export$873e90337ab80c46).IceAnt]: 'Ice Ant - A freezing version of ant that moves around and can carry small objects',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Worm]: 'Worm - A burrowing creature that moves through blocks',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Smoke]: 'Smoke - Light particles that rise and dissipate over time',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Oil]: 'Oil - Flammable liquid that burns at high temperatures',
    [(0, $25746eb61037a613$export$873e90337ab80c46).Steam]: 'Steam - Water vapor that rises and cools into water',
    [(0, $25746eb61037a613$export$873e90337ab80c46).MoltenMetal]: "Molten Metal - Hot liquid metal that solidifies below 1500\xb0C",
    [(0, $25746eb61037a613$export$873e90337ab80c46).Mirror]: 'Mirror - Reflects light rays',
    [(0, $25746eb61037a613$export$873e90337ab80c46).LightSource]: 'Light Source - Emits light in all directions',
    [(0, $25746eb61037a613$export$873e90337ab80c46).LightDetector]: 'Light Detector - Generates electricity when exposed to light',
    [(0, $25746eb61037a613$export$873e90337ab80c46).LightBulb]: 'Light Bulb - Consumes electricity to emit light, brightness depends on charge',
    eraser: 'Eraser - Removes elements from the simulation',
    heatTool: 'Heat Tool - Increases temperature of elements',
    coolTool: 'Cool Tool - Decreases temperature of elements'
};




var $b6663e21933797fa$exports = {};
$b6663e21933797fa$exports = new URL("water.ee4f3e46.svg", import.meta.url).toString();


const $6a63833045a6ff17$var$ICONS = {
    [(0, $25746eb61037a613$export$873e90337ab80c46).Water]: new URL($b6663e21933797fa$exports).href
};
const $6a63833045a6ff17$var$Icon = ({ type: type })=>{
    const icon = (0, $0a2978442e4c4e59$export$841e0ced76dde0da)[type];
    if (!icon) return null;
    const importedSrc = $6a63833045a6ff17$var$ICONS[type];
    if (importedSrc) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        src: importedSrc,
        alt: type,
        className: $a5bdec834b919a00$export$1ca1ec8b29a4ce27
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        children: icon
    });
};
const $6a63833045a6ff17$export$94abe340dda06b03 = ()=>{
    const [isClosing, setIsClosing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [isOpened, setIsOpened] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [drawingType, setDrawingType] = (0, $6c32d828ed838d7b$export$8a75c83865bcf9dd)("drawingType");
    const [drawingData, setDrawingData] = (0, $6c32d828ed838d7b$export$8a75c83865bcf9dd)("drawingData");
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!isOpened) return;
        const closePanel = ()=>{
            setIsClosing(true);
            setTimeout(()=>{
                setIsOpened(false);
                setIsClosing(false);
            }, 300);
        };
        window.addEventListener("click", closePanel);
        return ()=>{
            window.removeEventListener("click", closePanel);
        };
    }, [
        isOpened
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const handleSpace = (e)=>{
            if (e.key === " ") {
                if (!isOpened) setIsOpened(true);
                else {
                    setIsClosing(true);
                    setTimeout(()=>{
                        setIsOpened(false);
                        setIsClosing(false);
                    }, 300);
                }
            }
            if ((0, $d4cc0bff95ac142d$export$1c1af44c281de472)[e.key]) {
                setDrawingType((0, $d4cc0bff95ac142d$export$1c1af44c281de472)[e.key]);
                setIsOpened(false);
            }
        };
        window.addEventListener("keyup", handleSpace);
        return ()=>{
            window.removeEventListener("keyup", handleSpace);
        };
    }, [
        isOpened
    ]);
    const button = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))($a5bdec834b919a00$export$bbd811db8e2a5b5e, {
            [$a5bdec834b919a00$export$775ab2407e846dbe]: isOpened && !isClosing
        }),
        onClick: (e)=>{
            setIsOpened(true);
            e.stopPropagation();
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6a63833045a6ff17$var$Icon, {
            type: drawingType
        })
    });
    const renderElementButton = (groupElement)=>{
        const elementAsString = typeof groupElement === 'string';
        let customIcon = '';
        let type = groupElement;
        let data = {};
        if (elementAsString) type = groupElement;
        else {
            customIcon = groupElement.icon ?? '';
            type = groupElement.type;
            data = groupElement.data;
        }
        const color = (0, $b0107f5265abe006$export$5551a2d24ff40153)({
            type: type,
            coordinates: {
                x: 0,
                y: 0
            },
            speed: {
                x: 0,
                y: 0
            },
            data: {}
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
            className: $a5bdec834b919a00$export$e72cf0edcb61a6cd,
            onClick: ()=>{
                setDrawingType(type);
                setDrawingData(data);
                setIsOpened(false);
            },
            style: {
                boxShadow: `0 0 0 2px rgb(${color.r}, ${color.g}, ${color.b})`
            },
            "data-tooltip-id": `tooltip-${type}`,
            children: [
                customIcon || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6a63833045a6ff17$var$Icon, {
                    type: type
                }),
                (0, $d4cc0bff95ac142d$export$d8dfc3abc36dfb12)[type] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: $a5bdec834b919a00$export$ec0409edb5e28490,
                    children: (0, $d4cc0bff95ac142d$export$d8dfc3abc36dfb12)[type]
                })
            ]
        }, type + JSON.stringify(data));
    };
    const panel = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))($a5bdec834b919a00$export$84387c39da17f8d8, {
            [$a5bdec834b919a00$export$ffacadc13768e1a3]: isClosing
        }),
        onClick: (e)=>{
            e.stopPropagation();
        },
        children: [
            (0, $0a2978442e4c4e59$export$402035f05c012faf).map((group, index)=>{
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))($a5bdec834b919a00$export$f36792cb9bd81925, {
                        [$a5bdec834b919a00$export$4c7897fafd92b108]: index === (0, $0a2978442e4c4e59$export$402035f05c012faf).length - 1
                    }),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: $a5bdec834b919a00$export$91bc5dc3bf221ff4,
                            children: group.name
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: $a5bdec834b919a00$export$d01df6464fa48bad,
                            children: group.elements.map((type)=>renderElementButton(type))
                        })
                    ]
                }, group.name);
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: Object.keys((0, $0a2978442e4c4e59$export$841e0ced76dde0da)).map((type)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b6649b19c980ca22$export$28c660c63b792dea), {
                        id: `tooltip-${type}`,
                        content: (0, $879c5e1ef32da115$export$6a959b2fe514de23)[type] ?? type,
                        place: "top"
                    }, type))
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            button,
            isOpened && panel
        ]
    });
};




var $acw62 = parcelRequire("acw62");
var $8fd601a544a969db$export$bbd811db8e2a5b5e;
var $8fd601a544a969db$export$96e4b36520c26a2c;
$8fd601a544a969db$export$bbd811db8e2a5b5e = `ye7_Pa_floatingButton`;
$8fd601a544a969db$export$96e4b36520c26a2c = `ye7_Pa_modal`;



const $36649f38b6907df4$export$fef7159a5e479b3c = ()=>{
    const [isOpened, setIsOpened] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [isDebugMode, setIsDebugMode] = (0, $6c32d828ed838d7b$export$8a75c83865bcf9dd)("debugMode");
    const [maxSpeedMode, setMaxSpeedMode] = (0, $6c32d828ed838d7b$export$8a75c83865bcf9dd)("maxSpeedMode");
    const [isTemperatureEnabled, setIsTemperatureEnabled] = (0, $6c32d828ed838d7b$export$8a75c83865bcf9dd)("isTemperatureEnabled");
    const [isLightSourcesEnabled, setIsLightSourcesEnabled] = (0, $6c32d828ed838d7b$export$8a75c83865bcf9dd)("isLightSourcesEnabled");
    const [baseTemperature, setBaseTemperature] = (0, $6c32d828ed838d7b$export$8a75c83865bcf9dd)("baseTemperature");
    const [isSmoothMovementEnabled, setIsSmoothMovementEnabled] = (0, $6c32d828ed838d7b$export$8a75c83865bcf9dd)("isSmoothMovementEnabled");
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!isOpened) return;
        const handleOutsideClick = ()=>{
            setIsOpened(false);
        };
        window.addEventListener("click", handleOutsideClick);
        return ()=>window.removeEventListener("click", handleOutsideClick);
    }, [
        isOpened
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const handleKey = (e)=>{
            if (e.key === "d") setIsDebugMode(!isDebugMode);
            if (e.key === "m") setMaxSpeedMode(!maxSpeedMode);
            if (e.key === "t") setIsTemperatureEnabled(!isTemperatureEnabled);
        };
        window.addEventListener("keyup", handleKey);
        return ()=>window.removeEventListener("keyup", handleKey);
    }, [
        isDebugMode,
        maxSpeedMode,
        isTemperatureEnabled,
        isSmoothMovementEnabled
    ]);
    const button = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        className: $8fd601a544a969db$export$bbd811db8e2a5b5e,
        onClick: (e)=>{
            setIsOpened((o)=>!o);
            e.stopPropagation();
        },
        children: "\u2699\uFE0F"
    });
    const modal = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: $8fd601a544a969db$export$96e4b36520c26a2c,
        onClick: (e)=>{
            e.stopPropagation();
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "checkbox",
                            checked: isDebugMode,
                            onChange: (e)=>setIsDebugMode(e.target.checked)
                        }),
                        " ",
                        "Debug mode"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "checkbox",
                            checked: maxSpeedMode,
                            onChange: (e)=>setMaxSpeedMode(e.target.checked)
                        }),
                        " ",
                        "Max speed mode"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "checkbox",
                            checked: isTemperatureEnabled,
                            onChange: (e)=>setIsTemperatureEnabled(e.target.checked)
                        }),
                        " ",
                        "Temperature processing"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "checkbox",
                            checked: isLightSourcesEnabled,
                            onChange: (e)=>setIsLightSourcesEnabled(e.target.checked)
                        }),
                        " ",
                        "Light sources"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "checkbox",
                            checked: isSmoothMovementEnabled,
                            onChange: (e)=>setIsSmoothMovementEnabled(e.target.checked)
                        }),
                        " ",
                        "Smooth movement"
                    ]
                }),
                isTemperatureEnabled && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                            children: [
                                "Air temperature: ",
                                baseTemperature,
                                "\xb0C"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "range",
                            min: -200,
                            max: 200,
                            value: baseTemperature,
                            onChange: (e)=>setBaseTemperature(+e.target.value)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: ()=>{
                            setIsDebugMode(false);
                            setMaxSpeedMode(false);
                            setIsTemperatureEnabled(true);
                            setIsLightSourcesEnabled(false);
                            setBaseTemperature(20);
                            setIsSmoothMovementEnabled(true);
                            setIsOpened(false);
                        },
                        children: "Reset"
                    })
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            button,
            isOpened && modal
        ]
    });
};




var $acw62 = parcelRequire("acw62");
var $38ee070aa7454695$export$e19a55101d8f7602;
var $38ee070aa7454695$export$2aeb1aa985743a62;
var $38ee070aa7454695$export$464c821cd4347539;
var $38ee070aa7454695$export$68f8307b0a075091;
var $38ee070aa7454695$export$1f98eb964f35687;
var $38ee070aa7454695$export$aa9d5aa27bfd99eb;
var $38ee070aa7454695$export$b0c5c2fac8144e54;
var $38ee070aa7454695$export$e4a469299c03550;
var $38ee070aa7454695$export$153ac24eb35ce502;
var $38ee070aa7454695$export$139c8fbff3585413;
var $38ee070aa7454695$export$bc8b0524d1e98883;
var $38ee070aa7454695$export$f4d082c200a4b4b8;
$38ee070aa7454695$export$e19a55101d8f7602 = `_IFzOG_fps`;
$38ee070aa7454695$export$2aeb1aa985743a62 = `_IFzOG_fpsBar`;
$38ee070aa7454695$export$464c821cd4347539 = `_IFzOG_hint`;
$38ee070aa7454695$export$68f8307b0a075091 = `_IFzOG_lastFPS`;
$38ee070aa7454695$export$1f98eb964f35687 = `_IFzOG_loadMeter`;
$38ee070aa7454695$export$aa9d5aa27bfd99eb = `_IFzOG_loadMeterBar`;
$38ee070aa7454695$export$b0c5c2fac8144e54 = `_IFzOG_metrics`;
$38ee070aa7454695$export$e4a469299c03550 = `_IFzOG_processedPointsMeter`;
$38ee070aa7454695$export$153ac24eb35ce502 = `_IFzOG_processedPointsMeterText`;
$38ee070aa7454695$export$139c8fbff3585413 = `_IFzOG_temperatureMap`;
$38ee070aa7454695$export$bc8b0524d1e98883 = `_IFzOG_temperatureMapContainer`;
$38ee070aa7454695$export$f4d082c200a4b4b8 = `_IFzOG_transparent`;








const $18525e86e9210fba$var$TemperatureMap = ()=>{
    const canvasRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const bounds = (0, $bab86e660d8728eb$export$c4e9d269599ab4b4).getBounds();
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const ctx = canvasRef.current?.getContext("2d");
        if (!ctx) return;
        const onFrame = ()=>{
            let maxTemp = 500;
            let minTemp = -500;
            for(let x = 0; x < width; x++)for(let y = 0; y < height; y++){
                const temperature = (0, $f401cf2536c45f5a$export$a83c692ac725e2ca).getTemperatureOnPoint(x + bounds.left, y + bounds.top);
                maxTemp = Math.max(maxTemp, temperature);
                minTemp = Math.min(minTemp, temperature);
            }
            ctx.fillStyle = "white";
            ctx.fillRect(0, 0, width, height);
            if (maxTemp === minTemp) return;
            for(let x = 0; x < width; x++)for(let y = 0; y < height; y++){
                const temperature = (0, $f401cf2536c45f5a$export$a83c692ac725e2ca).getTemperatureOnPoint(x + bounds.left, y + bounds.top);
                ctx.fillStyle = temperature > 0 ? `rgba(255, 0, 0, ${Math.min(1, temperature / Math.abs(maxTemp))})` : `rgba(0, 0, 255, ${Math.min(1, -temperature / Math.abs(minTemp))})`;
                ctx.fillRect(x, y, 1, 1);
            }
        };
        const intervalId = setInterval(onFrame, 1000 / 30);
        return ()=>{
            clearInterval(intervalId);
        };
    }, [
        canvasRef.current,
        width,
        height
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            width: `${width / 2}px`,
            height: `${height / 2}px`
        },
        className: $38ee070aa7454695$export$bc8b0524d1e98883,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("canvas", {
            className: $38ee070aa7454695$export$139c8fbff3585413,
            ref: canvasRef,
            width: width,
            height: height
        })
    });
};
const $18525e86e9210fba$var$ProcessedPointsMeter = ()=>{
    const [pointsTotal, setPointsTotal] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [pointsProcessed, setPointsProcessed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const interval = setInterval(()=>{
            const points = (0, $8c2070529dc8eec8$export$1c787534cb11aa3e).getActivePoints();
            setPointsTotal(points.length);
            const active = points.filter((point)=>!(0, $8c2070529dc8eec8$export$1c787534cb11aa3e).isUnused(point));
            setPointsProcessed(active.length);
        }, 100);
        return ()=>clearInterval(interval);
    }, []);
    if (pointsTotal < 2000) return null;
    const processedPercent = Math.min(99.99, pointsProcessed / pointsTotal * 100);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: $38ee070aa7454695$export$e4a469299c03550,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $38ee070aa7454695$export$153ac24eb35ce502,
                children: "Processing:"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                viewBox: "0 0 40 40",
                width: "40",
                height: "40",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        cx: "20",
                        cy: "20",
                        r: "15",
                        fill: "#ddd"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: `
            M 20,20
            L 20,5
            A 15,15 0 ${processedPercent > 50 ? 1 : 0} 1 ${20 + 15 * Math.sin(processedPercent * Math.PI / 50)},${20 - 15 * Math.cos(processedPercent * Math.PI / 50)}
            Z
          `,
                        fill: `rgba(${[
                            Math.floor(processedPercent * 2.55),
                            Math.floor(255 - processedPercent * 2.55),
                            0
                        ].join(",")})`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: $38ee070aa7454695$export$153ac24eb35ce502,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                        children: [
                            Math.round(processedPercent),
                            "%"
                        ]
                    }),
                    " of points",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    pointsProcessed,
                    " of ",
                    pointsTotal
                ]
            })
        ]
    });
};
const $18525e86e9210fba$var$LoadMeter = ()=>{
    const [load, setLoad] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const interval = setInterval(()=>{
            setLoad((0, $07a0e0a0b93620bf$export$3cdec2bba15e3523).data.load * 100);
        }, 50);
        return ()=>clearInterval(interval);
    }, []);
    const limitedLoad = Math.min(100, load);
    const color = [
        Math.floor(limitedLoad * 2.55),
        Math.floor(255 - limitedLoad * 2.55),
        0
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: $38ee070aa7454695$export$1f98eb964f35687,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: $38ee070aa7454695$export$aa9d5aa27bfd99eb,
            style: {
                width: `${load}%`,
                backgroundColor: `rgb(${color.join(",")})`
            }
        })
    });
};
const $18525e86e9210fba$export$ed9166ec0f465b5e = ()=>{
    const [fpsHistory, setFpsHistory] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>new Array(30).fill(0));
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const interval = setInterval(()=>{
            setFpsHistory((prev)=>[
                    ...prev,
                    (0, $07a0e0a0b93620bf$export$3cdec2bba15e3523).data.fps
                ].slice(-30));
        }, 1000);
        return ()=>clearInterval(interval);
    }, []);
    const metricsRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [shouldBeTransparent, setShouldBeTransparent] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const onMouseMove = (e)=>{
            if (!metricsRef.current) return;
            const { top: top, left: left, width: width, height: height } = metricsRef.current.getBoundingClientRect();
            setShouldBeTransparent(e.clientX >= left && e.clientX <= left + width && e.clientY >= top && e.clientY <= top + height);
        };
        document.addEventListener("mousemove", onMouseMove);
        return ()=>document.removeEventListener("mousemove", onMouseMove);
    }, []);
    const lastFPS = Math.round(fpsHistory[fpsHistory.length - 1]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))($38ee070aa7454695$export$b0c5c2fac8144e54, {
            [$38ee070aa7454695$export$f4d082c200a4b4b8]: shouldBeTransparent
        }),
        ref: metricsRef,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: $38ee070aa7454695$export$68f8307b0a075091,
                children: [
                    lastFPS,
                    " FPS"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $38ee070aa7454695$export$e19a55101d8f7602,
                children: fpsHistory.map((fps, index)=>{
                    const percent = fps / 60 * 100;
                    const color = [
                        Math.floor(255 - percent * 2.55),
                        Math.floor(percent * 2.55),
                        0
                    ];
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: $38ee070aa7454695$export$2aeb1aa985743a62,
                        style: {
                            height: `${percent}%`,
                            backgroundColor: `rgb(${color.join(",")})`
                        }
                    }, index);
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($18525e86e9210fba$var$LoadMeter, {}),
            (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getIsTemperatureEnabled() && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($18525e86e9210fba$var$TemperatureMap, {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($18525e86e9210fba$var$ProcessedPointsMeter, {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: $38ee070aa7454695$export$464c821cd4347539,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "d"
                    }),
                    " - debug mode ",
                    (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getDebugMode() && "(\u2714\uFE0F)",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "m"
                    }),
                    " - \u221E FPS mode ",
                    (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getMaxSpeedMode() && "(\u2714\uFE0F)",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "t"
                    }),
                    " - temp ",
                    (0, $6b3e82ea4b803b12$export$c7c44baae9d9f25f).getIsTemperatureEnabled() && "(\u2714\uFE0F)",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        href: "https://t.me/kshshe",
                        target: "_blank",
                        rel: "noreferrer",
                        children: "developer"
                    }),
                    ",",
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        href: "https://github.com/kshshe/sandbox-4",
                        target: "_blank",
                        rel: "noreferrer",
                        children: "code"
                    })
                ]
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");
var $bfe6887f1137c7ef$export$319eeec870e9e287;
var $bfe6887f1137c7ef$export$bbd811db8e2a5b5e;
$bfe6887f1137c7ef$export$319eeec870e9e287 = `iAWwfW_controlButtons`;
$bfe6887f1137c7ef$export$bbd811db8e2a5b5e = `iAWwfW_floatingButton`;




const $038513e908360a5c$export$2f558b9d3e370342 = ()=>{
    const [brushSize, setBrushSize] = (0, $6c32d828ed838d7b$export$8a75c83865bcf9dd)('brushSize');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const onKeyUp = (e)=>{
            if (e.key === "ArrowUp") setBrushSize(Math.min(5, brushSize + 1));
            else if (e.key === "ArrowDown") setBrushSize(Math.max(1, brushSize - 1));
        };
        window.addEventListener("keyup", onKeyUp);
        return ()=>{
            window.removeEventListener("keyup", onKeyUp);
        };
    }, [
        brushSize,
        setBrushSize
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: $bfe6887f1137c7ef$export$319eeec870e9e287,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: $bfe6887f1137c7ef$export$bbd811db8e2a5b5e,
                onClick: (e)=>{
                    (0, $37fb57f92a46a76e$export$bf2a15d34f3c441c).clear();
                    window.location.reload();
                },
                children: "\uD83D\uDD04"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: $bfe6887f1137c7ef$export$bbd811db8e2a5b5e,
                onClick: (e)=>{
                    setBrushSize(brushSize === 5 ? 1 : brushSize + 1);
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    style: {
                        fontSize: `${brushSize * 8}px`
                    },
                    children: "\uD83D\uDD8C\uFE0F"
                })
            })
        ]
    });
};



parcelRequire("acw62");

var $8ca9f10efb4a43db$export$89da14300d534261;
var $8ca9f10efb4a43db$export$4c33b401f069772a;
var $8ca9f10efb4a43db$export$c84aae135f0622a3;
var $8ca9f10efb4a43db$export$ed7dfaaac81320fd;
var $8ca9f10efb4a43db$export$b0d8a4ba496e2be;
var $8ca9f10efb4a43db$export$5f1bdd20b649bc36;
$8ca9f10efb4a43db$export$89da14300d534261 = `ihamjq_active`;
$8ca9f10efb4a43db$export$4c33b401f069772a = `ihamjq_controlButton`;
$8ca9f10efb4a43db$export$c84aae135f0622a3 = `ihamjq_controlsRow`;
$8ca9f10efb4a43db$export$ed7dfaaac81320fd = `ihamjq_speedButton`;
$8ca9f10efb4a43db$export$b0d8a4ba496e2be = `ihamjq_speedControls`;
$8ca9f10efb4a43db$export$5f1bdd20b649bc36 = `ihamjq_timeControls`;



const $e173430b1e039630$export$9d89a2c9980445ef = ()=>{
    const [isPaused, setIsPaused] = (0, $6c32d828ed838d7b$export$8a75c83865bcf9dd)('isPaused');
    const [simulationSpeed, setSimulationSpeed] = (0, $6c32d828ed838d7b$export$8a75c83865bcf9dd)('simulationSpeed');
    // Predefined speed options
    const speedOptions = [
        {
            value: 0.25,
            label: "0.25x"
        },
        {
            value: 0.5,
            label: "0.5x"
        },
        {
            value: 1,
            label: "1x"
        },
        {
            value: 2,
            label: "2x"
        },
        {
            value: 4,
            label: "4x"
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: $8ca9f10efb4a43db$export$5f1bdd20b649bc36,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: $8ca9f10efb4a43db$export$c84aae135f0622a3,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: `${$8ca9f10efb4a43db$export$4c33b401f069772a} ${isPaused ? $8ca9f10efb4a43db$export$89da14300d534261 : ''}`,
                        onClick: ()=>setIsPaused(!isPaused),
                        title: "Pause/Resume (Space)",
                        children: isPaused ? "\u25B6\uFE0F" : "\u23F8\uFE0F"
                    }),
                    isPaused && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: $8ca9f10efb4a43db$export$4c33b401f069772a,
                        onClick: (0, $cb12b8b8642d52ce$export$746623013149fc35),
                        title: "Step Forward (Right Arrow)",
                        children: "\u23ED\uFE0F"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $8ca9f10efb4a43db$export$b0d8a4ba496e2be,
                children: speedOptions.map((option, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: `${$8ca9f10efb4a43db$export$ed7dfaaac81320fd} ${Math.abs(simulationSpeed - option.value) < 0.01 ? $8ca9f10efb4a43db$export$89da14300d534261 : ''}`,
                        onClick: ()=>setSimulationSpeed(option.value),
                        title: `Set speed to ${option.label} (${index + 1})`,
                        children: option.label
                    }, option.value))
            })
        ]
    });
};


const $46b22a467997623f$var$body = document.querySelector('#react');
if ($46b22a467997623f$var$body) (0, $7e96a608cb33bf79$exports.createRoot)($46b22a467997623f$var$body).render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
    children: [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a63833045a6ff17$export$94abe340dda06b03), {}),
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $36649f38b6907df4$export$fef7159a5e479b3c), {}),
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $038513e908360a5c$export$2f558b9d3e370342), {}),
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e173430b1e039630$export$9d89a2c9980445ef), {}),
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18525e86e9210fba$export$ed9166ec0f465b5e), {})
    ]
}));



// package.json
var $0dea53fbf8dad186$var$name = "@vercel/analytics";
var $0dea53fbf8dad186$var$version = "1.5.0";
// src/queue.ts
var $0dea53fbf8dad186$var$initQueue = ()=>{
    if (window.va) return;
    window.va = function a(...params) {
        (window.vaq = window.vaq || []).push(params);
    };
};
// src/utils.ts
function $0dea53fbf8dad186$var$isBrowser() {
    return typeof window !== "undefined";
}
function $0dea53fbf8dad186$var$detectEnvironment() {
    try {
        const env = "production";
        if (env === "development" || env === "test") return "development";
    } catch (e) {}
    return "production";
}
function $0dea53fbf8dad186$var$setMode(mode = "auto") {
    if (mode === "auto") {
        window.vam = $0dea53fbf8dad186$var$detectEnvironment();
        return;
    }
    window.vam = mode;
}
function $0dea53fbf8dad186$var$getMode() {
    const mode = $0dea53fbf8dad186$var$isBrowser() ? window.vam : $0dea53fbf8dad186$var$detectEnvironment();
    return mode || "production";
}
function $0dea53fbf8dad186$var$isProduction() {
    return $0dea53fbf8dad186$var$getMode() === "production";
}
function $0dea53fbf8dad186$var$isDevelopment() {
    return $0dea53fbf8dad186$var$getMode() === "development";
}
function $0dea53fbf8dad186$var$removeKey(key, { [key]: _, ...rest }) {
    return rest;
}
function $0dea53fbf8dad186$var$parseProperties(properties, options) {
    if (!properties) return void 0;
    let props = properties;
    const errorProperties = [];
    for (const [key, value] of Object.entries(properties))if (typeof value === "object" && value !== null) {
        if (options.strip) props = $0dea53fbf8dad186$var$removeKey(key, props);
        else errorProperties.push(key);
    }
    if (errorProperties.length > 0 && !options.strip) throw Error(`The following properties are not valid: ${errorProperties.join(", ")}. Only strings, numbers, booleans, and null are allowed.`);
    return props;
}
function $0dea53fbf8dad186$export$c689ba62f1421710(pathname, pathParams) {
    if (!pathname || !pathParams) return pathname;
    let result = pathname;
    try {
        const entries = Object.entries(pathParams);
        for (const [key, value] of entries)if (!Array.isArray(value)) {
            const matcher = $0dea53fbf8dad186$var$turnValueToRegExp(value);
            if (matcher.test(result)) result = result.replace(matcher, `/[${key}]`);
        }
        for (const [key, value] of entries)if (Array.isArray(value)) {
            const matcher = $0dea53fbf8dad186$var$turnValueToRegExp(value.join("/"));
            if (matcher.test(result)) result = result.replace(matcher, `/[...${key}]`);
        }
        return result;
    } catch (e) {
        return pathname;
    }
}
function $0dea53fbf8dad186$var$turnValueToRegExp(value) {
    return new RegExp(`/${$0dea53fbf8dad186$var$escapeRegExp(value)}(?=[/?#]|$)`);
}
function $0dea53fbf8dad186$var$escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function $0dea53fbf8dad186$var$getScriptSrc(props) {
    if (props.scriptSrc) return props.scriptSrc;
    if ($0dea53fbf8dad186$var$isDevelopment()) return "https://va.vercel-scripts.com/v1/script.debug.js";
    if (props.basePath) return `${props.basePath}/insights/script.js`;
    return "/_vercel/insights/script.js";
}
// src/generic.ts
function $0dea53fbf8dad186$export$a976684a0efeb93f(props = {
    debug: true
}) {
    var _a;
    if (!$0dea53fbf8dad186$var$isBrowser()) return;
    $0dea53fbf8dad186$var$setMode(props.mode);
    $0dea53fbf8dad186$var$initQueue();
    if (props.beforeSend) (_a = window.va) == null || _a.call(window, "beforeSend", props.beforeSend);
    const src = $0dea53fbf8dad186$var$getScriptSrc(props);
    if (document.head.querySelector(`script[src*="${src}"]`)) return;
    const script = document.createElement("script");
    script.src = src;
    script.defer = true;
    script.dataset.sdkn = $0dea53fbf8dad186$var$name + (props.framework ? `/${props.framework}` : "");
    script.dataset.sdkv = $0dea53fbf8dad186$var$version;
    if (props.disableAutoTrack) script.dataset.disableAutoTrack = "1";
    if (props.endpoint) script.dataset.endpoint = props.endpoint;
    else if (props.basePath) script.dataset.endpoint = `${props.basePath}/insights`;
    if (props.dsn) script.dataset.dsn = props.dsn;
    script.onerror = ()=>{
        const errorMessage = $0dea53fbf8dad186$var$isDevelopment() ? "Please check if any ad blockers are enabled and try again." : "Be sure to enable Web Analytics for your project and deploy again. See https://vercel.com/docs/analytics/quickstart for more information.";
        console.log(`[Vercel Web Analytics] Failed to load script from ${src}. ${errorMessage}`);
    };
    if ($0dea53fbf8dad186$var$isDevelopment() && props.debug === false) script.dataset.debug = "false";
    document.head.appendChild(script);
}
function $0dea53fbf8dad186$export$6b2a7d5132615086(name2, properties, options) {
    var _a, _b;
    if (!$0dea53fbf8dad186$var$isBrowser()) {
        const msg = "[Vercel Web Analytics] Please import `track` from `@vercel/analytics/server` when using this function in a server environment";
        if ($0dea53fbf8dad186$var$isProduction()) console.warn(msg);
        else throw new Error(msg);
        return;
    }
    if (!properties) {
        (_a = window.va) == null || _a.call(window, "event", {
            name: name2,
            options: options
        });
        return;
    }
    try {
        const props = $0dea53fbf8dad186$var$parseProperties(properties, {
            strip: $0dea53fbf8dad186$var$isProduction()
        });
        (_b = window.va) == null || _b.call(window, "event", {
            name: name2,
            data: props,
            options: options
        });
    } catch (err) {
        if (err instanceof Error && $0dea53fbf8dad186$var$isDevelopment()) console.error(err);
    }
}
function $0dea53fbf8dad186$export$b81f1580747d8b3a({ route: route, path: path }) {
    var _a;
    (_a = window.va) == null || _a.call(window, "pageview", {
        route: route,
        path: path
    });
}
var $0dea53fbf8dad186$export$2e2bcd8739ae039 = {
    inject: $0dea53fbf8dad186$export$a976684a0efeb93f,
    track: $0dea53fbf8dad186$export$6b2a7d5132615086,
    computeRoute: $0dea53fbf8dad186$export$c689ba62f1421710
};


(0, $8c2070529dc8eec8$export$1c787534cb11aa3e).init();
(0, $cb12b8b8642d52ce$export$8d3783709eddecb8)();
(0, $2bc8b61bc422460f$export$262288d7716e04c6)();
(0, $0dea53fbf8dad186$export$a976684a0efeb93f)();


//# sourceMappingURL=index.6e9d3d53.js.map
